// @ts-nocheck
import { MOCK, invalidateAndRefresh } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api, contentApi } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// __legacy_global_aliases__
// Resolve cross-module helpers via window (legacy SPA globals)
const landingPageIdForLandingPage = (...args: any[]) => (window as any).landingPageIdForLandingPage(...args);
const renderOpsModuleTabs = (...args: any[]) => (window as any).renderOpsModuleTabs(...args);
const renderOpsWorkflowHint = (...args: any[]) => (window as any).renderOpsWorkflowHint(...args);


// ============================================================
// 运营管理 · 模版库 / 分享卡片配置
// 模版库 = 落地页预制页面；分享卡片 = 社媒渠道内展示的信息结构样式
// ============================================================

window.Pages = window.Pages || {};

function escapeShareCardValue(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function getShareCardOgFormState() {
  window.shareCardOgFormState = {
    title: "",
    url: "",
    desc: "",
    site: "",
    imageUrl: "",
    imageDataUrl: "",
    imageFileName: "",
    imageWidth: 0,
    imageHeight: 0,
    imageMetaSource: "",
    imageMetaLoading: "",
    imageRatioWarnedSource: "",
    whatsappImageUrl: "",
    whatsappImageDataUrl: "",
    whatsappImageFileName: "",
    whatsappImageWidth: 0,
    whatsappImageHeight: 0,
    whatsappImageMetaSource: "",
    whatsappImageMetaLoading: "",
    discordPcImageUrl: "",
    discordPcImageDataUrl: "",
    discordPcImageFileName: "",
    discordPcImageWidth: 0,
    discordPcImageHeight: 0,
    discordPcImageMetaSource: "",
    discordPcImageMetaLoading: "",
    discordMobileImageUrl: "",
    discordMobileImageDataUrl: "",
    discordMobileImageFileName: "",
    discordMobileImageWidth: 0,
    discordMobileImageHeight: 0,
    discordMobileImageMetaSource: "",
    discordMobileImageMetaLoading: "",
    ...(window.shareCardOgFormState || {}),
  };
  if (window.shareCardOgImageDataUrl && !window.shareCardOgFormState.imageDataUrl) {
    window.shareCardOgFormState.imageDataUrl = window.shareCardOgImageDataUrl;
  }
  return window.shareCardOgFormState;
}

function saveShareCardOgFormState() {
  const state = getShareCardOgFormState();
  const getValue = (id, current) => document.getElementById(id)?.value ?? current;
  state.title = getValue("og-title-input", state.title);
  state.url = getValue("og-url-input", state.url);
  state.desc = getValue("og-desc-input", state.desc);
  state.site = getValue("og-site-input", state.site);
  state.imageUrl = getValue("og-image-url-input", state.imageUrl);
  state.whatsappImageUrl = getValue("whatsapp-image-url-input", state.whatsappImageUrl);
  state.discordPcImageUrl = getValue("discord-pc-image-url-input", state.discordPcImageUrl);
  state.discordMobileImageUrl = getValue("discord-mobile-image-url-input", state.discordMobileImageUrl);
  state.imageDataUrl = window.shareCardOgImageDataUrl || state.imageDataUrl || "";
  window.shareCardOgImageDataUrl = state.imageDataUrl;
  window.shareCardOgFormState = state;
  return state;
}

function getShareCardPostFormState() {
  window.shareCardPostFormState = {
    postCopy: "",
    commonImageAlt: "",
    publisherName: "Player",
    fbOgType: "website",
    twitterCreator: "",
    ...(window.shareCardPostFormState || {}),
  };
  return window.shareCardPostFormState;
}

function saveShareCardPostFormState() {
  const state = getShareCardPostFormState();
  const getValue = (id, current) => document.getElementById(id)?.value ?? current;
  state.postCopy = getValue("post-copy-input", state.postCopy);
  state.commonImageAlt = getValue("common-image-alt-input", state.commonImageAlt);
  state.publisherName = getValue("publisher-name-input", state.publisherName);
  state.fbOgType = "website";
  state.twitterCard = getValue("twitter-card-input", state.twitterCard);
  state.twitterSite = getValue("twitter-site-input", state.twitterSite);
  state.twitterCreator = getValue("twitter-creator-input", state.twitterCreator);
  state.twitterImageAlt = getValue("twitter-image-alt-input", state.twitterImageAlt);
  window.shareCardPostFormState = state;
  return state;
}

function getShareCardPostPreviewValues(previewState = null) {
  const ogState = previewState || getShareCardOgFormState();
  const postState = getShareCardPostFormState();
  return {
    postCopy: ogState.copy || postState.postCopy || "分享了一个游戏福利链接",
    commonImageAlt: postState.commonImageAlt || postState.fbImageAlt || ogState.title || "分享图说明",
    publisherName: postState.publisherName || "Player",
    fbOgType: "website",
    fbImageSize: "自动识别 / 建议 1200×630",
    fbImageAlt: postState.commonImageAlt || ogState.title || "分享图说明",
    twitterCard: "summary_large_image",
    twitterSite: ogState.site || "example.com",
    twitterCreator: "@user_social_name",
    twitterImageAlt: postState.commonImageAlt || ogState.title || "分享图说明",
  };
}

function getShareCardSpecialDraftState() {
  window.shareCardSpecialDraftState = {
    channel: "Discord",
    style: "Rich Embed",
    goal: "点击率",
    title: "",
    desc: "",
    imageUrl: "",
    imageDataUrl: "",
    imageFileName: "",
    botName: "Embed Bot",
    botAvatarUrl: "",
    botAvatarDataUrl: "",
    botAvatarFileName: "",
    appBadge: "APP",
    timestamp: "Today at 10:30 AM",
    authorIcon: "🌐",
    authorIconUrl: "",
    authorIconDataUrl: "",
    authorIconFileName: "",
    authorName: "example.dev",
    authorUrl: "",
    titleUrl: "",
    thumbnailUrl: "",
    fieldsText: "Author | Alex Developer\nCategory | Programming\nRead Time | 8 min read\nPublished | May 14, 2024",
    contentLine: "🚀 Learn how to create powerful bots that engage your community!",
    tagsText: "Discord, Bots, JavaScript, Node.js, Tutorial",
    footerIcon: "🔗",
    footerText: "https://example.dev/blog/discord-bot-guide",
    buttonsText: "Read Article | https://example.dev/blog/discord-bot-guide | Primary | ↗\nView on GitHub | https://github.com/example | Secondary | GitHub\nJoin Discussion | https://discord.gg/example | Secondary | 💬",
    reactionIcon: "🔥",
    reactionCount: "12",
    cta: "Read Article",
    color: "#5865F2",
    note: "",
    ...(window.shareCardSpecialDraftState || {}),
  };
  const allowedStyles = getShareCardSpecialStyles();
  if (!allowedStyles.some((style) => style.channel === window.shareCardSpecialDraftState.channel)) {
    window.shareCardSpecialDraftState.channel = allowedStyles[0]?.channel || "Discord";
    window.shareCardSpecialDraftState.style = allowedStyles[0]?.style || "Rich Embed";
  }
  return window.shareCardSpecialDraftState;
}

function saveShareCardSpecialDraftState() {
  const state = getShareCardSpecialDraftState();
  const getValue = (id, current) => document.getElementById(id)?.value ?? current;
  state.channel = getValue("special-channel-input", state.channel);
  state.style = getValue("special-style-input", state.style);
  state.goal = getValue("special-goal-input", state.goal);
  state.title = getValue("special-title-input", state.title);
  state.desc = getValue("special-desc-input", state.desc);
  state.imageUrl = getValue("special-image-url-input", state.imageUrl);
  state.botName = getValue("discord-bot-name-input", state.botName);
  state.botAvatarUrl = getValue("discord-bot-avatar-input", state.botAvatarUrl);
  state.authorIconUrl = getValue("discord-author-icon-url-input", state.authorIconUrl);
  state.authorName = getValue("discord-author-name-input", state.authorName);
  state.authorUrl = getValue("discord-author-url-input", state.authorUrl);
  state.titleUrl = getValue("discord-title-url-input", state.titleUrl);
  state.thumbnailUrl = getValue("discord-thumbnail-url-input", state.thumbnailUrl);
  state.fieldsText = getValue("discord-fields-input", state.fieldsText);
  state.contentLine = getValue("discord-content-line-input", state.contentLine);
  state.tagsText = getValue("discord-tags-input", state.tagsText);
  state.footerIconUrl = getValue("discord-footer-icon-url-input", state.footerIconUrl);
  state.footerText = getValue("discord-footer-text-input", state.footerText);
  state.buttonsText = getValue("discord-buttons-input", state.buttonsText);
  state.cta = getValue("special-cta-input", state.cta);
  state.color = getValue("special-color-input", state.color);
  state.note = getValue("special-note-input", state.note);
  window.shareCardSpecialDraftState = state;
  return state;
}

function getShareCardSpecialConfigs() {
  const allowedChannels = new Set(getShareCardSpecialStyles().map((style) => style.channel));
  window.shareCardSpecialConfigs = (window.shareCardSpecialConfigs || []).filter((config) => allowedChannels.has(config.channel));
  return window.shareCardSpecialConfigs;
}

function parseDiscordRows(value, fallback = []) {
  const rows = String(value || "").split("\n").map((row) => row.trim()).filter(Boolean);
  if (!rows.length) return fallback;
  return rows.map((row) => row.split("|").map((part) => part.trim()));
}

function parseDiscordTags(value) {
  return String(value || "").split(",").map((tag) => tag.trim()).filter(Boolean);
}

function getDiscordRuntimePreviewMeta() {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return {
    appBadge: "APP",
    timestamp: `Today at ${hours}:${minutes}`,
    reactionIcon: "🔥",
    reactionCount: "互动后生成",
  };
}

function renderRuntimeGeneratedField(label, value, desc) {
  return `
    <div class="rounded-lg border border-dashed border-amber-200 bg-amber-50/70 p-3">
      <div class="flex items-center justify-between gap-2">
        <span class="text-xs font-semibold text-ink-800">${label}</span>
        <span class="badge bg-amber-100 text-amber-700">不需配置</span>
      </div>
      <div class="mt-1 text-xs text-ink-700">预览值：<span class="font-mono">${escapeShareCardValue(value)}</span></div>
      <div class="mt-1 text-[11px] leading-relaxed text-ink-500">${desc}</div>
    </div>
  `;
}

function stripDiscordRuntimeOnlyFields(config) {
  const { appBadge, timestamp, reactionIcon, reactionCount, ...persistedConfig } = config;
  return persistedConfig;
}

function getSpecialPreviewValues(config = getShareCardSpecialDraftState()) {
  const og = getShareCardOgFormState();
  const specialStyles = getShareCardSpecialStyles();
  const style = specialStyles.find((s) => s.channel === config.channel) || specialStyles[0];
  const runtimeMeta = getDiscordRuntimePreviewMeta();
  return {
    ...config,
    appBadge: runtimeMeta.appBadge,
    timestamp: runtimeMeta.timestamp,
    reactionIcon: runtimeMeta.reactionIcon,
    reactionCount: runtimeMeta.reactionCount,
    icon: style?.icon || "✨",
    title: config.title || og.title || "Embed Title预览",
    desc: config.desc || og.desc || "Embed Description会在这里展示。",
    url: og.url || "https://example.com/share",
    site: og.site || "example.com",
    imageUrl: config.imageDataUrl || config.imageUrl || og.imageDataUrl || og.imageUrl || "",
    cta: config.cta || "立即查看",
    color: config.color || "#1E3A8A",
  };
}

function renderDiscordRichEmbedPreview(config, actions = "") {
  const v = getSpecialPreviewValues(config);
  const thumbnailUrl = v.thumbnailUrl || v.imageUrl || "";
  const fields = parseDiscordRows(v.fieldsText, [["Author", "Alex Developer"], ["Category", "Programming"], ["Read Time", "8 min read"], ["Published", "May 14, 2024"]]);
  const buttons = parseDiscordRows(v.buttonsText, [["Read Article", v.titleUrl || v.url, "Primary", "↗"], ["View on GitHub", "#", "Secondary", "GitHub"], ["Join Discussion", "#", "Secondary", "💬"]]);
  const tags = parseDiscordTags(v.tagsText || "Discord, Bots, JavaScript, Node.js, Tutorial");
  const botAvatarUrl = v.botAvatarDataUrl || v.botAvatarUrl || "";
  const botAvatar = botAvatarUrl
    ? `<img src="${escapeShareCardValue(botAvatarUrl)}" alt="Bot Avatar" class="w-full h-full object-cover" />`
    : `<span class="text-xl">🎮</span>`;
  const authorIconUrl = v.authorIconDataUrl || v.authorIconUrl || "";
  const authorIcon = authorIconUrl
    ? `<img src="${escapeShareCardValue(authorIconUrl)}" alt="Author Icon" class="w-4 h-4 rounded-full object-cover" />`
    : `<span>${escapeShareCardValue(v.authorIcon || "🌐")}</span>`;
  const footerIconUrl = v.footerIconDataUrl || v.footerIconUrl || "";
  const footerIcon = footerIconUrl
    ? `<img src="${escapeShareCardValue(footerIconUrl)}" alt="Footer Icon" class="w-4 h-4 rounded-full object-cover flex-shrink-0" />`
    : `<span>${escapeShareCardValue(v.footerIcon || "🔗")}</span>`;
  const thumbnail = thumbnailUrl
    ? `<img src="${escapeShareCardValue(thumbnailUrl)}" alt="Thumbnail" class="w-full h-full object-cover" />`
    : `<div class="w-full h-full bg-[#111827] flex items-center justify-center text-xs text-white/40">thumbnail</div>`;
  return `
    <div class="rounded-xl border border-[#1f2937] bg-[#111827] text-white overflow-hidden shadow-soft">
      <div class="p-4 bg-[#1b1d23]">
        <div class="flex items-center gap-3 mb-3">
          <div class="w-10 h-10 rounded-full bg-[#5865f2] overflow-hidden flex items-center justify-center flex-shrink-0">${botAvatar}</div>
          <div class="min-w-0 flex-1">
            <div class="flex items-center gap-2 text-sm"><span class="font-semibold truncate">${escapeShareCardValue(v.botName || "Embed Bot")}</span><span class="px-1.5 py-0.5 rounded bg-[#5865f2] text-[10px] font-bold">${escapeShareCardValue(v.appBadge || "APP")}</span><span class="text-xs text-white/45">${escapeShareCardValue(v.timestamp || "Today at 10:30 AM")}</span></div>
          </div>
        </div>
        <div class="rounded-lg bg-[#1f2229] border border-white/5 border-l-4 overflow-hidden" style="border-left-color:${escapeShareCardValue(v.color)}">
          <div class="p-4">
            <div class="flex gap-4 items-start">
              <div class="min-w-0 flex-1">
                <div class="text-xs text-white/55 flex items-center gap-2">${authorIcon}<span class="truncate">${escapeShareCardValue(v.authorName || v.site)}</span></div>
                <div class="mt-3 text-base font-semibold text-[#3ba4ff] leading-snug">${escapeShareCardValue(v.title)}</div>
                <div class="mt-2 text-sm text-white/75 leading-relaxed line-clamp-3">${escapeShareCardValue(v.desc)}</div>
              </div>
              <div class="w-28 aspect-[4/3] rounded-lg overflow-hidden bg-[#111827] border border-white/5 flex-shrink-0">${thumbnail}</div>
            </div>
            <div class="my-4 border-t border-white/10"></div>
            <div class="grid grid-cols-4 gap-3 text-xs">
              ${fields.slice(0, 4).map(([name, value]) => `<div><div class="font-semibold text-white/85">${escapeShareCardValue(name)}</div><div class="mt-1 text-white/55">${escapeShareCardValue(value || "-")}</div></div>`).join("")}
            </div>
            <div class="my-4 border-t border-white/10"></div>
            <div class="text-sm text-white/75 leading-relaxed">${escapeShareCardValue(v.contentLine || "🚀 Learn how to create powerful bots that engage your community!")}</div>
            <div class="mt-3 flex flex-wrap gap-2">${tags.map((tag) => `<span class="px-2 py-1 rounded bg-white/5 border border-white/5 text-xs text-white/65">${escapeShareCardValue(tag)}</span>`).join("")}</div>
            <div class="mt-4 flex items-center gap-2 text-xs text-white/45">${footerIcon}<span class="truncate">${escapeShareCardValue(v.footerText || v.url)}</span></div>
          </div>
        </div>
        <div class="mt-3 flex flex-wrap gap-3">
          ${buttons.slice(0, 3).map(([label, url, style, icon], index) => `<a href="javascript:void(0)" class="px-3 py-2 rounded-lg text-sm ${String(style || "").toLowerCase() === "primary" || index === 0 ? "bg-[#5865f2] text-white" : "bg-white/5 text-white/75"}">${escapeShareCardValue(icon || "")} ${escapeShareCardValue(label || "Button")}</a>`).join("")}
        </div>
        <div class="mt-3 inline-flex items-center gap-2 rounded-lg bg-white/5 px-3 py-1.5 text-sm text-white/70"><span>${escapeShareCardValue(v.reactionIcon || "🔥")}</span><span>${escapeShareCardValue(v.reactionCount || "12")}</span></div>
      </div>
      ${actions}
    </div>
  `;
}

function renderSpecialCardPreview(config, actions = "") {
  const v = getSpecialPreviewValues(config);
  if (v.channel === "Discord") return renderDiscordRichEmbedPreview(config, actions);
  const image = v.imageUrl
    ? `<img src="${escapeShareCardValue(v.imageUrl)}" alt="特殊渠道图片" class="w-full h-full object-cover" />`
    : `<div class="w-full h-full bg-ink-100 flex items-center justify-center text-xs text-ink-400">special:image</div>`;
  const isDiscord = v.channel === "Discord";
  const isSlack = v.channel === "Slack";
  const isTelegram = v.channel === "Telegram";
  const imageAspectClass = "aspect-[1200/630]";
  const shellBg = isDiscord ? "bg-[#313338]" : isSlack ? "bg-[#f7f7f7]" : isTelegram ? "bg-[#d7e8f7]" : "bg-[#efe7dc]";
  const textClass = isDiscord ? "text-white" : "text-ink-900";
  const subTextClass = isDiscord ? "text-white/60" : "text-ink-500";
  const isStructuredCard = isDiscord || isSlack;
  return `
    <div class="rounded-xl border border-ink-200 ${shellBg} overflow-hidden shadow-soft">
      <div class="px-3 py-2 bg-white/90 border-b border-ink-100 flex items-center justify-between">
        <span class="text-xs font-semibold text-ink-800">${v.icon} ${escapeShareCardValue(v.channel)}</span>
        <span class="text-[10px] text-ink-400">${escapeShareCardValue(v.goal)}</span>
      </div>
      <div class="p-3 min-h-[280px] flex flex-col justify-end">
        <div class="${isStructuredCard ? "max-w-[96%] border-l-4 rounded-lg" : "max-w-[86%] rounded-2xl rounded-bl-sm"} bg-white ${isDiscord ? "bg-[#2b2d31]" : ""} overflow-hidden shadow-soft border border-ink-100" style="${isStructuredCard ? `border-left-color:${escapeShareCardValue(v.color)}` : ""}">
          <div class="${imageAspectClass}">${image}</div>
          <div class="p-3">
            <div class="text-[10px] ${subTextClass} uppercase truncate">${escapeShareCardValue(v.site)}</div>
            <div class="text-sm font-semibold ${textClass} mt-1 line-clamp-2">${escapeShareCardValue(v.title)}</div>
            <div class="text-xs ${subTextClass} mt-1 leading-relaxed line-clamp-2">${escapeShareCardValue(v.desc)}</div>
            <div class="mt-3 flex items-center justify-between gap-2">
              <span class="text-[10px] font-mono ${subTextClass} truncate">${escapeShareCardValue(v.style)}</span>
              <span class="px-2 py-1 rounded text-[10px] text-white" style="background:${escapeShareCardValue(v.color)}">${escapeShareCardValue(v.cta)}</span>
            </div>
          </div>
        </div>
      </div>
      ${actions}
    </div>
  `;
}

function getShareCardPreviewImageHtml(state, emptyHtml) {
  const imageUrl = state.imageDataUrl || state.imageUrl || "";
  return imageUrl ? `<img src="${escapeShareCardValue(imageUrl)}" alt="分享卡片图片" class="w-full h-full object-cover" />` : emptyHtml;
}

function getShareCardPostChannelNames() {
  return ["Facebook", "Instagram", "Twitter / X"];
}

function getShareCardPostSpecs() {
  return {
    Facebook: {
      label: "Facebook Feed Link Preview",
      required: ["og:title", "og:type", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "og:image:alt"],
      image: "Feed 大图建议 1200×630，尺寸自动识别",
      tone: "#1877f2",
    },
    Instagram: {
      label: "Instagram Post / Story Link Preview",
      required: ["og:title", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "og:image:alt"],
      image: "常见为链接贴纸/站外预览，图片建议主体居中",
      tone: "#E1306C",
    },
    "Twitter / X": {
      label: "X Summary Card with Large Image",
      required: ["twitter:card", "twitter:title", "twitter:description", "twitter:image"],
      recommended: ["twitter:site", "twitter:creator", "twitter:image:alt"],
      image: "summary_large_image，建议 2:1，图片小于 5MB",
      tone: "#111827",
    },
    Threads: {
      label: "Threads Link Preview",
      required: ["og:title", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "og:image:alt"],
      image: "继承 Meta OG 预览，适合 1.91:1 横图",
      tone: "#111827",
    },
    TikTok: {
      label: "TikTok Post Link Preview",
      required: ["og:title", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "og:image:alt"],
      image: "分享贴文/简介链接预览，图片主体建议居中",
      tone: "#111827",
    },
    YouTube: {
      label: "YouTube Community Post Link Preview",
      required: ["og:title", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "og:image:alt"],
      image: "Community Post 链接预览，建议高清横图",
      tone: "#ff0000",
    },
    Reddit: {
      label: "Reddit Link Post Preview",
      required: ["og:title", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "og:image:alt"],
      image: "Link Post 缩略图/大图预览，标题权重较高",
      tone: "#ff4500",
    },
    Discord: {
      label: "Discord Channel Post Embed",
      required: ["og:title", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "theme-color"],
      image: "频道消息 Embed，可展示强调色与大图",
      tone: "#5865f2",
    },
    Telegram: {
      label: "Telegram Channel Post Preview",
      required: ["og:title", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "og:image:alt"],
      image: "频道/群发链接预览，依赖服务端抓取缓存",
      tone: "#229ed9",
    },
    Pinterest: {
      label: "Pinterest Pin Link Preview",
      required: ["og:title", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "og:image:alt"],
      image: "Pin 更偏图片消费，建议高质量封面图",
      tone: "#e60023",
    },
    VK: {
      label: "VK Wall Post Link Preview",
      required: ["og:title", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "og:image:alt"],
      image: "墙贴链接预览，基于 OG 字段抓取",
      tone: "#0077ff",
    },
    Snapchat: {
      label: "Snapchat Share / Story Preview",
      required: ["og:title", "og:url", "og:image"],
      recommended: ["og:description", "og:site_name", "og:image:alt"],
      image: "分享卡片/故事入口，建议视觉主体清晰",
      tone: "#fffc00",
    },
  };
}

function renderPostFieldBadges(fields, tone = "brand") {
  const toneClass = tone === "dark" ? "bg-ink-900 text-white" : "bg-brand-50 text-brand-700 border border-brand-100";
  return fields.map((field) => `<span class="px-1.5 py-0.5 rounded text-[9px] font-mono ${toneClass}">${field}</span>`).join("");
}

function renderFieldHelp(text) {
  return `<button type="button" data-help="${escapeShareCardValue(text)}" class="field-help-trigger inline-flex align-middle ml-1 w-4 h-4 rounded-full border border-ink-300 bg-white text-ink-400 text-[10px] leading-4 items-center justify-center cursor-help hover:border-brand-300 hover:text-brand-700">?</button>`;
}

function getOgPreviewRiskNotes(channel) {
  const riskMap = {
    LINE: ["OG 可生成基础链接预览，但方图/裁切效果需重点校验，建议主体居中并准备方图素材。"],
    Telegram: ["OG 可生成基础预览，但 Inline Keyboard、按钮和 Bot 消息结构需在第三步单独配置。"],
    Discord: ["OG 可生成基础预览，但 Theme / Accent Color、结构化字段与 Bot/Webhook Rich Embed 需在第三步单独配置；图片建议 PC 端 4:3、移动端 3:4。"],
    Slack: ["OG 可生成基础 unfurl，但 Block Kit、按钮和 App unfurl 不由 OG 完整控制，需在第三步单独配置。"],
  };
  return riskMap[channel] || [];
}

function renderOgPreviewRiskHint(channel) {
  const notes = getOgPreviewRiskNotes(channel);
  if (!notes.length) return "";
  return `
    <div class="px-3 pb-3">
      <div class="rounded-lg border border-amber-200 bg-amber-50 px-2.5 py-2 text-[10px] text-amber-800 leading-snug">
        <div class="font-semibold mb-1">OG 基础预览风险提示</div>
        ${notes.map((note) => `<div class="flex gap-1.5"><span>•</span><span>${escapeShareCardValue(note)}</span></div>`).join("")}
      </div>
    </div>
  `;
}

function truncateShareCardText(value, maxLength) {
  const text = String(value || "").trim();
  return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
}

function isNearAspectRatio(width, height, targetRatio, tolerance = 0.04) {
  if (!width || !height) return false;
  return Math.abs(width / height - targetRatio) <= tolerance;
}

function getShareCardBestImageSpec(channelKey) {
  const specs = {
    whatsapp: { channel: "WhatsApp", ratio: 1, ratioText: "1:1", recommend: "1200×1200" },
    discordPc: { channel: "Discord PC", ratio: 4 / 3, ratioText: "4:3", recommend: "1200×900" },
    discordMobile: { channel: "Discord 移动", ratio: 3 / 4, ratioText: "3:4", recommend: "900×1200" },
  };
  return specs[channelKey] || null;
}

function shouldDoubleCheckBestImage(channelKey, width, height) {
  const spec = getShareCardBestImageSpec(channelKey);
  if (!spec || !width || !height) return false;
  return !isNearAspectRatio(width, height, spec.ratio);
}

function showBestImageDoubleCheck(channelKey, width, height, fileName, onConfirm) {
  const spec = getShareCardBestImageSpec(channelKey);
  if (!spec || !window.UI?.confirmModal) {
    onConfirm();
    return;
  }
  const size = `${width}×${height}`;
  UI.confirmModal({
    title: "Double Check：图片尺寸不是最佳尺寸",
    content: `
      <div class="space-y-3">
        <div class="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-amber-800">
          当前上传图片 <b>${escapeShareCardValue(fileName)}</b> 尺寸为 <b>${size}</b>，不是 ${spec.channel} 的最佳尺寸。
        </div>
        <div>${spec.channel} 推荐使用 <b>${spec.ratioText}</b>（${spec.recommend}）。尺寸不匹配会影响卡片展示效果，可能降低点击与转化率。</div>
        <div class="text-ink-500">建议重新上传最佳尺寸素材；如需继续预览，可点击“继续使用”。</div>
      </div>
    `,
    confirmText: "继续使用",
    cancelText: "重新上传",
    onConfirm,
  });
}

function getShareCardChannelImageFields(channelKey) {
  const map = {
    whatsapp: {
      dataUrl: "whatsappImageDataUrl",
      url: "whatsappImageUrl",
      fileName: "whatsappImageFileName",
      width: "whatsappImageWidth",
      height: "whatsappImageHeight",
      metaSource: "whatsappImageMetaSource",
      metaLoading: "whatsappImageMetaLoading",
      fileInputId: "whatsapp-image-file",
      urlInputId: "whatsapp-image-url-input",
      previewId: "whatsapp-channel-image-preview",
      fileNameId: "whatsapp-image-file-name",
      label: "WhatsApp 独立图片",
    },
    discordPc: {
      dataUrl: "discordPcImageDataUrl",
      url: "discordPcImageUrl",
      fileName: "discordPcImageFileName",
      width: "discordPcImageWidth",
      height: "discordPcImageHeight",
      metaSource: "discordPcImageMetaSource",
      metaLoading: "discordPcImageMetaLoading",
      fileInputId: "discord-pc-image-file",
      urlInputId: "discord-pc-image-url-input",
      previewId: "discord-pc-channel-image-preview",
      fileNameId: "discord-pc-image-file-name",
      label: "Discord PC 独立图片",
    },
    discordMobile: {
      dataUrl: "discordMobileImageDataUrl",
      url: "discordMobileImageUrl",
      fileName: "discordMobileImageFileName",
      width: "discordMobileImageWidth",
      height: "discordMobileImageHeight",
      metaSource: "discordMobileImageMetaSource",
      metaLoading: "discordMobileImageMetaLoading",
      fileInputId: "discord-mobile-image-file",
      urlInputId: "discord-mobile-image-url-input",
      previewId: "discord-mobile-channel-image-preview",
      fileNameId: "discord-mobile-image-file-name",
      label: "Discord 移动独立图片",
    },
  };
  return map[channelKey];
}

function getImageSourceByFields(state, fields) {
  return fields ? (state[fields.dataUrl] || state[fields.url] || "") : "";
}

function getPreviewStateWithChannelImage(ogState, channelKey) {
  const fields = getShareCardChannelImageFields(channelKey);
  const source = getImageSourceByFields(ogState, fields);
  if (!fields || !source) return ogState;
  return {
    ...ogState,
    imageDataUrl: ogState[fields.dataUrl] || "",
    imageUrl: ogState[fields.url] || "",
    imageWidth: ogState[fields.width] || 0,
    imageHeight: ogState[fields.height] || 0,
  };
}

function getOgImageRatioTip(state) {
  const source = state.imageDataUrl || state.imageUrl || "";
  if (!source) return { type: "info", text: "标准上传图建议 1200×1200（1:1），WhatsApp 展示效果最佳。" };
  if (!state.imageWidth || !state.imageHeight) return { type: "info", text: "正在识别图片尺寸，标准推荐 1200×1200（1:1）。" };
  const size = `${state.imageWidth}×${state.imageHeight}`;
  if (isNearAspectRatio(state.imageWidth, state.imageHeight, 1)) return { type: "ok", text: `当前图片 ${size}，接近 1:1，显示效果较优。` };
  return { type: "warn", text: `当前图片 ${size} 不是 1:1，WhatsApp 显示效果不是最优，建议使用 1200×1200。` };
}

function renderOgImageRatioTip(state) {
  const tip = getOgImageRatioTip(state);
  const cls = tip.type === "warn"
    ? "border-amber-200 bg-amber-50 text-amber-800"
    : tip.type === "ok"
      ? "border-emerald-200 bg-emerald-50 text-emerald-800"
      : "border-ink-100 bg-ink-50 text-ink-500";
  return `<div class="rounded-lg border px-2.5 py-2 text-[11px] leading-relaxed ${cls}">${tip.text}</div>`;
}

function updateOgImageRatioTip(state) {
  const target = document.getElementById("og-image-ratio-tip");
  if (target) target.innerHTML = renderOgImageRatioTip(state);
}

function maybeWarnOgImageRatio(state, source) {
  if (!source || !state.imageWidth || !state.imageHeight || isNearAspectRatio(state.imageWidth, state.imageHeight, 1)) return;
  if (state.imageRatioWarnedSource === source) return;
  state.imageRatioWarnedSource = source;
  UI.toast("标准上传图建议使用 1200×1200（1:1）；当前图片尺寸显示效果不是最优。", "warning");
}

function syncImageDimensionsForFields(state, fields, options = {}) {
  const source = getImageSourceByFields(state, fields);
  if (!source) {
    state[fields.width] = 0;
    state[fields.height] = 0;
    state[fields.metaSource] = "";
    state[fields.metaLoading] = "";
    return;
  }
  if (state[fields.metaSource] === source && state[fields.width] && state[fields.height]) return;
  window.shareCardImageMetaCache = window.shareCardImageMetaCache || {};
  const cached = window.shareCardImageMetaCache[source];
  if (cached) {
    state[fields.width] = cached.width;
    state[fields.height] = cached.height;
    state[fields.metaSource] = source;
    state[fields.metaLoading] = "";
    if (options.warnIfNotSquare) maybeWarnOgImageRatio(state, source);
    return;
  }
  if (state[fields.metaLoading] === source) return;
  state[fields.metaLoading] = source;
  const img = new Image();
  img.onload = () => {
    const latest = getShareCardOgFormState();
    const latestSource = getImageSourceByFields(latest, fields);
    if (latestSource !== source) return;
    latest[fields.width] = img.naturalWidth || img.width || 0;
    latest[fields.height] = img.naturalHeight || img.height || 0;
    latest[fields.metaSource] = source;
    latest[fields.metaLoading] = "";
    window.shareCardImageMetaCache[source] = { width: latest[fields.width], height: latest[fields.height] };
    if (options.warnIfNotSquare) maybeWarnOgImageRatio(latest, source);
    window.shareCardOgFormState = latest;
    updateOgImageRatioTip(latest);
    const previewState = getActiveShareCardPreviewState(latest, getShareCardPostFormState());
    updateWhatsAppPreview(previewState);
    updateDiscordDevicePreviews(previewState);
  };
  img.onerror = () => {
    const latest = getShareCardOgFormState();
    if (getImageSourceByFields(latest, fields) === source) latest[fields.metaLoading] = "";
  };
  img.src = source;
}

function syncChannelImageDimensions(state, channelKey) {
  const fields = getShareCardChannelImageFields(channelKey);
  if (fields) syncImageDimensionsForFields(state, fields);
}

function renderChannelImageOverrideControls(channelKey, ogState, recommendText) {
  const fields = getShareCardChannelImageFields(channelKey);
  const source = getImageSourceByFields(ogState, fields);
  const fileName = ogState[fields.fileName] || "未上传独立图片";
  return `
    <div class="mt-3 rounded-lg border border-dashed border-brand-200 bg-white/70 p-2">
      <div class="mb-2 flex items-center justify-between gap-2">
        <span class="text-[11px] font-semibold text-ink-800">${fields.label}</span>
        <span class="badge bg-brand-50 text-brand-700">优先于基础图</span>
      </div>
      <div class="flex gap-2">
        <input id="${fields.fileInputId}" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleShareCardImageFile(this.files?.[0], '${channelKey}')" />
        <input id="${fields.urlInputId}" value="${escapeShareCardValue(ogState[fields.url] || "")}" oninput="updateOgCardPreviews()" placeholder="或填写该渠道图片 URL" class="min-w-0 flex-1 px-2 py-1.5 border border-ink-200 rounded text-[11px] font-mono" />
        <button type="button" onclick="document.getElementById('${fields.fileInputId}').click()" class="px-2 py-1.5 text-[11px] border border-ink-200 rounded hover:bg-ink-50">上传</button>
      </div>
      <div class="mt-1.5 flex items-center justify-between gap-2 text-[10px] text-ink-400">
        <span id="${fields.fileNameId}" class="truncate">${escapeShareCardValue(fileName)}</span>
        <span>${source ? "已启用独立图" : "未配置则继承基础图"}</span>
      </div>
      <div class="mt-1 text-[10px] text-ink-500">${recommendText}</div>
    </div>
  `;
}

function getWhatsAppPreviewValues() {
  return {
    hints: [
      "本原型统一采用 WhatsApp Rich Link Preview 进行预览。",
      "预览读取 og:title、og:description、og:url、og:image 与 og:site_name。",
      "已验证：WhatsApp 使用 1:1 正方形图片卡片呈现效果最好，建议优先准备 1200×1200。",
      "预览会根据图片实际宽高切换竖版大卡、横版大卡、正方形卡、小图卡、横幅卡或无图迷你卡。",
    ],
  };
}

function formatWhatsAppImageSize(ogState) {
  return ogState.imageWidth && ogState.imageHeight ? `${ogState.imageWidth} × ${ogState.imageHeight} 像素` : "等待图片尺寸识别";
}

function getWhatsAppImageVariant(ogState) {
  const imageUrl = ogState.imageDataUrl || ogState.imageUrl || "";
  if (!imageUrl) return { type: "text", label: "迷你卡片（无图）", size: "无图" };
  const width = Number(ogState.imageWidth || 0);
  const height = Number(ogState.imageHeight || 0);
  if (!width || !height) return { type: "horizontal", label: "Rich Link Preview", size: "识别图片尺寸中" };
  const ratio = width / height;
  if (width <= 500 || height <= 360) return { type: "small", label: "小卡片（小图）", size: formatWhatsAppImageSize(ogState) };
  if (ratio >= 3.2) return { type: "wide", label: "长条卡片（横幅）", size: formatWhatsAppImageSize(ogState) };
  if (ratio < 0.75) return { type: "portrait", label: "竖图卡片（非最优）", size: formatWhatsAppImageSize(ogState) };
  if (ratio >= 0.85 && ratio <= 1.2) return { type: "square", label: "推荐卡片（1:1 最佳）", size: formatWhatsAppImageSize(ogState) };
  return { type: "horizontal", label: "大卡片（横版）", size: formatWhatsAppImageSize(ogState) };
}

function renderWhatsAppReferenceImage() {
  return `
    <svg viewBox="0 0 1100 720" class="block w-full h-auto rounded-lg bg-[#fbfaf6]" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="WhatsApp Link Preview 尺寸参考图">
      <rect width="1100" height="720" fill="#fbfaf6"/>
      <text x="72" y="45" font-size="28" font-weight="700" fill="#1f2937">WhatsApp Link Preview</text>
      <text x="72" y="75" font-size="18" fill="#4b5563">不同尺寸的分享卡片效果展示</text>
      <text x="45" y="120" font-size="16" font-weight="700" fill="#d97706">竖图卡片（非最优）</text><text x="45" y="142" font-size="14" fill="#4b5563">1080 × 1920 像素</text>
      <rect x="45" y="155" width="250" height="455" rx="14" fill="#e2f7d6" stroke="#c8e7b8"/><rect x="60" y="170" width="220" height="295" rx="8" fill="#9cc7d6"/><text x="60" y="495" font-size="15" font-weight="700" fill="#111827">Exploring the Swiss Alps</text><text x="60" y="525" font-size="13" fill="#4b5563">Discover the most beautiful hiking routes...</text><text x="60" y="570" font-size="12" fill="#6b7280">example.com</text>
      <text x="360" y="120" font-size="16" font-weight="700" fill="#16a34a">大卡片（横版）</text><text x="360" y="142" font-size="14" fill="#4b5563">1200 × 630 像素</text>
      <rect x="360" y="155" width="430" height="178" rx="14" fill="#e2f7d6" stroke="#c8e7b8"/><rect x="375" y="170" width="225" height="135" rx="6" fill="#1f6f78"/><text x="615" y="198" font-size="14" font-weight="700" fill="#111827">Northern Lights in Iceland</text><text x="615" y="230" font-size="12" fill="#4b5563">Everything you need to know...</text><text x="615" y="285" font-size="11" fill="#6b7280">example.com</text>
      <text x="815" y="120" font-size="16" font-weight="700" fill="#16a34a">推荐卡片（1:1 最佳）</text><text x="815" y="142" font-size="14" fill="#4b5563">1200 × 1200 像素</text>
      <rect x="815" y="155" width="220" height="278" rx="14" fill="#e2f7d6" stroke="#c8e7b8"/><rect x="830" y="170" width="190" height="150" rx="7" fill="#c58b47"/><text x="830" y="345" font-size="14" font-weight="700" fill="#111827">The 10 Best Coffee Shops</text><text x="830" y="380" font-size="12" fill="#4b5563">A curated list for every coffee lover.</text>
      <text x="320" y="390" font-size="16" font-weight="700" fill="#16a34a">小卡片（小图）</text><text x="320" y="412" font-size="14" fill="#4b5563">400 × 300 像素</text>
      <rect x="320" y="425" width="240" height="88" rx="12" fill="#e2f7d6" stroke="#c8e7b8"/><rect x="335" y="440" width="68" height="58" rx="6" fill="#6366f1"/><text x="415" y="456" font-size="12" font-weight="700" fill="#111827">New Smartphone</text><text x="415" y="480" font-size="10" fill="#4b5563">Review: Is it worth it?</text>
      <text x="590" y="390" font-size="16" font-weight="700" fill="#16a34a">长条卡片（横幅）</text><text x="590" y="412" font-size="14" fill="#4b5563">1200 × 300 像素</text>
      <rect x="590" y="425" width="365" height="88" rx="12" fill="#e2f7d6" stroke="#c8e7b8"/><rect x="605" y="440" width="155" height="58" rx="6" fill="#111827"/><text x="775" y="458" font-size="13" font-weight="700" fill="#111827">Black Friday Sale 2024</text><text x="775" y="482" font-size="11" fill="#4b5563">Up to 50% off selected items.</text>
      <text x="320" y="565" font-size="16" font-weight="700" fill="#16a34a">迷你卡片（无图）</text>
      <rect x="320" y="580" width="305" height="66" rx="12" fill="#e2f7d6" stroke="#c8e7b8"/><text x="335" y="604" font-size="13" font-weight="700" fill="#111827">Minimalist Living: 10 Tips</text><text x="335" y="628" font-size="11" fill="#4b5563">Learn how to live with less...</text>
      <rect x="685" y="585" width="350" height="72" rx="8" fill="#fff" stroke="#d1d5db"/><text x="705" y="612" font-size="13" font-weight="700" fill="#374151">说明</text><text x="705" y="635" font-size="11" fill="#4b5563">WhatsApp 会根据图片尺寸自动调整；验证后 1:1 效果最好。</text>
    </svg>
  `;
}

function renderWhatsAppReferenceHover() {
  return `
    <div class="relative group">
      <button type="button" class="px-2 py-1 rounded-lg border border-brand-100 bg-white text-[10px] text-brand-700 hover:bg-brand-50">尺寸参考</button>
      <div class="hidden group-hover:block fixed left-1/2 top-24 z-[9999] w-[760px] max-w-[calc(100vw-48px)] max-h-[calc(100vh-140px)] -translate-x-1/2 overflow-auto rounded-2xl border border-ink-200 bg-white p-3 shadow-pop">
        <div class="mb-2 flex items-center justify-between gap-3">
          <div>
            <div class="text-sm font-semibold text-ink-900">WhatsApp Link Preview 尺寸参考</div>
            <div class="text-[11px] text-ink-500">鼠标移开后关闭；浮层固定在页面中部，避免被预览卡片裁切。</div>
          </div>
          <span class="badge bg-ok-50 text-ok-700">尺寸参考</span>
        </div>
        ${renderWhatsAppReferenceImage()}
      </div>
    </div>
  `;
}

function renderWhatsAppImageTag(imageUrl, alt = "WhatsApp 分享预览图") {
  return `<img src="${escapeShareCardValue(imageUrl)}" alt="${alt}" class="w-full h-full object-cover" />`;
}

function renderWhatsAppTextBlock(ogState, compact = false) {
  return `
    <div class="${compact ? "p-2 min-w-0 flex-1" : "p-2"}">
      <div class="og-preview-title text-xs font-semibold text-ink-900 line-clamp-2">${escapeShareCardValue(ogState.title || "分享标题预览")}</div>
      <div class="og-preview-desc text-[11px] text-ink-500 mt-1 line-clamp-2">${escapeShareCardValue(ogState.desc || "分享描述会在这里展示。")}</div>
      <div class="og-preview-site text-[10px] text-ink-400 mt-1 uppercase truncate">${escapeShareCardValue(ogState.site || "example.com")}</div>
    </div>
  `;
}

function renderWhatsAppRichPreviewShell(ogState) {
  const imageUrl = ogState.imageDataUrl || ogState.imageUrl || "";
  const variant = getWhatsAppImageVariant(ogState);
  const meta = `<div class="mb-2 flex items-center justify-between gap-2 text-[10px]"><span class="font-semibold text-ok-700">${escapeShareCardValue(variant.label)}</span><span class="text-ink-400">${escapeShareCardValue(variant.size)}</span></div>`;
  if (variant.type === "text") {
    return `<div class="max-w-[92%] rounded-2xl rounded-bl-sm bg-[#dcf8c6] p-2 shadow-soft">${meta}<div class="rounded-lg bg-white border border-ink-100">${renderWhatsAppTextBlock(ogState)}</div><div class="mt-1 text-right text-[10px] text-ink-400">11:30 AM ✓✓</div></div>`;
  }
  if (variant.type === "portrait") {
    const portraitMeta = `<div class="mb-2 flex items-center justify-between gap-2 text-[10px]"><span class="font-semibold text-amber-700">${escapeShareCardValue(variant.label)}</span><span class="text-ink-400">${escapeShareCardValue(variant.size)}</span></div>`;
    return `<div class="max-w-[235px] rounded-2xl rounded-bl-sm bg-[#dcf8c6] p-2 shadow-soft opacity-90">${portraitMeta}<div class="rounded-lg bg-white overflow-hidden border border-amber-200"><div class="aspect-square bg-ink-100 overflow-hidden">${renderWhatsAppImageTag(imageUrl)}</div>${renderWhatsAppTextBlock(ogState)}</div><div class="mt-1 rounded bg-amber-50 px-2 py-1 text-[10px] text-amber-700">9:16 会被裁切/压缩，建议改用 1:1。</div><div class="mt-1 text-right text-[10px] text-ink-400">11:30 AM ✓✓</div></div>`;
  }
  if (variant.type === "square") {
    return `<div class="max-w-[310px] rounded-2xl rounded-bl-sm bg-[#dcf8c6] p-2 shadow-pop ring-2 ring-emerald-300/70">${meta}<div class="rounded-lg bg-white overflow-hidden border border-emerald-200"><div class="aspect-square bg-ink-100 overflow-hidden">${renderWhatsAppImageTag(imageUrl)}</div>${renderWhatsAppTextBlock(ogState)}</div><div class="mt-1 rounded bg-emerald-50 px-2 py-1 text-[10px] font-medium text-emerald-700">1:1 正方形图片为最佳展示效果。</div><div class="mt-1 text-right text-[10px] text-ink-400">11:30 AM ✓✓</div></div>`;
  }
  if (variant.type === "small") {
    return `<div class="max-w-[310px] rounded-2xl rounded-bl-sm bg-[#dcf8c6] p-2 shadow-soft">${meta}<div class="rounded-lg bg-white overflow-hidden border border-ink-100 flex"><div class="w-20 h-20 flex-shrink-0 bg-ink-100 overflow-hidden">${renderWhatsAppImageTag(imageUrl)}</div>${renderWhatsAppTextBlock(ogState, true)}</div><div class="mt-1 text-right text-[10px] text-ink-400">11:30 AM ✓✓</div></div>`;
  }
  if (variant.type === "wide") {
    return `<div class="max-w-[390px] rounded-2xl rounded-bl-sm bg-[#dcf8c6] p-2 shadow-soft">${meta}<div class="rounded-lg bg-white overflow-hidden border border-ink-100 flex"><div class="w-44 h-20 flex-shrink-0 bg-ink-100 overflow-hidden">${renderWhatsAppImageTag(imageUrl)}</div>${renderWhatsAppTextBlock(ogState, true)}</div><div class="mt-1 text-right text-[10px] text-ink-400">11:30 AM ✓✓</div></div>`;
  }
  return `<div class="max-w-[430px] rounded-2xl rounded-bl-sm bg-[#dcf8c6] p-2 shadow-soft">${meta}<div class="rounded-lg bg-white overflow-hidden border border-ink-100 flex"><div class="w-[54%] aspect-[1200/630] flex-shrink-0 bg-ink-100 overflow-hidden">${renderWhatsAppImageTag(imageUrl)}</div>${renderWhatsAppTextBlock(ogState, true)}</div><div class="mt-1 text-right text-[10px] text-ink-400">11:30 AM ✓✓</div></div>`;
}

function renderWhatsAppPreview(ogState, options = {}) {
  const useChannelImage = options.useChannelImage !== false;
  const showOverrideControls = options.showOverrideControls !== false;
  const previewState = useChannelImage ? getPreviewStateWithChannelImage(ogState, "whatsapp") : ogState;
  return `
    <div class="whatsapp-preview-card rounded-xl border border-brand-200 bg-[#efe7dc] overflow-visible shadow-soft">
      <div class="px-3 py-2 bg-brand-50/95 border-b border-brand-100 flex items-center justify-between gap-2">
        <span class="text-xs font-semibold text-brand-900">📱 WhatsApp</span>
        <div class="flex items-center gap-2">
          ${renderWhatsAppReferenceHover()}
          <span class="whatsapp-preview-mode badge bg-ok-50 text-ok-700">Rich Link Preview</span>
        </div>
      </div>
      <div class="p-3 min-h-[300px] flex flex-col justify-end overflow-visible">
        <div class="text-[10px] text-center text-ink-400 mb-3">Today</div>
        <div class="whatsapp-rich-preview-shell overflow-visible" data-use-channel-image="${useChannelImage ? "1" : "0"}">${renderWhatsAppRichPreviewShell(previewState)}</div>
        ${showOverrideControls ? renderChannelImageOverrideControls("whatsapp", ogState, "推荐 1:1（1200×1200），该图片只用于 WhatsApp，调用优先级高于基础 og:image。") : ""}
      </div>
    </div>
  `;
}

function renderDiscordDevicePreviewShell(ogState, device = "pc", options = {}) {
  const isPc = device === "pc";
  const channelKey = isPc ? "discordPc" : "discordMobile";
  const useChannelImage = options.useChannelImage !== false;
  const previewState = useChannelImage ? getPreviewStateWithChannelImage(ogState, channelKey) : ogState;
  const imageUrl = previewState.imageDataUrl || previewState.imageUrl || "";
  const title = previewState.title || "分享标题预览";
  const desc = previewState.desc || "分享描述会在这里展示。";
  const site = previewState.site || "example.com";
  const url = previewState.url || "https://example.com/share";
  const imageHtml = imageUrl
    ? `<img src="${escapeShareCardValue(imageUrl)}" alt="Discord ${isPc ? "PC" : "移动"} 分享图" class="w-full h-full object-cover" />`
    : `<div class="w-full h-full bg-[#111827] flex items-center justify-center text-xs text-white/35">${isPc ? "4:3" : "3:4"}</div>`;
  if (!isPc) {
    return `
      <div class="mx-auto w-[220px] rounded-[26px] border border-[#1f2937] bg-[#111827] p-3 text-white shadow-soft">
        <div class="mb-2 flex items-center gap-2 text-[11px] text-white/55"><span class="w-2 h-2 rounded-full bg-[#5865f2]"></span><span>Discord Mobile</span></div>
        <div class="rounded-xl bg-[#1f2229] border border-white/5 border-l-4 border-l-[#5865f2] overflow-hidden">
          <div class="aspect-[3/4] bg-[#111827]">${imageHtml}</div>
          <div class="p-3">
            <div class="text-[10px] text-white/45 uppercase truncate">${escapeShareCardValue(site)}</div>
            <div class="mt-1 text-sm font-semibold text-[#3ba4ff] line-clamp-2">${escapeShareCardValue(title)}</div>
            <div class="mt-1 text-xs text-white/65 line-clamp-3">${escapeShareCardValue(desc)}</div>
            <div class="mt-2 text-[10px] text-white/40 truncate">${escapeShareCardValue(url)}</div>
          </div>
        </div>
      </div>
    `;
  }
  return `
    <div class="rounded-xl border border-[#1f2937] bg-[#111827] p-3 text-white shadow-soft">
      <div class="mb-2 flex items-center justify-between gap-2 text-xs"><span class="font-semibold">🎮 Discord PC</span><span class="text-white/45">4:3 推荐</span></div>
      <div class="rounded-lg bg-[#1f2229] border border-white/5 border-l-4 border-l-[#5865f2] overflow-hidden">
        <div class="flex gap-3 p-3">
          <div class="min-w-0 flex-1">
            <div class="text-[10px] text-white/45 uppercase truncate">${escapeShareCardValue(site)}</div>
            <div class="mt-1 text-sm font-semibold text-[#3ba4ff] line-clamp-2">${escapeShareCardValue(title)}</div>
            <div class="mt-1 text-xs text-white/65 line-clamp-3">${escapeShareCardValue(desc)}</div>
            <div class="mt-2 text-[10px] text-white/40 truncate">${escapeShareCardValue(url)}</div>
          </div>
          <div class="w-28 aspect-[4/3] rounded-lg overflow-hidden bg-[#111827] border border-white/5 flex-shrink-0">${imageHtml}</div>
        </div>
      </div>
    </div>
  `;
}

function renderDiscordDevicePreview(ogState, device = "pc", options = {}) {
  const isPc = device === "pc";
  const channelKey = isPc ? "discordPc" : "discordMobile";
  const useChannelImage = options.useChannelImage !== false;
  const showOverrideControls = options.showOverrideControls !== false;
  return `
    <div id="discord-${isPc ? "pc" : "mobile"}-preview-card" class="rounded-xl border border-ink-200 bg-white overflow-hidden shadow-soft">
      <div class="px-3 py-2 border-b border-ink-100 bg-white/80 flex items-center justify-between">
        <span class="text-xs font-semibold text-ink-700">🎮 Discord ${isPc ? "PC" : "移动"}</span>
        <span class="text-[10px] text-ink-400">${isPc ? "PC 4:3" : "移动 3:4"}</span>
      </div>
      <div class="p-3 min-h-[300px] bg-[#eef0ff]">
        <div class="discord-${isPc ? "pc" : "mobile"}-preview-shell" data-use-channel-image="${useChannelImage ? "1" : "0"}">${renderDiscordDevicePreviewShell(ogState, device, { useChannelImage })}</div>
        ${showOverrideControls ? renderChannelImageOverrideControls(channelKey, ogState, `${isPc ? "推荐 4:3（如 1200×900）" : "推荐 3:4（如 900×1200）"}，该图片只用于 Discord ${isPc ? "PC" : "移动端"}，调用优先级高于基础 og:image。`) : ""}
      </div>
      ${renderOgPreviewRiskHint("Discord")}
    </div>
  `;
}

function updateDiscordDevicePreviews(ogState = getShareCardOgFormState()) {
  document.querySelectorAll(".discord-pc-preview-shell").forEach((shell) => {
    shell.innerHTML = renderDiscordDevicePreviewShell(ogState, "pc", { useChannelImage: shell.dataset.useChannelImage !== "0" });
  });
  document.querySelectorAll(".discord-mobile-preview-shell").forEach((shell) => {
    shell.innerHTML = renderDiscordDevicePreviewShell(ogState, "mobile", { useChannelImage: shell.dataset.useChannelImage !== "0" });
  });
}

function syncOgImageDimensions(state) {
  syncImageDimensionsForFields(state, {
    dataUrl: "imageDataUrl",
    url: "imageUrl",
    width: "imageWidth",
    height: "imageHeight",
    metaSource: "imageMetaSource",
    metaLoading: "imageMetaLoading",
  }, { warnIfNotSquare: true });
}

function renderPostFieldGuide(styles) {
  const specs = getShareCardPostSpecs();
  return styles.map((s) => {
    const spec = specs[s.channel];
    if (!spec) return "";
    return `
      <div class="rounded-xl border border-ink-100 bg-white p-3">
        <div class="flex items-center justify-between gap-2">
          <div class="text-xs font-semibold text-ink-900">${s.icon} ${spec.label}</div>
          <span class="text-[10px] text-ink-400">${spec.image}</span>
        </div>
        <div class="mt-2 text-[10px] text-ink-500">必要字段</div>
        <div class="mt-1 flex flex-wrap gap-1">${renderPostFieldBadges(spec.required, "dark")}</div>
        <div class="mt-2 text-[10px] text-ink-500">推荐补充</div>
        <div class="mt-1 flex flex-wrap gap-1">${renderPostFieldBadges(spec.recommended)}</div>
      </div>
    `;
  }).join("");
}

function renderShareCardWorkflowSteps(activeStep) {
  const steps = [
    { key: "og", no: "01", title: "私聊/群聊标准卡片", desc: "必做：仅配置 OG 标准字段与基础图", badge: "必做", badgeClass: "bg-danger-50 text-danger-700" },
    { key: "best", no: "02", title: "最佳效果卡片", desc: "强烈建议：配置 WhatsApp / Discord 独立图片", badge: "强烈建议", badgeClass: "bg-amber-50 text-amber-700" },
    { key: "post", no: "03", title: "Post标准卡片", desc: "可选：补充 Post 分享公共字段与预览", badge: "可选", badgeClass: "bg-ink-100 text-ink-600", beta: true },
  ];
  return `
    <div class="card p-2 mb-5 grid grid-cols-3 gap-2">
      ${steps.map((step) => {
        const active = step.key === activeStep;
        return `
          <button onclick="goShareCardStep('${step.key}')" class="px-4 py-3 rounded-lg text-left transition ${active ? "bg-brand-900 text-white" : "bg-white text-ink-600 hover:bg-ink-50 border border-ink-100"}">
            <div class="flex items-center justify-between gap-2">
              <span class="text-xs font-semibold opacity-70">${step.no}</span>
              <span class="badge ${active ? "bg-white/15 text-white" : step.badgeClass}">${step.badge}</span>
            </div>
            <div class="mt-1 flex items-center gap-2 text-sm font-semibold">
              <span>${step.title}</span>
              ${step.beta ? `<span class="badge bg-amber-50 text-amber-700">Beta</span>` : ""}
            </div>
            <div class="text-[11px] mt-0.5 opacity-70">${step.desc}</div>
          </button>
        `;
      }).join("")}
    </div>
  `;
}

function getShareCardSpecialStyles() {
  const order = ["Discord", "Slack", "Telegram"];
  const styles = getShareCardStyles();
  return order.map((channel) => styles.find((s) => s.channel === channel)).filter(Boolean);
}

function getShareCardStyles() {
  return [
    { id: "card_facebook_large", channel: "Facebook", icon: "📘", style: "Feed Link Preview", fields: ["og:title", "og:type", "og:url", "og:image", "og:description", "og:site_name", "og:image:alt"], limits: "标题 60 字符，描述 110 字符，图片 1200×630（1.91:1）", usage: "Facebook Feed / Post 链接预览", status: "active" },
    { id: "card_instagram_post", channel: "Instagram", icon: "📷", style: "Post / Story Link Preview", fields: ["og:title", "og:url", "og:image", "og:description"], limits: "图片主体居中，Story/贴纸场景可能裁剪", usage: "Instagram Post / Story", status: "active" },
    { id: "card_x_summary", channel: "Twitter / X", icon: "𝕏", style: "Summary Card with Large Image", fields: ["twitter:card", "twitter:title", "twitter:description", "twitter:image", "twitter:site", "twitter:creator", "twitter:image:alt"], limits: "标题 70 字符，描述 200 字符，图片 2:1", usage: "X Post 时间线卡片", status: "active" },
    { id: "card_whatsapp_rich", channel: "WhatsApp", icon: "📱", style: "Rich Link Preview", fields: ["og:title", "og:description", "og:image", "og:url", "og:site_name"], limits: "统一按 Rich Link Preview 预览；验证后 1:1 正方形图片效果最佳，建议 1200×1200", usage: "WhatsApp 私聊 / 群聊链接预览", status: "active" },
    { id: "card_line_square", channel: "LINE", icon: "🟢", style: "方图消息卡片", fields: ["title", "description", "image", "url"], limits: "标题建议 40 字内，图片建议 1040×1040 方图", usage: "LINE 聊天 / 群分享", status: "active" },
    { id: "card_telegram_inline", channel: "Telegram", icon: "✈️", style: "Telegram Inline", fields: ["title", "description", "image", "url", "button_text"], limits: "Inline Keyboard / Bot 消息支持按钮与结构化动作，普通 OG 预览依赖服务端缓存", usage: "Bot Inline / Channel 消息增强卡片", status: "active" },
    { id: "card_discord_rich", channel: "Discord", icon: "🎮", style: "Rich Embed", fields: ["title", "description", "image", "site_name", "color"], limits: "PC 建议 4:3，移动端建议 3:4，可按端分别准备素材", usage: "服务器频道 / Post 分享", status: "active" },
    { id: "card_signal_private", channel: "Signal", icon: "🔵", style: "隐私聊天链接卡片", fields: ["title", "description", "image", "url"], limits: "隐私保护强，预览依赖基础 OG 字段", usage: "私聊 / 群聊预览", status: "active" },
    { id: "card_viber_chat", channel: "Viber", icon: "🟣", style: "聊天气泡链接卡片", fields: ["title", "description", "image", "url"], limits: "描述不宜过长，图片建议 1200×630", usage: "私聊 / 群聊预览", status: "active" },
    { id: "card_slack_block", channel: "Slack", icon: "💬", style: "Slack Block Kit", fields: ["title", "description", "image", "url", "button_text", "blocks"], limits: "Block Kit 支持 section、image、actions 等结构化消息", usage: "Slack 频道 / App unfurl 增强卡片", status: "active" },
    { id: "card_imessage_preview", channel: "iMessage", icon: "💬", style: "iOS 链接预览", fields: ["title", "description", "image", "url"], limits: "iOS 生态预览，建议高清 1200×630", usage: "iMessage 私聊预览", status: "active" },
    { id: "card_imo_basic", channel: "imo", icon: "🟦", style: "基础 OG 链接预览", fields: ["title", "description", "image", "url"], limits: "基础 OG Preview，建议图片 1200×630", usage: "私聊 / 群聊预览", status: "testing" },
  ];
}

function renderOgChannelPreview(s) {
  const imagePlaceholder = `<div class="og-preview-image w-full h-full min-h-0 bg-ink-100 flex items-center justify-center text-xs text-ink-400 overflow-hidden">${s.limits.match(/\d+×\d+/)?.[0] || "og:image"}</div>`;
  const header = `
    <div class="px-3 py-2 border-b border-ink-100 bg-white/80 flex items-center justify-between">
      <span class="text-xs font-semibold text-ink-700">${s.icon} ${s.channel}</span>
      <span class="text-[10px] text-ink-400">私聊 / 群聊</span>
    </div>
  `;
  const riskHint = renderOgPreviewRiskHint(s.channel);
  if (s.channel === "WhatsApp") {
    return `
      <div class="rounded-xl border border-ink-200 bg-[#efe7dc] overflow-hidden shadow-soft">
        ${header}
        <div class="p-3 min-h-[180px] flex flex-col justify-end">
          <div class="text-[10px] text-center text-ink-400 mb-3">Today</div>
          <div class="max-w-[88%] rounded-2xl rounded-bl-sm bg-white p-2 shadow-soft">
            <div class="rounded-lg bg-white overflow-hidden flex border border-ink-100">
              <div class="w-24 h-24 flex-shrink-0">${imagePlaceholder}</div>
              <div class="p-2 min-w-0 flex-1">
                <div class="og-preview-title text-xs font-semibold text-ink-900 line-clamp-2">分享标题预览</div>
                <div class="og-preview-desc text-[11px] text-ink-500 mt-1 line-clamp-2">分享描述会在这里展示。</div>
                <div class="og-preview-site text-[10px] text-ink-400 mt-1 uppercase truncate">example.com</div>
              </div>
            </div>
          </div>
        </div>
        ${riskHint}
      </div>
    `;
  }
  if (s.channel === "LINE") {
    return `
      <div class="rounded-xl border border-ink-200 bg-[#dcebd2] overflow-hidden shadow-soft">
        ${header}
        <div class="p-3 min-h-[260px] flex flex-col justify-end">
          <div class="max-w-[76%] rounded-2xl rounded-bl-sm bg-white p-2 shadow-soft">
            <div class="rounded-lg bg-white overflow-hidden border border-ink-100">
              <div class="aspect-square">${imagePlaceholder}</div>
              <div class="p-2">
                <div class="og-preview-title text-xs font-semibold text-ink-900 line-clamp-1">分享标题预览</div>
                <div class="og-preview-desc text-[11px] text-ink-500 mt-1 line-clamp-1">分享描述会在这里展示。</div>
              </div>
            </div>
          </div>
        </div>
        ${riskHint}
      </div>
    `;
  }
  if (s.channel === "Twitter / X") {
    return `
      <div class="rounded-xl border border-ink-200 bg-white overflow-hidden shadow-soft">
        ${header}
        <div class="p-3 min-h-[230px] bg-ink-50">
          <div class="flex gap-2 mb-3">
            <div class="w-8 h-8 rounded-full bg-ink-900 text-white flex items-center justify-center text-xs">U</div>
            <div class="flex-1">
              <div class="text-xs font-semibold text-ink-900">Player</div>
              <div class="text-[11px] text-ink-500">分享了一个链接</div>
            </div>
          </div>
          <div class="rounded-2xl border border-ink-200 bg-white overflow-hidden">
            <div class="aspect-[1200/628]">${imagePlaceholder}</div>
            <div class="p-3">
              <div class="og-preview-title text-sm font-semibold text-ink-900 line-clamp-1">分享标题预览</div>
              <div class="og-preview-desc text-xs text-ink-500 mt-1 line-clamp-2">分享描述会在这里展示。</div>
              <div class="og-preview-url text-xs text-ink-400 mt-1 truncate">https://example.com/share</div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
  const bgMap = {
    Telegram: "bg-[#d7e8f7]",
    Discord: "bg-[#eef0ff]",
    Signal: "bg-[#e8f1ff]",
    Viber: "bg-[#f2eaff]",
    Slack: "bg-[#f7f7f7]",
    iMessage: "bg-[#eaf4ff]",
    imo: "bg-[#eef6ff]",
  };
  const bubbleClass = s.channel === "Slack" ? "max-w-[92%] rounded-lg border-l-4 border-[#4A154B]" : "max-w-[86%] rounded-2xl rounded-bl-sm";
  return `
    <div class="rounded-xl border border-ink-200 bg-white overflow-hidden shadow-soft">
      ${header}
      <div class="p-3 min-h-[230px] ${bgMap[s.channel] || "bg-ink-50"} flex flex-col justify-end">
        <div class="${bubbleClass} bg-white overflow-hidden shadow-soft border border-ink-100">
          <div class="aspect-[1200/630]">${imagePlaceholder}</div>
          <div class="p-3">
            <div class="og-preview-site text-[10px] text-ink-400 uppercase truncate">example.com</div>
            <div class="og-preview-title text-xs font-semibold text-ink-900 mt-1 line-clamp-1">分享标题预览</div>
            <div class="og-preview-desc text-[11px] text-ink-500 mt-1 leading-relaxed line-clamp-2">分享描述会在这里展示。</div>
            <div class="og-preview-url text-[10px] text-brand-700 mt-2 font-mono truncate">https://example.com/share</div>
          </div>
        </div>
      </div>
      ${riskHint}
    </div>
  `;
}

function renderOgPostPreview(s, values = getShareCardPostPreviewValues()) {
  const specs = getShareCardPostSpecs();
  const spec = specs[s.channel];
  const tone = spec?.tone || "#1877f2";
  const badgeTextColor = s.channel === "Snapchat" ? "#111827" : "#fff";
  const imagePlaceholder = `<div class="og-preview-image w-full h-full min-h-0 bg-ink-100 flex items-center justify-center text-xs text-ink-400 overflow-hidden">${s.channel === "Twitter / X" ? "2:1" : "1200×630"}</div>`;
  if (s.channel === "Twitter / X") {
    return `
      <div class="rounded-2xl border border-[#cfd9de] bg-white overflow-hidden shadow-soft">
        <div class="px-3 py-2 border-b border-[#eff3f4] flex items-center justify-between bg-white">
          <span class="text-xs font-semibold text-ink-900">${s.icon} X Post</span>
          <span class="twitter-preview-card px-1.5 py-0.5 rounded bg-ink-900 text-white text-[9px] font-mono">${escapeShareCardValue(values.twitterCard)}</span>
        </div>
        <div class="p-4 bg-white min-h-[390px]">
          <div class="flex gap-3">
            <div class="w-10 h-10 rounded-full bg-ink-900 text-white flex items-center justify-center text-sm font-bold flex-shrink-0">X</div>
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-1 text-sm">
                <span class="publisher-preview font-bold text-ink-900">${escapeShareCardValue(values.publisherName)}</span>
                <span class="twitter-preview-creator text-ink-400">${escapeShareCardValue(values.twitterCreator)}</span>
                <span class="text-ink-400">·</span>
                <span class="text-ink-400">now</span>
              </div>
              <div class="post-preview-copy text-sm text-ink-900 mt-1 leading-relaxed">${escapeShareCardValue(values.postCopy)}</div>
              <div class="mt-3 rounded-2xl border border-[#cfd9de] overflow-hidden bg-white">
                <div class="aspect-[2/1] bg-ink-50">${imagePlaceholder}</div>
                <div class="px-3 py-2 border-t border-[#cfd9de]">
                  <div class="og-preview-title text-sm font-semibold text-ink-900 line-clamp-1">分享标题预览</div>
                  <div class="og-preview-desc text-xs text-ink-500 mt-0.5 line-clamp-2 leading-relaxed">分享描述会在这里展示。</div>
                  <div class="og-preview-url text-xs text-ink-500 mt-1 truncate">https://example.com/share</div>
                </div>
              </div>
              <div class="mt-3 flex items-center justify-between max-w-[260px] text-xs text-ink-400"><span>💬 12</span><span>↻ 8</span><span>♡ 36</span><span>↗</span></div>
            </div>
          </div>
        </div>
        <div class="px-3 pb-3">
          <div class="rounded-lg bg-ink-50 border border-ink-100 p-2">
            <div class="text-[10px] text-ink-500 mb-1">该 Post 样式读取字段</div>
            <div class="flex flex-wrap gap-1">${renderPostFieldBadges(spec.required, "dark")}${renderPostFieldBadges(spec.recommended)}</div>
            <div class="mt-2 grid grid-cols-2 gap-1 text-[10px] text-ink-500"><span>twitter:card <b class="twitter-preview-card text-ink-800">${escapeShareCardValue(values.twitterCard)}</b></span><span>twitter:site <b class="twitter-preview-site text-ink-800">${escapeShareCardValue(values.twitterSite)}</b></span><span class="col-span-2 truncate">twitter:image:alt <b class="twitter-preview-alt text-ink-800">${escapeShareCardValue(values.twitterImageAlt)}</b></span></div>
          </div>
        </div>
      </div>
    `;
  }
  if (s.channel === "Instagram") {
    return `
      <div class="rounded-2xl border border-ink-200 bg-white overflow-hidden shadow-soft">
        <div class="px-3 py-2 border-b border-ink-100 flex items-center justify-between bg-white">
          <div class="flex items-center gap-2"><span class="text-base">📷</span><span class="text-xs font-semibold text-ink-900">Instagram Post</span></div>
          <span class="text-[10px] text-ink-400">Sponsored link preview</span>
        </div>
        <div class="bg-white min-h-[390px]">
          <div class="px-3 py-2 flex items-center gap-2">
            <div class="w-8 h-8 rounded-full bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 p-[2px]"><div class="w-full h-full rounded-full bg-white flex items-center justify-center text-[10px]">IG</div></div>
            <div class="publisher-preview text-sm font-semibold text-ink-900">${escapeShareCardValue(values.publisherName)}</div>
            <div class="ml-auto text-ink-400 text-lg leading-none">⋯</div>
          </div>
          <div class="aspect-square bg-ink-100 border-y border-ink-100">${imagePlaceholder}</div>
          <div class="px-3 py-2">
            <div class="flex items-center gap-4 text-lg text-ink-900"><span>♡</span><span>💬</span><span>↗</span><span class="ml-auto">▢</span></div>
            <div class="mt-2 text-sm leading-relaxed"><span class="publisher-preview font-semibold">${escapeShareCardValue(values.publisherName)}</span> <span class="post-preview-copy">${escapeShareCardValue(values.postCopy)}</span></div>
            <div class="mt-2 rounded-lg border border-ink-100 bg-ink-50 p-2">
              <div class="og-preview-site text-[10px] text-ink-400 uppercase truncate">example.com</div>
              <div class="og-preview-title text-xs font-semibold text-ink-900 line-clamp-1">分享标题预览</div>
              <div class="og-preview-desc text-[11px] text-ink-500 mt-0.5 line-clamp-1">分享描述会在这里展示。</div>
            </div>
          </div>
        </div>
        <div class="px-3 pb-3">
          <div class="rounded-lg bg-ink-50 border border-ink-100 p-2">
            <div class="text-[10px] text-ink-500 mb-1">该 Post 样式读取字段</div>
            <div class="flex flex-wrap gap-1">${renderPostFieldBadges(spec.required, "dark")}${renderPostFieldBadges(spec.recommended)}</div>
          </div>
        </div>
      </div>
    `;
  }
  return `
    <div class="rounded-2xl border border-ink-200 bg-[#f0f2f5] overflow-hidden shadow-soft">
      <div class="px-3 py-2 border-b border-ink-100 flex items-center justify-between bg-white">
        <span class="text-xs font-semibold" style="color:${tone}">📘 Facebook Feed Post</span>
        <span class="px-1.5 py-0.5 rounded text-[9px] font-mono" style="background:${tone};color:${badgeTextColor}">website</span>
      </div>
      <div class="p-3 min-h-[390px]">
        <div class="rounded-xl bg-white shadow-soft overflow-hidden">
          <div class="p-3">
            <div class="flex items-center gap-2 mb-2">
              <div class="w-9 h-9 rounded-full bg-[#1877f2] text-white flex items-center justify-center text-xs font-bold">f</div>
              <div class="min-w-0">
                <div class="publisher-preview text-sm font-semibold text-ink-900 leading-tight">${escapeShareCardValue(values.publisherName)}</div>
                <div class="text-[11px] text-ink-400 leading-tight">Just now · 🌐</div>
              </div>
            </div>
            <div class="post-preview-copy text-sm text-ink-800 mb-3 leading-relaxed">${escapeShareCardValue(values.postCopy)}</div>
          </div>
          <div class="border-y border-ink-200 bg-white">
            <div class="aspect-[1.91/1] bg-ink-100">${imagePlaceholder}</div>
            <div class="p-3 bg-[#f7f8fa]">
              <div class="og-preview-site text-[10px] text-ink-500 uppercase truncate tracking-wide">example.com</div>
              <div class="og-preview-title text-sm font-semibold text-ink-900 mt-1 line-clamp-2">分享标题预览</div>
              <div class="og-preview-desc text-xs text-ink-600 mt-1 line-clamp-2 leading-relaxed">分享描述会在这里展示。</div>
            </div>
          </div>
          <div class="px-3 py-2 grid grid-cols-3 text-center text-xs text-ink-500 border-b border-ink-100"><span>Like</span><span>Comment</span><span>Share</span></div>
        </div>
      </div>
      <div class="px-3 pb-3">
        <div class="rounded-lg bg-white/80 border border-ink-100 p-2">
          <div class="text-[10px] text-ink-500 mb-1">该 Post 样式读取字段</div>
          <div class="flex flex-wrap gap-1">${renderPostFieldBadges(spec.required, "dark")}${renderPostFieldBadges(spec.recommended)}</div>
          <div class="mt-2 grid grid-cols-2 gap-1 text-[10px] text-ink-500"><span>渠道 <b class="text-ink-800">Facebook</b></span><span>图片 <b class="fb-preview-size text-ink-800">${escapeShareCardValue(values.fbImageSize)}</b></span><span class="col-span-2 truncate">图片说明 <b class="fb-preview-alt text-ink-800">${escapeShareCardValue(values.fbImageAlt)}</b></span></div>
        </div>
      </div>
    </div>
  `;
}

const SHARE_CARD_I18N_LOCALES = [
  { code: "zh-CN", name: "简体中文", region: "中国大陆", status: "source", owner: "业务负责人", progress: 100 },
  { code: "en-US", name: "English (US)", region: "美国 / 默认英文", status: "draft", owner: "待翻译", progress: 0 },
  { code: "en-GB", name: "English (UK)", region: "英国", status: "draft", owner: "待翻译", progress: 0 },
  { code: "en-AU", name: "English (Australia)", region: "澳大利亚", status: "draft", owner: "待翻译", progress: 0 },
  { code: "zh-TW", name: "繁體中文（台灣）", region: "中国台湾", status: "draft", owner: "待翻译", progress: 0 },
  { code: "zh-HK", name: "繁體中文（香港）", region: "中国香港", status: "draft", owner: "待翻译", progress: 0 },
  { code: "ja-JP", name: "日本語", region: "日本", status: "draft", owner: "待翻译", progress: 0 },
  { code: "ko-KR", name: "한국어", region: "韩国", status: "draft", owner: "待翻译", progress: 0 },
  { code: "th-TH", name: "ไทย", region: "泰国", status: "draft", owner: "待翻译", progress: 0 },
  { code: "vi-VN", name: "Tiếng Việt", region: "越南", status: "draft", owner: "待翻译", progress: 0 },
  { code: "id-ID", name: "Bahasa Indonesia", region: "印度尼西亚", status: "draft", owner: "待翻译", progress: 0 },
  { code: "ms-MY", name: "Bahasa Melayu", region: "马来西亚", status: "draft", owner: "待翻译", progress: 0 },
  { code: "fil-PH", name: "Filipino", region: "菲律宾", status: "draft", owner: "待翻译", progress: 0 },
  { code: "my-MM", name: "မြန်မာဘာသာ", region: "缅甸", status: "draft", owner: "待翻译", progress: 0 },
  { code: "km-KH", name: "ភាសាខ្មែរ", region: "柬埔寨", status: "draft", owner: "待翻译", progress: 0 },
  { code: "lo-LA", name: "ລາວ", region: "老挝", status: "draft", owner: "待翻译", progress: 0 },
  { code: "hi-IN", name: "हिन्दी", region: "印度", status: "draft", owner: "待翻译", progress: 0 },
  { code: "bn-BD", name: "বাংলা", region: "孟加拉", status: "draft", owner: "待翻译", progress: 0 },
  { code: "ur-PK", name: "اردو", region: "巴基斯坦 / 乌尔都语", status: "draft", owner: "待翻译", progress: 0 },
  { code: "ta-IN", name: "தமிழ்", region: "印度 / 泰米尔语", status: "draft", owner: "待翻译", progress: 0 },
  { code: "te-IN", name: "తెలుగు", region: "印度 / 泰卢固语", status: "draft", owner: "待翻译", progress: 0 },
  { code: "mr-IN", name: "मराठी", region: "印度 / 马拉地语", status: "draft", owner: "待翻译", progress: 0 },
  { code: "gu-IN", name: "ગુજરાતી", region: "印度 / 古吉拉特语", status: "draft", owner: "待翻译", progress: 0 },
  { code: "kn-IN", name: "ಕನ್ನಡ", region: "印度 / 卡纳达语", status: "draft", owner: "待翻译", progress: 0 },
  { code: "ml-IN", name: "മലയാളം", region: "印度 / 马拉雅拉姆语", status: "draft", owner: "待翻译", progress: 0 },
  { code: "pa-IN", name: "ਪੰਜਾਬੀ", region: "印度 / 旁遮普语", status: "draft", owner: "待翻译", progress: 0 },
  { code: "ne-NP", name: "नेपाली", region: "尼泊尔", status: "draft", owner: "待翻译", progress: 0 },
  { code: "si-LK", name: "සිංහල", region: "斯里兰卡", status: "draft", owner: "待翻译", progress: 0 },
  { code: "ar-SA", name: "العربية", region: "沙特 / 中东", status: "draft", owner: "待翻译", progress: 0 },
  { code: "he-IL", name: "עברית", region: "以色列", status: "draft", owner: "待翻译", progress: 0 },
  { code: "fa-IR", name: "فارسی", region: "伊朗", status: "draft", owner: "待翻译", progress: 0 },
  { code: "tr-TR", name: "Türkçe", region: "土耳其", status: "draft", owner: "待翻译", progress: 0 },
  { code: "ru-RU", name: "Русский", region: "俄语区", status: "draft", owner: "待翻译", progress: 0 },
  { code: "uk-UA", name: "Українська", region: "乌克兰", status: "draft", owner: "待翻译", progress: 0 },
  { code: "es-ES", name: "Español (España)", region: "西班牙", status: "draft", owner: "待翻译", progress: 0 },
  { code: "es-MX", name: "Español (México)", region: "墨西哥", status: "draft", owner: "待翻译", progress: 0 },
  { code: "es-419", name: "Español (LatAm)", region: "拉美", status: "draft", owner: "待翻译", progress: 0 },
  { code: "pt-BR", name: "Português (Brasil)", region: "巴西", status: "draft", owner: "待翻译", progress: 0 },
  { code: "pt-PT", name: "Português (Portugal)", region: "葡萄牙", status: "draft", owner: "待翻译", progress: 0 },
  { code: "fr-FR", name: "Français", region: "法国", status: "draft", owner: "待翻译", progress: 0 },
  { code: "de-DE", name: "Deutsch", region: "德国", status: "draft", owner: "待翻译", progress: 0 },
  { code: "it-IT", name: "Italiano", region: "意大利", status: "draft", owner: "待翻译", progress: 0 },
  { code: "nl-NL", name: "Nederlands", region: "荷兰", status: "draft", owner: "待翻译", progress: 0 },
  { code: "pl-PL", name: "Polski", region: "波兰", status: "draft", owner: "待翻译", progress: 0 },
  { code: "cs-CZ", name: "Čeština", region: "捷克", status: "draft", owner: "待翻译", progress: 0 },
  { code: "hu-HU", name: "Magyar", region: "匈牙利", status: "draft", owner: "待翻译", progress: 0 },
  { code: "ro-RO", name: "Română", region: "罗马尼亚", status: "draft", owner: "待翻译", progress: 0 },
  { code: "el-GR", name: "Ελληνικά", region: "希腊", status: "draft", owner: "待翻译", progress: 0 },
  { code: "sv-SE", name: "Svenska", region: "瑞典", status: "draft", owner: "待翻译", progress: 0 },
  { code: "da-DK", name: "Dansk", region: "丹麦", status: "draft", owner: "待翻译", progress: 0 },
  { code: "fi-FI", name: "Suomi", region: "芬兰", status: "draft", owner: "待翻译", progress: 0 },
  { code: "nb-NO", name: "Norsk Bokmål", region: "挪威", status: "draft", owner: "待翻译", progress: 0 },
  { code: "sw-KE", name: "Kiswahili", region: "东非", status: "draft", owner: "待翻译", progress: 0 },
  { code: "af-ZA", name: "Afrikaans", region: "南非", status: "draft", owner: "待翻译", progress: 0 },
];

const SHARE_LANGUAGE_ZH_NAMES = {
  "zh-CN": "简体中文",
  "en-US": "英语（美国）",
  "en-GB": "英语（英国）",
  "en-AU": "英语（澳大利亚）",
  "zh-TW": "繁体中文（台湾）",
  "zh-HK": "繁体中文（香港）",
  "ja-JP": "日语",
  "ko-KR": "韩语",
  "th-TH": "泰语",
  "vi-VN": "越南语",
  "id-ID": "印度尼西亚语",
  "ms-MY": "马来语",
  "fil-PH": "菲律宾语",
  "my-MM": "缅甸语",
  "km-KH": "高棉语",
  "lo-LA": "老挝语",
  "hi-IN": "印地语",
  "bn-BD": "孟加拉语",
  "ur-PK": "乌尔都语",
  "ta-IN": "泰米尔语",
  "te-IN": "泰卢固语",
  "mr-IN": "马拉地语",
  "gu-IN": "古吉拉特语",
  "kn-IN": "卡纳达语",
  "ml-IN": "马拉雅拉姆语",
  "pa-IN": "旁遮普语",
  "ne-NP": "尼泊尔语",
  "si-LK": "僧伽罗语",
  "ar-SA": "阿拉伯语",
  "he-IL": "希伯来语",
  "fa-IR": "波斯语",
  "tr-TR": "土耳其语",
  "ru-RU": "俄语",
  "uk-UA": "乌克兰语",
  "es-ES": "西班牙语（西班牙）",
  "es-MX": "西班牙语（墨西哥）",
  "es-419": "西班牙语（拉美）",
  "pt-BR": "葡萄牙语（巴西）",
  "pt-PT": "葡萄牙语（葡萄牙）",
  "fr-FR": "法语",
  "de-DE": "德语",
  "it-IT": "意大利语",
  "nl-NL": "荷兰语",
  "pl-PL": "波兰语",
  "cs-CZ": "捷克语",
  "hu-HU": "匈牙利语",
  "ro-RO": "罗马尼亚语",
  "el-GR": "希腊语",
  "sv-SE": "瑞典语",
  "da-DK": "丹麦语",
  "fi-FI": "芬兰语",
  "nb-NO": "挪威语（书面语）",
  "sw-KE": "斯瓦希里语",
  "af-ZA": "南非荷兰语",
};

function getShareLanguageChineseName(locale) {
  return locale?.zhName || SHARE_LANGUAGE_ZH_NAMES[locale?.code] || locale?.name || locale?.code || "未知语言";
}

function getShareLanguageNativeName(locale) {
  const zhName = getShareLanguageChineseName(locale);
  return locale?.name && locale.name !== zhName ? locale.name : "";
}

function getShareCardI18nFieldLabels(localeCode) {
  const labels = {
    "zh-CN": {
      title: "分享标题", titlePlaceholder: "请输入分享标题",
      desc: "分享描述", descPlaceholder: "请输入分享描述",
      copy: "分享文案", copyBadge: "Post 复用", copyPlaceholder: "不填则使用：分享了一个游戏福利链接",
      url: "落地链接", site: "站点名", sitePlaceholder: "请输入站点名 / 游戏名",
      image: "分享图", upload: "上传", uploadReplace: "上传替换", reuse: "恢复复用",
      imageUrlPlaceholder: "或填写图片 URL", targetImageUrlPlaceholder: "不填则复用中文图片 URL",
      defaultReuseTitle: "默认复用中文源图片", defaultReuseHint: "可上传该语种专属图替换",
      noFile: "尚未上传图片", reuseFileName: "默认复用中文源图片", overrideFileName: "已配置该语种专属图片",
      overrideTip: "当前语种使用专属图片。", reuseTip: "未配置专属图片时，自动采用中文源图片。",
      sourceDesc: "默认中文源内容，直接在第一个 Tab 维护。", targetDesc: "目标语种内容，结构与中文输入区一致，可由 CSV 填充后再校对。",
    },
    "en-US": {
      title: "Share Title", titlePlaceholder: "Enter share title",
      desc: "Share Description", descPlaceholder: "Enter share description",
      copy: "Share Copy", copyBadge: "Reused by Post", copyPlaceholder: "Default: shared a game reward link",
      url: "Landing URL", site: "Site Name", sitePlaceholder: "Enter site / game name",
      image: "Share Image", upload: "Upload", uploadReplace: "Upload Override", reuse: "Reuse Source",
      imageUrlPlaceholder: "Or enter image URL", targetImageUrlPlaceholder: "Leave empty to reuse Chinese image URL",
      defaultReuseTitle: "Reuses Chinese source image by default", defaultReuseHint: "Upload a locale-specific image to override",
      noFile: "No image uploaded", reuseFileName: "Reusing Chinese source image", overrideFileName: "Locale-specific image configured",
      overrideTip: "This locale uses its own image.", reuseTip: "If no locale image is configured, the Chinese source image is used automatically.",
      sourceDesc: "Default Chinese source content, maintained in the first tab.", targetDesc: "Target locale content. Same structure as Chinese; CSV can fill it for review.",
    },
    "zh-TW": {
      title: "分享標題", titlePlaceholder: "請輸入分享標題",
      desc: "分享描述", descPlaceholder: "請輸入分享描述",
      copy: "分享文案", copyBadge: "Post 複用", copyPlaceholder: "不填則使用：分享了一個遊戲福利連結",
      url: "落地連結", site: "站點名稱", sitePlaceholder: "請輸入站點名稱 / 遊戲名",
      image: "分享圖", upload: "上傳", uploadReplace: "上傳替換", reuse: "恢復複用",
      imageUrlPlaceholder: "或填寫圖片 URL", targetImageUrlPlaceholder: "不填則複用簡中圖片 URL",
      defaultReuseTitle: "預設複用簡中來源圖片", defaultReuseHint: "可上傳該語種專屬圖替換",
      noFile: "尚未上傳圖片", reuseFileName: "預設複用簡中來源圖片", overrideFileName: "已配置該語種專屬圖片",
      overrideTip: "目前語種使用專屬圖片。", reuseTip: "未配置專屬圖片時，會自動採用簡中來源圖片。",
      sourceDesc: "預設簡中來源內容，直接在第一個 Tab 維護。", targetDesc: "目標語種內容，結構與簡中輸入區一致，可由 CSV 填充後再校對。",
    },
    "ja-JP": {
      title: "シェアタイトル", titlePlaceholder: "シェアタイトルを入力",
      desc: "シェア説明", descPlaceholder: "シェア説明を入力",
      copy: "シェア文言", copyBadge: "Post で再利用", copyPlaceholder: "未入力時：ゲーム特典リンクをシェアしました",
      url: "遷移先リンク", site: "サイト名", sitePlaceholder: "サイト名 / ゲーム名を入力",
      image: "シェア画像", upload: "アップロード", uploadReplace: "画像を差し替え", reuse: "共通画像に戻す",
      imageUrlPlaceholder: "または画像 URL を入力", targetImageUrlPlaceholder: "空欄なら中国語画像 URL を再利用",
      defaultReuseTitle: "デフォルトで中国語ソース画像を再利用", defaultReuseHint: "この言語専用画像をアップロードして差し替え可能",
      noFile: "画像未アップロード", reuseFileName: "中国語ソース画像を再利用", overrideFileName: "この言語専用画像を設定済み",
      overrideTip: "この言語は専用画像を使用しています。", reuseTip: "専用画像がない場合、中国語ソース画像を自動で使用します。",
      sourceDesc: "デフォルトの中国語ソース内容は最初の Tab で管理します。", targetDesc: "対象言語の内容です。中国語入力区と同じ構造で、CSV 取り込み後に確認できます。",
    },
    "ko-KR": {
      title: "공유 제목", titlePlaceholder: "공유 제목을 입력하세요",
      desc: "공유 설명", descPlaceholder: "공유 설명을 입력하세요",
      copy: "공유 문구", copyBadge: "Post 재사용", copyPlaceholder: "비워두면: 게임 보상 링크를 공유했습니다",
      url: "랜딩 링크", site: "사이트 이름", sitePlaceholder: "사이트 / 게임 이름을 입력하세요",
      image: "공유 이미지", upload: "업로드", uploadReplace: "업로드하여 교체", reuse: "원본 재사용",
      imageUrlPlaceholder: "또는 이미지 URL 입력", targetImageUrlPlaceholder: "비워두면 중국어 이미지 URL 재사용",
      defaultReuseTitle: "기본값은 중국어 원본 이미지 재사용", defaultReuseHint: "언어별 전용 이미지를 업로드해 교체 가능",
      noFile: "업로드된 이미지 없음", reuseFileName: "중국어 원본 이미지 재사용", overrideFileName: "언어별 전용 이미지 설정됨",
      overrideTip: "현재 언어는 전용 이미지를 사용합니다.", reuseTip: "전용 이미지가 없으면 중국어 원본 이미지를 자동 사용합니다.",
      sourceDesc: "기본 중국어 원본 내용은 첫 번째 Tab에서 관리합니다.", targetDesc: "대상 언어 내용입니다. 중국어 입력 영역과 동일한 구조이며 CSV로 채운 뒤 검수할 수 있습니다.",
    },
    "th-TH": {
      title: "ชื่อแชร์", titlePlaceholder: "กรอกชื่อแชร์",
      desc: "คำอธิบายแชร์", descPlaceholder: "กรอกคำอธิบายแชร์",
      copy: "ข้อความแชร์", copyBadge: "ใช้ซ้ำใน Post", copyPlaceholder: "หากเว้นว่าง: แชร์ลิงก์รางวัลเกม",
      url: "ลิงก์ปลายทาง", site: "ชื่อเว็บไซต์", sitePlaceholder: "กรอกชื่อเว็บไซต์ / เกม",
      image: "รูปภาพแชร์", upload: "อัปโหลด", uploadReplace: "อัปโหลดแทนที่", reuse: "กลับไปใช้รูปต้นฉบับ",
      imageUrlPlaceholder: "หรือกรอก URL รูปภาพ", targetImageUrlPlaceholder: "เว้นว่างเพื่อใช้ URL รูปภาษาจีน",
      defaultReuseTitle: "ค่าเริ่มต้นใช้รูปต้นฉบับภาษาจีน", defaultReuseHint: "อัปโหลดรูปเฉพาะภาษานี้เพื่อแทนที่ได้",
      noFile: "ยังไม่ได้อัปโหลดรูป", reuseFileName: "ใช้รูปต้นฉบับภาษาจีน", overrideFileName: "ตั้งค่ารูปเฉพาะภาษานี้แล้ว",
      overrideTip: "ภาษานี้ใช้รูปเฉพาะของตัวเอง", reuseTip: "หากไม่มีรูปเฉพาะ ระบบจะใช้รูปต้นฉบับภาษาจีนโดยอัตโนมัติ",
      sourceDesc: "เนื้อหาต้นฉบับภาษาจีนอยู่ใน Tab แรก", targetDesc: "เนื้อหาภาษาเป้าหมาย โครงสร้างเหมือนภาษาจีน และเติมจาก CSV เพื่อตรวจทานได้",
    },
    "vi-VN": {
      title: "Tiêu đề chia sẻ", titlePlaceholder: "Nhập tiêu đề chia sẻ",
      desc: "Mô tả chia sẻ", descPlaceholder: "Nhập mô tả chia sẻ",
      copy: "Nội dung chia sẻ", copyBadge: "Post dùng lại", copyPlaceholder: "Để trống: đã chia sẻ liên kết phần thưởng game",
      url: "Liên kết đích", site: "Tên website", sitePlaceholder: "Nhập tên website / game",
      image: "Ảnh chia sẻ", upload: "Tải lên", uploadReplace: "Tải lên thay thế", reuse: "Dùng lại ảnh gốc",
      imageUrlPlaceholder: "Hoặc nhập URL ảnh", targetImageUrlPlaceholder: "Để trống để dùng URL ảnh tiếng Trung",
      defaultReuseTitle: "Mặc định dùng lại ảnh nguồn tiếng Trung", defaultReuseHint: "Có thể tải ảnh riêng cho ngôn ngữ này để thay thế",
      noFile: "Chưa tải ảnh", reuseFileName: "Đang dùng lại ảnh nguồn tiếng Trung", overrideFileName: "Đã cấu hình ảnh riêng cho ngôn ngữ này",
      overrideTip: "Ngôn ngữ này đang dùng ảnh riêng.", reuseTip: "Nếu chưa cấu hình ảnh riêng, hệ thống tự dùng ảnh nguồn tiếng Trung.",
      sourceDesc: "Nội dung nguồn tiếng Trung mặc định được duy trì ở Tab đầu tiên.", targetDesc: "Nội dung ngôn ngữ đích, cùng cấu trúc với tiếng Trung; có thể nhập từ CSV rồi rà soát.",
    },
  };
  return labels[localeCode] || labels["en-US"];
}

function getShareCardLocaleStatusMeta(status) {
  const map = {
    source: { text: "源文案", cls: "bg-purple-50 text-purple-700 border-purple-50" },
    published: { text: "已导入", cls: "bg-ok-50 text-ok-700 border-ok-50" },
    review: { text: "待审核", cls: "bg-amber-50 text-amber-700 border-amber-50" },
    draft: { text: "待翻译", cls: "bg-brand-50 text-brand-700 border-brand-50" },
    missing: { text: "未选择", cls: "bg-ink-100 text-ink-500 border-ink-100" },
  };
  return map[status] || map.missing;
}

function getShareLanguageCatalog() {
  const custom = window.__shareLanguageCustomLocales || [];
  const map = new Map();
  [...SHARE_CARD_I18N_LOCALES, ...custom].forEach((locale) => map.set(locale.code, locale));
  return Array.from(map.values());
}

function getShareCardDefaultLanguageCode() {
  return window.__shareLanguageDefaultLocale || window.__shareCardI18nDefaultLocale || "en-US";
}

function getShareCardDefaultLanguage() {
  const code = getShareCardDefaultLanguageCode();
  return getShareLanguageCatalog().find((locale) => locale.code === code) || getShareLanguageCatalog().find((locale) => locale.code === "en-US");
}

function getShareLanguageSelectedCodes() {
  const selected = window.__shareLanguageSelectedLocales || window.__shareCardI18nSelectedLocales || ["en-US", "zh-TW", "ja-JP"];
  const set = new Set(selected);
  set.add(getShareCardDefaultLanguageCode());
  return Array.from(set);
}

function getSelectedShareCardI18nLocales() {
  return new Set(getShareLanguageSelectedCodes());
}

function getImportedShareCardI18nRows() {
  return window.__shareCardI18nImportedRows || [];
}

function getShareCardI18nManualDrafts() {
  window.__shareCardI18nManualDrafts = window.__shareCardI18nManualDrafts || {};
  return window.__shareCardI18nManualDrafts;
}

function getShareCardLocaleDraft(locale, ogState, postState) {
  const source = {
    title: ogState.title || "一起加入史诗战斗！",
    desc: ogState.desc || "立即下载并领取你的专属奖励。",
    copy: postState.postCopy || "分享了一个游戏福利链接",
    site: ogState.site || "EasyShare",
    imageUrl: ogState.imageUrl || "",
    imageDataUrl: ogState.imageDataUrl || "",
    imageFileName: ogState.imageFileName || "",
  };
  if (locale.code === "zh-CN") return source;
  const manualDraft = getShareCardI18nManualDrafts()[locale.code] || {};
  const importedRows = getImportedShareCardI18nRows().filter((row) => row.locale === locale.code);
  const importedDraft = { title: "", desc: "", copy: "", site: source.site, imageUrl: "", imageDataUrl: "", imageFileName: "" };
  if (importedRows.length) {
    const find = (field, fallback = "") => importedRows.find((row) => row.field === field)?.targetText || fallback;
    importedDraft.title = find("og:title");
    importedDraft.desc = find("og:description");
    importedDraft.copy = find("share_copy");
    importedDraft.site = find("og:site_name", source.site);
  }
  return {
    title: manualDraft.title ?? importedDraft.title,
    desc: manualDraft.desc ?? importedDraft.desc,
    copy: manualDraft.copy ?? importedDraft.copy,
    site: manualDraft.site ?? importedDraft.site,
    imageUrl: manualDraft.imageUrl ?? importedDraft.imageUrl,
    imageDataUrl: manualDraft.imageDataUrl ?? importedDraft.imageDataUrl,
    imageFileName: manualDraft.imageFileName ?? importedDraft.imageFileName,
  };
}

function getActiveShareCardI18nLocale() {
  const locales = getShareCardI18nLocalesForInput();
  const activeCode = window.__shareCardI18nLocaleTab || "zh-CN";
  return locales.find((locale) => locale.code === activeCode) || locales[0] || SHARE_CARD_I18N_LOCALES[0];
}

function getShareCardPreviewStateForLocale(locale, ogState = getShareCardOgFormState(), postState = getShareCardPostFormState()) {
  const draft = getShareCardLocaleDraft(locale, ogState, postState);
  const isSource = locale.code === "zh-CN";
  return {
    ...ogState,
    title: draft.title || (isSource ? ogState.title : ""),
    desc: draft.desc || (isSource ? ogState.desc : ""),
    copy: draft.copy || (isSource ? postState.postCopy : ""),
    site: draft.site || ogState.site || "EasyShare",
    imageUrl: isSource ? (ogState.imageUrl || "") : (draft.imageUrl || ogState.imageUrl || ""),
    imageDataUrl: isSource ? (ogState.imageDataUrl || "") : (draft.imageDataUrl || (!draft.imageUrl ? ogState.imageDataUrl : "") || ""),
    imageFileName: isSource ? (ogState.imageFileName || "") : (draft.imageFileName || ogState.imageFileName || ""),
  };
}

function getActiveShareCardPreviewState(ogState = getShareCardOgFormState(), postState = getShareCardPostFormState()) {
  return getShareCardPreviewStateForLocale(getActiveShareCardI18nLocale(), ogState, postState);
}

function renderShareCardI18nImportedPreview(activeLocale, ogState, postState) {
  const rows = getImportedShareCardI18nRows();
  if (!rows.length) {
    return `
      <div class="rounded-xl border border-dashed border-ink-200 bg-ink-50 px-4 py-8 text-center">
        <div class="text-sm font-semibold text-ink-700">尚未导入多语言 CSV</div>
        <div class="mt-1 text-xs text-ink-500">上传校对确认后的 CSV 后，这里会展示解析后的多语言内容和当前语言预览。</div>
      </div>
    `;
  }
  const draft = getShareCardLocaleDraft(activeLocale, ogState, postState);
  return `
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-7 rounded-xl border border-ink-100 overflow-hidden">
        <div class="px-3 py-2 bg-ink-50 text-xs font-semibold text-ink-700">CSV 已导入内容</div>
        <div class="max-h-56 overflow-auto">
          <table class="w-full text-xs">
            <thead class="bg-white text-ink-400 border-b border-ink-100"><tr><th class="px-3 py-2 text-left">语言</th><th class="px-3 py-2 text-left">字段</th><th class="px-3 py-2 text-left">译文</th></tr></thead>
            <tbody>${rows.slice(0, 12).map((row) => `<tr class="border-b border-ink-50"><td class="px-3 py-2 font-mono text-ink-600">${escapeShareCardValue(row.locale)}</td><td class="px-3 py-2 font-mono text-brand-700">${escapeShareCardValue(row.field)}</td><td class="px-3 py-2 text-ink-800 line-clamp-1">${escapeShareCardValue(row.targetText || "—")}</td></tr>`).join("")}</tbody>
          </table>
        </div>
      </div>
      <div class="col-span-5 rounded-xl border border-brand-100 bg-brand-50/40 p-4">
        <div class="text-xs font-semibold text-brand-700 mb-2">${activeLocale.name} 预览</div>
        <div class="rounded-lg bg-white border border-ink-100 overflow-hidden shadow-soft">
          <div class="h-28 bg-ink-100 flex items-center justify-center text-xs text-ink-400">复用基础分享图</div>
          <div class="p-3">
            <div class="text-[10px] text-ink-400 uppercase truncate">${escapeShareCardValue(draft.site || ogState.site || "EasyShare")}</div>
            <div class="mt-1 text-sm font-semibold text-ink-900 line-clamp-2">${escapeShareCardValue(draft.title || "待导入标题")}</div>
            <div class="mt-1 text-xs text-ink-500 line-clamp-2">${escapeShareCardValue(draft.desc || "待导入描述")}</div>
            <div class="mt-2 rounded bg-ink-50 px-2 py-1 text-[11px] text-ink-600 line-clamp-1">${escapeShareCardValue(draft.copy || "待导入分享文案")}</div>
          </div>
        </div>
      </div>
    </div>
  `;
}

function getPendingShareCardI18nLocales() {
  const selected = Array.from(getSelectedShareCardI18nLocales());
  window.__shareCardI18nPendingLocales = window.__shareCardI18nPendingLocales || selected;
  return new Set(window.__shareCardI18nPendingLocales);
}

function renderShareCardI18nConfig(ogState, postState) {
  const selectedLocales = getSelectedShareCardI18nLocales();
  const defaultLanguage = getShareCardDefaultLanguage();
  return `
    <div class="flex items-center gap-2 flex-wrap">
      <button type="button" onclick="navigate('/admin/platform/share-languages?return=/ops/share-card-config')" class="px-3 py-1.5 text-xs rounded-lg border border-brand-100 bg-brand-50 text-brand-700 hover:bg-brand-100">多语言配置 · ${selectedLocales.size}</button>
      <span class="badge bg-ink-100 text-ink-700">默认：${defaultLanguage?.name || "English (US)"}</span>
      <button type="button" onclick="exportShareCardI18nCsv()" class="px-3 py-1.5 text-xs rounded-lg border border-ink-100 bg-white hover:bg-ink-50">下载中文包 CSV</button>
      <button type="button" onclick="document.getElementById('share-card-i18n-csv-input')?.click()" class="px-3 py-1.5 text-xs rounded-lg bg-brand-900 text-white hover:bg-brand-800">上传多语言包</button>
      <input id="share-card-i18n-csv-input" type="file" accept=".csv,text/csv" class="hidden" onchange="importShareCardI18nCsv(this.files?.[0]); this.value=''" />
    </div>
  `;
}

Pages.shareLanguages = function () {
  const isAdminEntry = (typeof getCurrentPath === "function" ? getCurrentPath() : "") === "/admin/platform/share-languages";
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const params = new URLSearchParams(query);
  const isAdminManage = isAdminEntry && !params.has("return");
  const returnPath = params.get("return") || (isAdminEntry ? "/admin/platform/settings" : "/ops/share-card-config");
  const catalog = getShareLanguageCatalog().filter((locale) => locale.code !== "zh-CN");
  const selected = new Set(getShareLanguageSelectedCodes().filter((code) => code !== "zh-CN"));
  const defaultCode = getShareCardDefaultLanguageCode();
  const defaultLanguage = getShareCardDefaultLanguage();
  return `
    ${UI.pageHeader({
      title: "多语言配置",
      desc: isAdminManage ? "管理员维护 Share 系统全局语言池、默认语言和自定义 BCP 47 标签。" : "为当前配置选择可用语言和默认语言；确认后回到来源页面继续配置。",
      actions: `
        <span class="badge ${isAdminManage ? "bg-purple-50 text-purple-700" : "bg-brand-50 text-brand-700"}">${isAdminManage ? "管理员全局管理" : "业务选择模式"}</span>
        <button onclick="navigate('${returnPath}')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">${isAdminManage ? "返回平台参数" : "取消返回"}</button>
        <button onclick="saveShareLanguages('${returnPath}')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">${isAdminManage ? "保存全局语言配置" : "确认选择并返回"}</button>
      `,
    })}

    <div class="grid grid-cols-12 gap-5 items-start">
      <section class="col-span-12 lg:col-span-8 card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
          <div>
            <h3 class="text-sm font-semibold text-ink-900">${isAdminManage ? "全局语言池" : "选择语言"}</h3>
            <p class="text-xs text-ink-500 mt-0.5">${isAdminManage ? "维护系统可用语言，所有业务入口复用这份语言池。" : "支持多选，语言标签遵循 BCP 47，例如 en-US、zh-TW、ja-JP。"}</p>
          </div>
          <span class="badge bg-brand-50 text-brand-700">已选 ${selected.size}</span>
        </div>
        <div class="p-5 grid grid-cols-2 xl:grid-cols-3 gap-3">
          ${catalog.map((locale) => {
            const checked = selected.has(locale.code);
            const isDefault = locale.code === defaultCode;
            const zhName = getShareLanguageChineseName(locale);
            const nativeName = getShareLanguageNativeName(locale);
            return `
              <label class="rounded-xl border ${checked ? "border-brand-200 bg-brand-50/50" : "border-ink-100 bg-white hover:border-brand-200"} p-3 cursor-pointer">
                <div class="flex items-start gap-2">
                  <input type="checkbox" data-share-language="${locale.code}" ${checked ? "checked" : ""} onchange="toggleShareLanguageSelection('${locale.code}', this.checked)" class="mt-0.5 rounded border-ink-300" />
                  <div class="min-w-0 flex-1">
                    <div class="flex items-center gap-2 flex-wrap">
                      <span class="text-sm font-semibold text-ink-900">${zhName}</span>
                      ${isDefault ? `<span class="badge bg-brand-900 text-white">默认</span>` : ""}
                    </div>
                    ${nativeName ? `<div class="mt-1 text-[11px] text-ink-500 truncate">${nativeName}</div>` : ""}
                    <div class="mt-1 font-mono text-xs text-brand-700">${locale.code}</div>
                    <div class="mt-1 text-[11px] text-ink-400">${locale.region || "全球"}</div>
                  </div>
                </div>
              </label>
            `;
          }).join("")}
        </div>
      </section>

      <aside class="col-span-12 lg:col-span-4 space-y-5">
        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100">
            <h3 class="text-sm font-semibold text-ink-900">默认语言</h3>
            <p class="text-xs text-ink-500 mt-0.5">未设置时默认英语（美国）。</p>
          </div>
          <div class="p-5 space-y-3">
            <select id="share-language-default-select" onchange="setShareLanguageDefaultFromPage(this.value)" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg bg-white text-sm">
              ${catalog.map((locale) => `<option value="${locale.code}" ${locale.code === defaultCode ? "selected" : ""}>${getShareLanguageChineseName(locale)} · ${locale.code}</option>`).join("")}
            </select>
            <div class="rounded-xl border border-brand-100 bg-brand-50 p-3 text-xs text-brand-800">
              当前默认语言：<strong>${getShareLanguageChineseName(defaultLanguage) || "英语（美国）"}</strong><br />
              <span class="font-mono">${defaultCode}</span>
            </div>
          </div>
        </div>

        ${isAdminManage ? `
        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100">
            <h3 class="text-sm font-semibold text-ink-900">自定义 BCP 47 标签</h3>
            <p class="text-xs text-ink-500 mt-0.5">管理员可补充预设外语言。</p>
          </div>
          <div class="p-5 space-y-3">
            <input id="custom-share-language-code" placeholder="例如 ur-IN / en-CA / fr-CA" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono" />
            <input id="custom-share-language-name" placeholder="中文显示名，例如 乌尔都语（印度）" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
            <button type="button" onclick="addCustomShareLanguage()" class="w-full px-3 py-2 text-sm rounded-lg bg-ink-900 text-white hover:bg-ink-800">添加语言</button>
          </div>
        </div>
        ` : ""}

        <div class="card p-4 ${isAdminManage ? "bg-amber-50 border-amber-200" : "bg-brand-50 border-brand-200"}">
          <div class="text-sm font-semibold ${isAdminManage ? "text-amber-900" : "text-brand-900"}">${isAdminManage ? "全局生效说明" : "业务选择说明"}</div>
          <div class="mt-1 text-xs ${isAdminManage ? "text-amber-800" : "text-brand-800"} leading-relaxed">${isAdminManage ? "保存后，分享卡片、落地页、活动等所有需要配置语言的入口都复用这里的语言选择和默认语言。" : "这里只选择当前业务需要使用的语言和默认语言；如缺少语种，请联系管理员在全局语言池补充。"}</div>
        </div>
      </aside>
    </div>
  `;
};

function getShareCardI18nLocalesForInput() {
  const selected = Array.from(getSelectedShareCardI18nLocales()).filter((code) => code !== "zh-CN");
  return ["zh-CN", ...selected].map((code) => SHARE_CARD_I18N_LOCALES.find((item) => item.code === code)).filter(Boolean);
}

function renderShareCardLocaleTabs(locales, activeCode) {
  const defaultCode = getShareCardDefaultLanguageCode();
  return `
    <div class="flex items-center gap-2 overflow-x-auto border-b border-ink-100 pb-2">
      ${locales.map((locale) => `<button type="button" onclick="switchShareCardI18nTab('${locale.code}')" class="px-3 py-1.5 rounded-lg text-xs whitespace-nowrap ${locale.code === activeCode ? "bg-brand-900 text-white" : "bg-ink-50 text-ink-600 hover:bg-ink-100"}">${locale.name}<span class="ml-1 font-mono opacity-70">${locale.code}</span>${locale.code === defaultCode ? `<span class="ml-1 rounded bg-white/20 px-1 py-0.5 text-[10px] ${locale.code === activeCode ? "text-white" : "bg-brand-50 text-brand-700"}">默认</span>` : ""}</button>`).join("")}
    </div>
  `;
}

function renderShareCardLocaleInputArea(ogState, postState, ogImagePreviewHtml) {
  const locales = getShareCardI18nLocalesForInput();
  const activeCode = window.__shareCardI18nLocaleTab || "zh-CN";
  const activeLocale = locales.find((locale) => locale.code === activeCode) || locales[0];
  const isSource = activeLocale.code === "zh-CN";
  const draft = getShareCardLocaleDraft(activeLocale, ogState, postState);
  const importedRows = getImportedShareCardI18nRows();
  const hasImported = !isSource && importedRows.some((row) => row.locale === activeLocale.code);
  const meta = getShareCardLocaleStatusMeta(isSource ? "source" : (hasImported ? "published" : "draft"));
  const localeCode = activeLocale.code;
  const titleId = isSource ? "og-title-input" : `i18n-${localeCode}-title-input`;
  const descId = isSource ? "og-desc-input" : `i18n-${localeCode}-desc-input`;
  const copyId = isSource ? "post-copy-input" : `i18n-${localeCode}-copy-input`;
  const siteId = isSource ? "og-site-input" : `i18n-${localeCode}-site-input`;
  const imageUrlId = isSource ? "og-image-url-input" : `i18n-${localeCode}-image-url-input`;
  const imageFileInputId = isSource ? "og-image-file" : `i18n-${localeCode}-image-file`;
  const imagePreviewId = isSource ? "og-image-preview" : `i18n-${localeCode}-image-preview`;
  const imageFileNameId = isSource ? "og-image-file-name" : `i18n-${localeCode}-image-file-name`;
  const localeImageState = isSource ? ogState : {
    imageDataUrl: draft.imageDataUrl || ogState.imageDataUrl || "",
    imageUrl: draft.imageDataUrl ? "" : (draft.imageUrl || ogState.imageUrl || ""),
  };
  const hasLocaleImageOverride = !isSource && Boolean(draft.imageDataUrl || draft.imageUrl);
  const labels = getShareCardI18nFieldLabels(localeCode);
  const textChange = isSource ? "updateOgCardPreviews()" : `updateShareCardI18nDraft('${localeCode}')`;
  const copyChange = isSource ? "updateShareCardPostPreviews()" : `updateShareCardI18nDraft('${localeCode}')`;
  const imageUrlChange = isSource ? "updateOgCardPreviews()" : `updateShareCardI18nDraft('${localeCode}')`;
  return `
    <div class="space-y-4">
      ${renderShareCardLocaleTabs(locales, activeLocale.code)}
      <div class="flex items-center justify-between gap-3">
        <div>
          <div class="text-sm font-semibold text-ink-900">${activeLocale.name}<span class="ml-2 font-mono text-xs text-ink-400">${activeLocale.code}</span></div>
          <div class="text-xs text-ink-500 mt-0.5">${isSource ? labels.sourceDesc : labels.targetDesc}</div>
        </div>
        <span class="badge ${meta.cls}">${meta.text}</span>
      </div>
      <div class="grid grid-cols-12 gap-5 items-start">
        <div class="col-span-8 space-y-4">
          <label class="block">
            <span class="flex items-center justify-between text-xs font-medium text-ink-500 mb-1"><span>${labels.title} · og:title</span>${isSource ? `<span><span id="og-title-counter">${ogState.title.length}</span>/60</span>` : `<span>${String(draft.title || "").length}/60</span>`}</span>
            <input id="${titleId}" maxlength="60" value="${escapeShareCardValue(draft.title)}" oninput="${textChange}" placeholder="${labels.titlePlaceholder}" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" />
          </label>
          <label class="block">
            <span class="flex items-center justify-between text-xs font-medium text-ink-500 mb-1"><span>${labels.desc} · og:description</span>${isSource ? `<span><span id="og-desc-counter">${ogState.desc.length}</span>/110</span>` : `<span>${String(draft.desc || "").length}/110</span>`}</span>
            <textarea id="${descId}" maxlength="110" oninput="${textChange}" rows="3" placeholder="${labels.descPlaceholder}" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm">${escapeShareCardValue(draft.desc)}</textarea>
          </label>
          <label class="block">
            <span class="flex items-center justify-between text-xs font-medium text-ink-500 mb-1"><span>${labels.copy} · share_copy</span><span class="font-mono text-brand-700">${labels.copyBadge}</span></span>
            <input id="${copyId}" value="${escapeShareCardValue(draft.copy)}" oninput="${copyChange}" placeholder="${labels.copyPlaceholder}" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm bg-white" />
          </label>
          <div class="grid grid-cols-2 gap-4">
            <label class="block">
              <span class="block text-xs font-medium text-ink-500 mb-1">${labels.url} · og:url</span>
              <input id="og-url-input" value="${escapeShareCardValue(ogState.url)}" oninput="updateOgCardPreviews()" placeholder="https://example.com/share" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm font-mono ${isSource ? "" : "bg-ink-50 text-ink-500"}" ${isSource ? "" : "readonly"} />
            </label>
            <label class="block">
              <span class="flex items-center justify-between text-xs font-medium text-ink-500 mb-1"><span>${labels.site} · og:site_name</span>${isSource ? `<span><span id="og-site-counter">${ogState.site.length}</span>/30</span>` : `<span>${String(draft.site || "").length}/30</span>`}</span>
              <input id="${siteId}" maxlength="30" value="${escapeShareCardValue(draft.site)}" oninput="${textChange}" placeholder="${labels.sitePlaceholder}" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" />
            </label>
          </div>
        </div>
        <div class="col-span-4">
          <div class="rounded-xl border border-ink-100 bg-ink-50/50 p-3">
            <div class="mb-2 flex items-center justify-between gap-2">
              <div class="text-xs font-semibold text-ink-700">${labels.image} · og:image</div>
              <span class="badge bg-ink-100 text-ink-700">1200×1200</span>
            </div>
            <div id="${imagePreviewId}" onclick="document.getElementById('${imageFileInputId}')?.click()" class="h-36 rounded-xl border-2 border-dashed border-ink-200 bg-white flex flex-col items-center justify-center text-xs text-ink-400 cursor-pointer hover:border-brand-300 overflow-hidden">
              ${isSource ? ogImagePreviewHtml : getShareCardPreviewImageHtml(localeImageState, `<div class="text-sm font-medium text-ink-600">${labels.defaultReuseTitle}</div><div class="text-[11px] mt-1">${labels.defaultReuseHint}</div>`)}
            </div>
            <input id="${imageFileInputId}" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleShareCardImageFile(this.files?.[0], '${isSource ? "og" : `i18n:${localeCode}`}')" />
            <div class="mt-3 flex gap-2">
              <input id="${imageUrlId}" value="${escapeShareCardValue(isSource ? ogState.imageUrl : (draft.imageUrl || ""))}" oninput="${imageUrlChange}" placeholder="${isSource ? labels.imageUrlPlaceholder : labels.targetImageUrlPlaceholder}" class="min-w-0 flex-1 px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono bg-white" />
              <button type="button" onclick="document.getElementById('${imageFileInputId}')?.click()" class="px-3 py-2 text-xs border border-ink-200 rounded-lg bg-white hover:bg-ink-50">${isSource ? labels.upload : labels.uploadReplace}</button>
              ${!isSource ? `<button type="button" onclick="resetShareCardI18nImage('${localeCode}')" class="px-3 py-2 text-xs border border-ink-200 rounded-lg bg-white hover:bg-ink-50">${labels.reuse}</button>` : ""}
            </div>
            <div id="${imageFileNameId}" class="mt-2 text-[11px] text-ink-400">${escapeShareCardValue(isSource ? (ogState.imageFileName || labels.noFile) : (draft.imageFileName || (hasLocaleImageOverride ? labels.overrideFileName : labels.reuseFileName)))}</div>
            <div id="og-image-ratio-tip" class="mt-2">${isSource ? renderOgImageRatioTip(ogState) : `<span class="text-[11px] text-ink-400">${hasLocaleImageOverride ? labels.overrideTip : labels.reuseTip}</span>`}</div>
          </div>
        </div>
      </div>
    </div>
  `;
}

function renderShareCardUnifiedConfig(ogState, ogImagePreviewHtml, chatPreviews, postPreviews) {
  const postState = getShareCardPostFormState();
  const activeLocale = getActiveShareCardI18nLocale();
  const previewState = getShareCardPreviewStateForLocale(activeLocale, ogState, postState);
  const postPreviewValues = getShareCardPostPreviewValues(previewState);
  const standardPreviewHtml = `
    ${renderWhatsAppPreview(previewState, { useChannelImage: false, showOverrideControls: false })}
    ${renderDiscordDevicePreview(previewState, "pc", { useChannelImage: false, showOverrideControls: false })}
    ${renderDiscordDevicePreview(previewState, "mobile", { useChannelImage: false, showOverrideControls: false })}
    ${chatPreviews
      .filter((s) => !["WhatsApp", "Discord"].includes(s.channel))
      .map((s) => renderOgChannelPreview(s))
      .join("")}
  `;
  const bestPreviewHtml = `
    ${renderWhatsAppPreview(previewState)}
    ${renderDiscordDevicePreview(previewState, "pc")}
    ${renderDiscordDevicePreview(previewState, "mobile")}
  `;
  return `
    <div class="space-y-5">
      <div class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 bg-brand-50/70 flex items-start justify-between gap-3">
          <div>
            <h3 class="text-base font-semibold text-ink-900">信息输入区</h3>
            <p class="text-xs text-ink-500 mt-1">在信息输入区内横向切换语种；中文源默认是第一个 Tab，其它已选语种向右排开。</p>
          </div>
          <div class="flex items-center gap-2 flex-wrap justify-end">
            ${renderShareCardI18nConfig(ogState, postState)}
            <span class="badge bg-danger-50 text-danger-700">必填基础信息</span>
          </div>
        </div>
        <div class="p-5 space-y-5">
          <div class="rounded-2xl border border-ink-100 bg-white p-4">
            ${renderShareCardLocaleInputArea(ogState, postState, ogImagePreviewHtml)}
          </div>
        </div>
      </div>

      <div class="card overflow-visible" id="share-card-preview-tabs">
        <div class="px-5 py-4 border-b border-ink-100 bg-white rounded-t-xl">
          <div class="mb-3 flex items-center justify-between gap-3">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">预览区</h3>
              <p class="text-xs text-ink-500 mt-1">当前按 ${activeLocale.name}（${activeLocale.code}）预览；横向切换查看标准卡片、最佳效果卡片、Post 标准卡片。</p>
            </div>
            <span class="badge bg-ink-100 text-ink-700">点击 Tab 切换</span>
          </div>
          <div class="grid grid-cols-3 gap-2 rounded-xl bg-ink-50 p-1">
            <button type="button" data-preview-tab="standard" onclick="switchShareCardPreviewTab('standard')" class="share-card-preview-tab rounded-lg px-3 py-2 text-left transition bg-brand-900 text-white shadow-soft">
              <div class="flex items-center gap-2 text-xs font-semibold"><span class="inline-flex h-4 w-4 items-center justify-center rounded-full bg-danger-50 text-[10px] text-danger-700">!</span><span>Part 1 · 标准卡片预览</span></div>
              <div class="mt-0.5 text-[11px] opacity-75">基础 og:image</div>
            </button>
            <button type="button" data-preview-tab="best" onclick="switchShareCardPreviewTab('best')" class="share-card-preview-tab rounded-lg px-3 py-2 text-left transition text-ink-600 hover:bg-white">
              <div class="flex items-center gap-2 text-xs font-semibold"><span class="inline-flex h-4 w-4 items-center justify-center rounded-full bg-amber-50 text-[10px] text-amber-700">★</span><span>Part 2 · 最佳效果卡片预览</span></div>
              <div class="mt-0.5 text-[11px] opacity-75">渠道独立图</div>
            </button>
            <button type="button" data-preview-tab="post" onclick="switchShareCardPreviewTab('post')" class="share-card-preview-tab rounded-lg px-3 py-2 text-left transition text-ink-600 hover:bg-white">
              <div class="flex items-center gap-2 text-xs font-semibold"><span class="inline-flex h-4 w-4 items-center justify-center rounded-full bg-amber-50 text-[9px] font-bold text-amber-700">β</span><span>Part 3 · Post标准卡片预览</span><span class="badge bg-amber-50 text-amber-700 align-middle">Beta</span></div>
              <div class="mt-0.5 text-[11px] opacity-75">Post 链接预览</div>
            </button>
          </div>
        </div>
        <div class="p-5 bg-white overflow-visible rounded-b-xl">
          <div data-preview-panel="standard" class="share-card-preview-panel space-y-4">
            <div class="flex items-center justify-between gap-3">
              <div class="text-xs text-ink-500">使用统一信息输入区与基础 og:image 生成各渠道标准预览。</div>
              <span class="badge bg-danger-50 text-danger-700"><span class="mr-1">!</span>必选</span>
            </div>
            <div class="grid grid-cols-3 2xl:grid-cols-4 gap-4">${standardPreviewHtml}</div>
          </div>
          <div data-preview-panel="best" class="share-card-preview-panel hidden space-y-4">
            <div class="flex items-center justify-between gap-3">
              <div class="text-xs text-ink-500">可为 WhatsApp、Discord PC、Discord 移动单独上传图片或填写 URL；独立图优先级高于基础 og:image。</div>
              <span class="badge bg-amber-50 text-amber-700"><span class="mr-1">★</span>强烈推荐</span>
            </div>
            <div class="rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 leading-relaxed">
              <div class="font-semibold mb-1">最佳图片尺寸建议</div>
              <div>WhatsApp 推荐 1:1（1200×1200）；Discord PC 推荐 4:3（1200×900）；Discord 移动推荐 3:4（900×1200）。</div>
            </div>
            <div class="grid grid-cols-3 gap-4 overflow-visible">${bestPreviewHtml}</div>
          </div>
          <div data-preview-panel="post" class="share-card-preview-panel hidden space-y-4">
            <div class="flex items-center justify-between gap-3">
              <div class="text-xs text-ink-500">Post 不再有独立文字输入，统一读取信息输入区的标题、描述、URL、站点名、分享文案与基础图。</div>
              <span class="badge bg-amber-50 text-amber-700"><span class="mr-1 font-bold">β</span>Beta</span>
            </div>
            <div class="grid grid-cols-3 2xl:grid-cols-4 gap-4">
              ${postPreviews.map((s) => renderOgPostPreview(s, postPreviewValues)).join("")}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

function renderShareCardOgStep(ogState, ogImagePreviewHtml, chatPreviews) {
  const postState = getShareCardPostFormState();
  const generalPreviewHtml = `
    ${renderWhatsAppPreview(ogState, { useChannelImage: false, showOverrideControls: false })}
    ${renderDiscordDevicePreview(ogState, "pc", { useChannelImage: false, showOverrideControls: false })}
    ${renderDiscordDevicePreview(ogState, "mobile", { useChannelImage: false, showOverrideControls: false })}
    ${chatPreviews
      .filter((s) => !["WhatsApp", "Discord"].includes(s.channel))
      .map((s) => renderOgChannelPreview(s))
      .join("")}
  `;
  return `
    <div class="space-y-5">
      <div class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 bg-brand-50/70 flex items-start justify-between gap-3">
          <div>
            <h3 class="text-base font-semibold text-ink-900">步骤 1 · 私聊/群聊标准卡片</h3>
            <p class="text-xs text-ink-500 mt-1">这是创建分享卡片的必做步骤。基于 OG 字段生成各渠道私聊/群聊卡片分享预览。</p>
          </div>
          <span class="badge bg-danger-50 text-danger-700">必做</span>
        </div>
        <div class="p-5 grid grid-cols-12 gap-4 items-start">
          <label class="block col-span-6">
            <span class="flex items-center justify-between text-xs font-medium text-ink-500 mb-1"><span>og:title</span><span><span id="og-title-counter">${ogState.title.length}</span>/60</span></span>
            <input id="og-title-input" maxlength="60" value="${escapeShareCardValue(ogState.title)}" oninput="updateOgCardPreviews()" placeholder="请输入分享标题" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" />
          </label>
          <label class="block col-span-6">
            <span class="block text-xs font-medium text-ink-500 mb-1">og:url</span>
            <input id="og-url-input" value="${escapeShareCardValue(ogState.url)}" oninput="updateOgCardPreviews()" placeholder="https://example.com/share" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm font-mono" />
          </label>
          <label class="block col-span-8">
            <span class="flex items-center justify-between text-xs font-medium text-ink-500 mb-1"><span>og:description</span><span><span id="og-desc-counter">${ogState.desc.length}</span>/110</span></span>
            <textarea id="og-desc-input" maxlength="110" oninput="updateOgCardPreviews()" rows="3" placeholder="请输入分享描述" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm">${escapeShareCardValue(ogState.desc)}</textarea>
          </label>
          <label class="block col-span-4">
            <span class="flex items-center justify-between text-xs font-medium text-ink-500 mb-1"><span>og:site_name</span><span><span id="og-site-counter">${ogState.site.length}</span>/30</span></span>
            <input id="og-site-input" maxlength="30" value="${escapeShareCardValue(ogState.site)}" oninput="updateOgCardPreviews()" placeholder="请输入站点名 / 游戏名" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" />
          </label>
          <div class="col-span-12 rounded-xl border border-brand-100 bg-brand-50/40 p-3">
            <div class="mb-2 flex items-center justify-between gap-3">
              <div class="text-xs font-semibold text-ink-800">配置参数：分享文案 ${renderFieldHelp("全流程只保存一个分享文案参数，第三步 Post标准卡片复用同一字段。用于模拟用户发布 Post 时写在链接卡片上方的正文；私聊/群聊 OG 标准卡片本身不读取该字段。")}</div>
              <span class="badge bg-brand-100 text-brand-700 font-mono">share_copy</span>
            </div>
            <input id="post-copy-input" value="${escapeShareCardValue(postState.postCopy)}" oninput="updateShareCardPostPreviews()" placeholder="不填则使用：分享了一个游戏福利链接" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm bg-white" />
          </div>
          <div class="col-span-12 rounded-xl border border-ink-100 p-3">
            <div class="text-xs font-medium text-ink-500 mb-2">标准上传图 og:image（建议 1200×1200）</div>
            <div class="grid grid-cols-12 gap-3 items-stretch">
              <div id="og-image-preview" onclick="document.getElementById('og-image-file').click()" class="col-span-4 h-32 rounded-lg border-2 border-dashed border-ink-200 bg-ink-50 flex flex-col items-center justify-center text-xs text-ink-400 cursor-pointer hover:border-brand-300 overflow-hidden">
                ${ogImagePreviewHtml}
              </div>
              <div class="col-span-8 flex flex-col justify-center gap-2">
                <input id="og-image-file" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleShareCardImageFile(this.files?.[0], 'og')" />
                <div class="flex gap-2">
                  <input id="og-image-url-input" value="${escapeShareCardValue(ogState.imageUrl)}" oninput="updateOgCardPreviews()" placeholder="或填写图片 URL" class="flex-1 px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono" />
                  <button type="button" onclick="document.getElementById('og-image-file').click()" class="px-3 py-2 text-xs border border-ink-200 rounded-lg hover:bg-ink-50">选择文件</button>
                </div>
                <div id="og-image-file-name" class="text-[11px] text-ink-400">${escapeShareCardValue(ogState.imageFileName || "尚未上传图片")}</div>
                <div id="og-image-ratio-tip">${renderOgImageRatioTip(ogState)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card overflow-visible">
        <div class="p-5 bg-white overflow-visible rounded-xl">
          <div class="grid grid-cols-3 2xl:grid-cols-4 gap-4">
            ${generalPreviewHtml}
          </div>
        </div>
      </div>
    </div>
  `;
}

function renderShareCardBestStep(ogState) {
  const enhancedPreviewHtml = `
    ${renderWhatsAppPreview(ogState)}
    ${renderDiscordDevicePreview(ogState, "pc")}
    ${renderDiscordDevicePreview(ogState, "mobile")}
  `;
  return `
    <div id="share-card-best-step" class="space-y-5">
      <div class="card overflow-visible">
        <div class="px-5 py-4 border-b border-ink-100 bg-amber-50/70 flex items-start justify-between gap-3 rounded-t-xl">
          <div>
            <h3 class="text-base font-semibold text-ink-900">步骤 2 · 最佳效果卡片</h3>
            <p class="text-xs text-ink-500 mt-1">强烈建议配置。为 WhatsApp、Discord PC、Discord 移动单独准备最佳尺寸图片；调用时渠道独立图优先级高于基础 og:image。</p>
          </div>
          <span class="badge bg-amber-50 text-amber-700">强烈建议</span>
        </div>
        <div class="p-5 bg-white overflow-visible rounded-b-xl">
          <div class="mb-4 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 leading-relaxed">
            <div class="font-semibold mb-1">最佳图片尺寸建议</div>
            <div>WhatsApp 推荐 1:1（1200×1200）；Discord PC 推荐 4:3（1200×900）；Discord 移动推荐 3:4（900×1200）。</div>
          </div>
          <div class="grid grid-cols-3 gap-4 overflow-visible">
            ${enhancedPreviewHtml}
          </div>
        </div>
      </div>
      <div class="flex justify-between">
        <button onclick="goShareCardStep('og')" class="px-3 py-2 text-sm border border-ink-200 rounded-lg hover:bg-ink-50">返回步骤 1</button>
        <button onclick="goShareCardStep('post')" class="px-3 py-2 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">下一步：Post标准卡片</button>
      </div>
    </div>
  `;
}

function renderShareCardPostStep(ogState, postState, postPreviews) {
  const previewValues = getShareCardPostPreviewValues();
  const inheritedImage = ogState.imageDataUrl || ogState.imageUrl ? "已配置" : "未配置";
  return `
    <div id="share-card-post-step" class="space-y-5">
      <div class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 bg-indigo-50/70 flex items-start justify-between gap-3">
          <div>
            <h3 class="text-base font-semibold text-ink-900">步骤 3 · Post标准卡片 <span class="ml-2 badge bg-amber-50 text-amber-700 align-middle">Beta</span></h3>
            <p class="text-xs text-ink-500 mt-1">该能力仍在研发中；当前仅提供 Facebook Post、Instagram Post、X Post 配置。默认继承步骤 1 的 OG 标题、描述、URL 与图片生成预览。</p>
          </div>
          <span class="badge bg-amber-50 text-amber-700">Beta · 可选</span>
        </div>
        <div class="p-5 space-y-4">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-4 rounded-xl border border-ink-100 bg-white p-4">
              <div class="text-sm font-semibold text-ink-900">继承自步骤 1</div>
              <p class="text-[11px] text-ink-500 mt-1">Post 预览默认复用 OG 标题、描述、URL 与图片，不需要重复配置。</p>
              <div class="mt-3 space-y-2 text-xs">
                <div class="flex justify-between gap-3"><span class="text-ink-500">标题</span><span class="text-ink-900 truncate max-w-[180px]">${escapeShareCardValue(ogState.title || "未填写，预览使用默认标题")}</span></div>
                <div class="flex justify-between gap-3"><span class="text-ink-500">描述</span><span class="text-ink-900 truncate max-w-[180px]">${escapeShareCardValue(ogState.desc || "未填写，预览使用默认描述")}</span></div>
                <div class="flex justify-between gap-3"><span class="text-ink-500">站点名</span><span class="text-ink-900 truncate max-w-[180px]">${escapeShareCardValue(ogState.site || "example.com")}</span></div>
                <div class="flex justify-between gap-3"><span class="text-ink-500">URL</span><span class="text-ink-900 truncate max-w-[180px]">${escapeShareCardValue(ogState.url || "https://example.com/share")}</span></div>
                <div class="flex justify-between gap-3"><span class="text-ink-500">图片</span><span class="text-ink-900">${inheritedImage}</span></div>
              </div>
            </div>
            <div class="col-span-8 rounded-xl border border-brand-100 bg-brand-50/60 p-4">
              <div class="flex items-start justify-between gap-3">
                <div>
                  <div class="text-sm font-semibold text-ink-900">2.1 Post 公共增强字段（统一配置）</div>
                  <p class="text-xs text-ink-500 mt-1">Post 会继承步骤 1 的 OG 标题、描述、站点名、URL 与图片；这里仅配置非 OG 基础字段的公共增强项。</p>
                </div>
                <span class="badge bg-brand-100 text-brand-700">公共字段</span>
              </div>
              <div class="mt-4 grid grid-cols-2 gap-3">
                <label class="block col-span-2">
                  <span class="flex items-center justify-between text-xs text-ink-500 mb-1"><span>配置参数：分享文案（复用步骤 1） ${renderFieldHelp("全流程只保存一个分享文案参数 share_copy。这里与步骤 1 的分享文案是同一个字段；不是 OG/Twitter 元数据字段。")}</span><span class="badge bg-brand-50 text-brand-700 font-mono">share_copy</span></span>
                  <input id="post-copy-input" value="${escapeShareCardValue(postState.postCopy)}" oninput="updateShareCardPostPreviews()" placeholder="不填则使用：分享了一个游戏福利链接" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" />
                </label>
                <label class="block">
                  <span class="block text-xs text-ink-500 mb-1">统一图片说明 ${renderFieldHelp("统一作为 og:image:alt / twitter:image:alt 的默认值，提升无障碍体验并帮助平台理解分享图内容；不影响卡片视觉样式。")}</span>
                  <input id="common-image-alt-input" value="${escapeShareCardValue(postState.commonImageAlt)}" oninput="updateShareCardPostPreviews()" placeholder="不填则采用标题作为图片说明" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" />
                </label>
                <div class="rounded-lg border border-ink-100 bg-white p-3 text-xs text-ink-600 leading-relaxed">
                  <div class="font-semibold text-ink-800 mb-1">发布者显示名</div>
                  <div>预览统一显示为 <code class="px-1 bg-ink-100 rounded">用户社媒昵称</code>；真实分享时由用户授权的 Facebook / Instagram / X 账号自动填入，运营无需配置。</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="card overflow-hidden">
        <div class="p-5 bg-white border-b border-ink-100">
          <div class="mb-3 flex items-center justify-between">
            <div>
              <div class="text-sm font-semibold text-ink-900">Post 渠道字段读取清单</div>
              <div class="text-xs text-ink-500 mt-0.5">当前 Beta 仅校验 Facebook、Instagram、X 三个渠道预览；均继承步骤 1 的 OG 字段，并叠加 Post 公共增强字段。</div>
            </div>
            <span class="badge bg-ink-100 text-ink-700">${postPreviews.length} 个 Post 渠道</span>
          </div>
          <div class="grid grid-cols-3 2xl:grid-cols-4 gap-3">${renderPostFieldGuide(postPreviews)}</div>
        </div>
        <div class="p-5 grid grid-cols-3 2xl:grid-cols-4 gap-4 bg-white">
          ${postPreviews.map((s) => renderOgPostPreview(s)).join("")}
        </div>
      </div>
      <div class="flex justify-between">
        <button onclick="goShareCardStep('og')" class="px-3 py-2 text-sm border border-ink-200 rounded-lg hover:bg-ink-50">返回步骤 1</button>
        <button onclick="goShareCardStep('special')" class="px-3 py-2 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">下一步：增强卡片配置</button>
      </div>
    </div>
  `;
}

function renderShareCardSpecialStep(specialStyles) {
  const draft = getShareCardSpecialDraftState();
  const configs = getShareCardSpecialConfigs();
  const channelOptions = specialStyles.map((s) => `<option value="${escapeShareCardValue(s.channel)}" ${draft.channel === s.channel ? "selected" : ""}>${s.icon} ${s.channel}</option>`).join("");
  const styleOptions = specialStyles.map((s) => `<option value="${escapeShareCardValue(s.style)}" ${draft.style === s.style ? "selected" : ""}>${s.style}</option>`).join("");
  const livePreview = renderSpecialCardPreview(draft);
  const runtimeMeta = getDiscordRuntimePreviewMeta();
  return `
    <div id="share-card-special-step" class="space-y-5">
      <div class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 bg-amber-50/70 flex items-start justify-between gap-3">
          <div>
            <h3 class="text-base font-semibold text-ink-900">增强配置 <span class="ml-2 badge bg-amber-50 text-amber-700 align-middle">Beta</span></h3>
            <p class="text-xs text-ink-500 mt-1">支持 Discord Embed、Slack Block Kit、Telegram Inline 三种增强卡片配置；当前 Discord Rich Embed 区分可配置字段与推送时/平台生成字段。</p>
          </div>
          <span class="badge bg-ink-100 text-ink-700">可选 · 已配置 ${configs.length} 个</span>
        </div>
        <div class="p-5 grid grid-cols-12 gap-5 items-start">
          <div class="col-span-7 space-y-4">
              <div class="rounded-xl border border-[#5865f2]/20 bg-[#eef0ff] p-3 text-xs text-ink-700 leading-relaxed">
              <div class="font-semibold text-ink-900 mb-1">增强卡片独立字段</div>
              <div>在 OG 基础字段之外，增强卡片可额外控制标题、描述、大图、按钮动作、主题色等结构化展示细节；Timestamp、App Badge、互动数等运行态字段标记为“不需配置”。</div>
            </div>
            <div class="grid grid-cols-3 gap-3">
              <label class="block"><span class="block text-xs font-medium text-ink-500 mb-1">增强卡片类型</span><select id="special-channel-input" onchange="syncSpecialStyleByChannel(); updateShareCardSpecialDraftPreview();" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm bg-white">${channelOptions}</select></label>
              <label class="block"><span class="block text-xs font-medium text-ink-500 mb-1">卡片模型</span><select id="special-style-input" onchange="updateShareCardSpecialDraftPreview()" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm bg-white">${styleOptions}</select></label>
              <label class="block"><span class="block text-xs font-medium text-ink-500 mb-1">目标优化</span><select id="special-goal-input" onchange="updateShareCardSpecialDraftPreview()" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm bg-white"><option ${draft.goal === "点击率" ? "selected" : ""}>点击率</option><option ${draft.goal === "安装转化" ? "selected" : ""}>安装转化</option><option ${draft.goal === "回流唤起" ? "selected" : ""}>回流唤起</option></select></label>
            </div>
            <div class="grid grid-cols-2 gap-4">
              <div class="rounded-xl border border-ink-100 p-4 space-y-3">
                <div class="text-sm font-semibold text-ink-900">Bot Header</div>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Bot Name</span><input id="discord-bot-name-input" value="${escapeShareCardValue(draft.botName)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="Embed Bot" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" /></label>
                <div class="block">
                  <span class="block text-xs text-ink-500 mb-1">Bot Avatar</span>
                  <div class="grid grid-cols-[56px_1fr] gap-3 items-center">
                    <div id="discord-bot-avatar-preview" onclick="document.getElementById('discord-bot-avatar-file').click()" class="w-14 h-14 rounded-full border-2 border-dashed border-ink-200 bg-ink-50 flex items-center justify-center text-xs text-ink-400 cursor-pointer hover:border-brand-300 overflow-hidden">${draft.botAvatarDataUrl || draft.botAvatarUrl ? `<img src="${escapeShareCardValue(draft.botAvatarDataUrl || draft.botAvatarUrl)}" alt="Bot Avatar" class="w-full h-full object-cover" />` : "Bot"}</div>
                    <div class="space-y-2 min-w-0">
                      <input id="discord-bot-avatar-file" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleShareCardImageFile(this.files?.[0], 'botAvatar')" />
                      <div class="flex gap-2"><input id="discord-bot-avatar-input" value="${escapeShareCardValue(draft.botAvatarUrl)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="或填写 Bot Avatar URL" class="flex-1 px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono" /><button type="button" onclick="document.getElementById('discord-bot-avatar-file').click()" class="px-3 py-2 text-xs border border-ink-200 rounded-lg hover:bg-ink-50">上传</button></div>
                      <div id="discord-bot-avatar-file-name" class="text-[11px] text-ink-400">${escapeShareCardValue(draft.botAvatarFileName || "未上传头像")}</div>
                    </div>
                  </div>
                </div>
                ${renderRuntimeGeneratedField("App Badge", runtimeMeta.appBadge, "由 Discord 平台根据 Bot / App 身份自动展示，后台不提供配置项。")}
                ${renderRuntimeGeneratedField("Timestamp", runtimeMeta.timestamp, "由推送机器在消息发送时按实际发送时间实时注入，后台不预先配置。")}
              </div>
              <div class="rounded-xl border border-ink-100 p-4 space-y-3">
                <div class="text-sm font-semibold text-ink-900">Author</div>
                <div class="block">
                  <span class="block text-xs text-ink-500 mb-1">Author Icon</span>
                  <div class="grid grid-cols-[48px_1fr] gap-3 items-center">
                    <div id="discord-author-icon-preview" onclick="document.getElementById('discord-author-icon-file').click()" class="w-12 h-12 rounded-full border-2 border-dashed border-ink-200 bg-ink-50 flex items-center justify-center text-xs text-ink-400 cursor-pointer hover:border-brand-300 overflow-hidden">${draft.authorIconDataUrl || draft.authorIconUrl ? `<img src="${escapeShareCardValue(draft.authorIconDataUrl || draft.authorIconUrl)}" alt="Author Icon" class="w-full h-full object-cover" />` : escapeShareCardValue(draft.authorIcon || "🌐")}</div>
                    <div class="space-y-2 min-w-0">
                      <input id="discord-author-icon-file" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleShareCardImageFile(this.files?.[0], 'authorIcon')" />
                      <div class="flex gap-2"><input id="discord-author-icon-url-input" value="${escapeShareCardValue(draft.authorIconUrl)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="或填写 Author Icon URL" class="flex-1 px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono" /><button type="button" onclick="document.getElementById('discord-author-icon-file').click()" class="px-3 py-2 text-xs border border-ink-200 rounded-lg hover:bg-ink-50">上传</button></div>
                      <div id="discord-author-icon-file-name" class="text-[11px] text-ink-400">${escapeShareCardValue(draft.authorIconFileName || "未上传 Author Icon")}</div>
                    </div>
                  </div>
                </div>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Author Name</span><input id="discord-author-name-input" value="${escapeShareCardValue(draft.authorName)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="example.dev" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" /></label>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Author URL</span><input id="discord-author-url-input" value="${escapeShareCardValue(draft.authorUrl)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="https://example.dev" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono" /></label>
              </div>
              <div class="rounded-xl border border-ink-100 p-4 space-y-3">
                <div class="text-sm font-semibold text-ink-900">Embed Main Content</div>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Title</span><input id="special-title-input" value="${escapeShareCardValue(draft.title)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="Building Amazing Discord Bots 🤖" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" /></label>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Title URL</span><input id="discord-title-url-input" value="${escapeShareCardValue(draft.titleUrl)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="https://example.dev/blog/discord-bot-guide" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono" /></label>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Description</span><textarea id="special-desc-input" rows="3" oninput="updateShareCardSpecialDraftPreview()" placeholder="A comprehensive guide to building, deploying, and scaling Discord bots..." class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm">${escapeShareCardValue(draft.desc)}</textarea></label>
              </div>
              <div class="rounded-xl border border-ink-100 p-4 space-y-3">
                <div class="text-sm font-semibold text-ink-900">Thumbnail Image</div>
                <div id="special-card-image-preview" onclick="document.getElementById('special-card-image-file').click()" class="h-28 rounded-lg border-2 border-dashed border-ink-200 bg-ink-50 flex flex-col items-center justify-center text-xs text-ink-400 cursor-pointer hover:border-brand-300 overflow-hidden">${getShareCardPreviewImageHtml(draft, `<div class="text-sm font-medium text-ink-600">上传 Thumbnail Image</div><div class="text-[11px] mt-1">Discord PC 4:3 · 移动端 3:4</div>`)}</div>
                <input id="special-card-image-file" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleShareCardImageFile(this.files?.[0], 'special')" />
                <div class="mt-2 flex gap-2"><input id="special-image-url-input" value="${escapeShareCardValue(draft.imageUrl)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="或填写 Thumbnail Image URL" class="flex-1 px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono" /><button type="button" onclick="document.getElementById('special-card-image-file').click()" class="px-3 py-2 text-xs border border-ink-200 rounded-lg hover:bg-ink-50">选择文件</button></div>
                <input id="discord-thumbnail-url-input" value="${escapeShareCardValue(draft.thumbnailUrl)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="可单独填写 Thumbnail URL，优先于上传图" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono" />
                <div id="special-card-image-file-name" class="text-[11px] text-ink-400 mt-1.5">${escapeShareCardValue(draft.imageFileName || "尚未上传图片")}</div>
                <div class="grid grid-cols-2 gap-2 text-[11px]">
                  <div class="rounded-lg border border-[#5865f2]/20 bg-[#eef0ff] p-2">
                    <div class="font-semibold text-ink-800">Discord PC 推荐</div>
                    <div class="mt-1 text-ink-500">4:3 横向素材，例如 1200×900</div>
                    <div class="mt-2 aspect-[4/3] rounded bg-[#5865f2]/15 border border-[#5865f2]/20"></div>
                  </div>
                  <div class="rounded-lg border border-[#5865f2]/20 bg-[#eef0ff] p-2">
                    <div class="font-semibold text-ink-800">Discord 移动端推荐</div>
                    <div class="mt-1 text-ink-500">3:4 竖向素材，例如 900×1200</div>
                    <div class="mt-2 aspect-[3/4] rounded bg-[#5865f2]/15 border border-[#5865f2]/20"></div>
                  </div>
                </div>
              </div>
              <div class="rounded-xl border border-ink-100 p-4 space-y-3">
                <div class="text-sm font-semibold text-ink-900">Fields / Tags</div>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Fields（每行：Name | Value）</span><textarea id="discord-fields-input" rows="5" oninput="updateShareCardSpecialDraftPreview()" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono">${escapeShareCardValue(draft.fieldsText)}</textarea></label>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Tags（逗号分隔）</span><input id="discord-tags-input" value="${escapeShareCardValue(draft.tagsText)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="Discord, Bots, JavaScript" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" /></label>
              </div>
              <div class="rounded-xl border border-ink-100 p-4 space-y-3">
                <div class="text-sm font-semibold text-ink-900">Content / Footer</div>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Content Line</span><input id="discord-content-line-input" value="${escapeShareCardValue(draft.contentLine)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="🚀 Learn how to create powerful bots..." class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" /></label>
                <div class="block">
                  <span class="block text-xs text-ink-500 mb-1">Footer Icon</span>
                  <div class="grid grid-cols-[48px_1fr] gap-3 items-center">
                    <div id="discord-footer-icon-preview" onclick="document.getElementById('discord-footer-icon-file').click()" class="w-12 h-12 rounded-full border-2 border-dashed border-ink-200 bg-ink-50 flex items-center justify-center text-xs text-ink-400 cursor-pointer hover:border-brand-300 overflow-hidden">${draft.footerIconDataUrl || draft.footerIconUrl ? `<img src="${escapeShareCardValue(draft.footerIconDataUrl || draft.footerIconUrl)}" alt="Footer Icon" class="w-full h-full object-cover" />` : escapeShareCardValue(draft.footerIcon || "🔗")}</div>
                    <div class="space-y-2 min-w-0">
                      <input id="discord-footer-icon-file" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleShareCardImageFile(this.files?.[0], 'footerIcon')" />
                      <div class="flex gap-2"><input id="discord-footer-icon-url-input" value="${escapeShareCardValue(draft.footerIconUrl)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="或填写 Footer Icon URL" class="flex-1 px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono" /><button type="button" onclick="document.getElementById('discord-footer-icon-file').click()" class="px-3 py-2 text-xs border border-ink-200 rounded-lg hover:bg-ink-50">上传</button></div>
                      <div id="discord-footer-icon-file-name" class="text-[11px] text-ink-400">${escapeShareCardValue(draft.footerIconFileName || "未上传 Footer Icon")}</div>
                    </div>
                  </div>
                </div>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Footer Text</span><input id="discord-footer-text-input" value="${escapeShareCardValue(draft.footerText)}" oninput="updateShareCardSpecialDraftPreview()" placeholder="https://example.dev/blog/discord-bot-guide" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm" /></label>
              </div>
              <div class="rounded-xl border border-ink-100 p-4 space-y-3">
                <div class="text-sm font-semibold text-ink-900">Buttons</div>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Buttons（每行：Label | URL | Primary/Secondary | Icon）</span><textarea id="discord-buttons-input" rows="5" oninput="updateShareCardSpecialDraftPreview()" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-xs font-mono">${escapeShareCardValue(draft.buttonsText)}</textarea></label>
              </div>
              <div class="rounded-xl border border-ink-100 p-4 space-y-3">
                <div class="text-sm font-semibold text-ink-900">Theme / Runtime / Note</div>
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Embed Color</span><input id="special-color-input" type="color" value="${escapeShareCardValue(draft.color || "#5865F2")}" oninput="updateShareCardSpecialDraftPreview()" class="w-full h-10 p-1 border border-ink-200 rounded-lg bg-white cursor-pointer" /></label>
                ${renderRuntimeGeneratedField("Reaction", runtimeMeta.reactionIcon + " " + runtimeMeta.reactionCount, "Reaction 图标与数量属于消息发送后的用户互动/机器人运行态数据，不作为卡片后台配置字段。")}
                <input id="special-cta-input" type="hidden" value="${escapeShareCardValue(draft.cta)}" />
                <label class="block"><span class="block text-xs text-ink-500 mb-1">Note</span><textarea id="special-note-input" rows="3" oninput="updateShareCardSpecialDraftPreview()" placeholder="配置备注" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm">${escapeShareCardValue(draft.note)}</textarea></label>
                <button type="button" onclick="addShareCardSpecialConfig()" class="w-full px-3 py-2 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">添加 Discord Rich Embed 配置</button>
              </div>
            </div>
          </div>
          <div class="col-span-5">
            <div class="text-sm font-semibold text-ink-900 mb-2">当前配置实时预览</div>
            <div id="special-live-preview">${livePreview}</div>
          </div>
        </div>
      </div>
      <div class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 bg-white flex items-center justify-between">
          <div>
            <h3 class="text-sm font-semibold text-ink-900">已添加的增强卡片配置</h3>
            <p class="text-xs text-ink-500 mt-1">可保存 Discord、Slack、Telegram 的增强卡片字段，后续分享活动配置可按渠道匹配引用。</p>
          </div>
          <span class="badge bg-ink-100 text-ink-700">${configs.length} 个配置</span>
        </div>
        <div class="p-5 grid grid-cols-3 2xl:grid-cols-4 gap-4 bg-white">
          ${configs.length ? configs.map((config) => renderSpecialCardPreview(config, `<div class="px-3 pb-3"><button onclick="removeShareCardSpecialConfig('${config.id}')" class="w-full px-2 py-1.5 text-xs border border-danger-200 text-danger-600 rounded-lg hover:bg-danger-50">删除该渠道配置</button></div>`)).join("") : `<div class="col-span-3 rounded-xl border border-dashed border-ink-200 p-8 text-center text-sm text-ink-400">还没有添加增强卡片配置。左侧填写后点击“添加增强卡片配置”。</div>`}
        </div>
      </div>
    </div>
  `;
}

Pages.enhancedConfigBeta = function () {
  const specialStyles = getShareCardSpecialStyles();
  window.PageHooks = window.PageHooks || {};
  window.PageHooks.mounted = (path) => {
    if (path === "/ops/enhanced-config-beta") {
      bindShareCardSpecialRealtime();
      bindFieldHelpTooltips();
      updateShareCardSpecialDraftPreview();
    }
  };
  return `
    ${UI.pageHeader({
      title: "增强配置Beta",
      desc: "独立管理 Discord Embed、Slack Block Kit、Telegram Inline 等增强卡片配置；功能与原第三步增强卡片配置保持一致。",
      actions: `<button onclick="UI.toast('增强配置已保存', 'success')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">保存增强配置</button>`,
    })}
    ${renderShareCardSpecialStep(specialStyles)}
  `;
};

Pages.shareCardConfig = function () {
  const styles = getShareCardStyles();
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const params = new URLSearchParams(query);
  const ogState = getShareCardOgFormState();
  const ogImagePreviewHtml = getShareCardPreviewImageHtml(ogState, `
    <div class="text-sm font-medium text-ink-600">上传分享图</div>
    <div class="text-[11px] mt-1">WhatsApp 推荐 1:1（1200×1200）· PNG/JPG/WebP · &lt;2MB</div>
  `);
  const postChannelNames = getShareCardPostChannelNames();
  const baseChatPreviews = styles.filter((s) => !postChannelNames.includes(s.channel) || ["Discord", "Telegram"].includes(s.channel));
  const priorityChatChannels = ["WhatsApp", "Discord"];
  const chatPreviews = [
    ...priorityChatChannels.map((channel) => baseChatPreviews.find((s) => s.channel === channel)).filter(Boolean),
    ...baseChatPreviews.filter((s) => !priorityChatChannels.includes(s.channel)),
  ];
  const postPreviews = styles.filter((s) => postChannelNames.includes(s.channel));
  window.PageHooks = window.PageHooks || {};
  window.PageHooks.mounted = (path) => {
    if (path === "/ops/share-card-config") {
      updateOgCardPreviews();
      bindShareCardPostRealtime();
      bindFieldHelpTooltips();
    }
  };
  return `
    ${UI.pageHeader({
      title: "分享卡片配置",
      desc: "先维护中文源内容与图片，再选择目标语言导出 CSV，上传校对后的多语言 CSV 后可在页面内查看内容与预览。",
      actions: `<button onclick="UI.toast('分享卡片配置已保存', 'success')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">保存分享卡片</button>`,
    })}
    ${renderShareCardUnifiedConfig(ogState, ogImagePreviewHtml, chatPreviews, postPreviews)}
  `;
};

window.selectShareCardLocale = function (localeCode) {
  window.__shareCardI18nLocale = localeCode || "en-US";
  saveShareCardOgFormState();
  saveShareCardPostFormState();
  renderRoute();
};

window.togglePendingShareCardI18nLocale = function (localeCode, checked) {
  const pending = getPendingShareCardI18nLocales();
  if (checked) pending.add(localeCode); else pending.delete(localeCode);
  window.__shareCardI18nPendingLocales = Array.from(pending);
};

window.confirmShareCardI18nLocales = function () {
  const pending = Array.from(getPendingShareCardI18nLocales());
  const defaultCode = getShareCardDefaultLanguageCode();
  if (!pending.includes(defaultCode)) pending.unshift(defaultCode);
  window.__shareCardI18nSelectedLocales = pending;
  window.__shareCardI18nLocale = pending[0] || "en-US";
  window.__shareCardI18nLocaleTab = "zh-CN";
  saveShareCardOgFormState();
  saveShareCardPostFormState();
  UI.toast(`已选择 ${pending.length} 种多语言`, "success");
  renderRoute();
};

window.toggleShareCardI18nLocale = function (localeCode, checked) {
  window.togglePendingShareCardI18nLocale(localeCode, checked);
};

window.setShareCardDefaultLanguage = function (localeCode) {
  const target = getShareLanguageCatalog().find((locale) => locale.code === localeCode && locale.code !== "zh-CN") || getShareLanguageCatalog().find((locale) => locale.code === "en-US");
  window.__shareLanguageDefaultLocale = target?.code || "en-US";
  window.__shareCardI18nDefaultLocale = window.__shareLanguageDefaultLocale;
  const selected = new Set(getShareLanguageSelectedCodes());
  selected.add(window.__shareLanguageDefaultLocale);
  window.__shareLanguageSelectedLocales = Array.from(selected).filter((code) => code !== "zh-CN");
  window.__shareCardI18nSelectedLocales = window.__shareLanguageSelectedLocales;
  window.__shareCardI18nPendingLocales = window.__shareLanguageSelectedLocales;
  saveShareCardOgFormState();
  saveShareCardPostFormState();
  UI.toast(`默认语言已设置为 ${getShareLanguageChineseName(target) || "英语（美国）"}`, "success");
  renderRoute();
};

window.toggleShareLanguageSelection = function (localeCode, checked) {
  const selected = new Set(getShareLanguageSelectedCodes().filter((code) => code !== "zh-CN"));
  if (checked) selected.add(localeCode); else selected.delete(localeCode);
  selected.add(getShareCardDefaultLanguageCode());
  window.__shareLanguageSelectedLocales = Array.from(selected);
  window.__shareCardI18nSelectedLocales = window.__shareLanguageSelectedLocales;
  window.__shareCardI18nPendingLocales = window.__shareLanguageSelectedLocales;
};

window.setShareLanguageDefaultFromPage = function (localeCode) {
  const target = getShareLanguageCatalog().find((locale) => locale.code === localeCode && locale.code !== "zh-CN") || getShareLanguageCatalog().find((locale) => locale.code === "en-US");
  window.__shareLanguageDefaultLocale = target?.code || "en-US";
  window.__shareCardI18nDefaultLocale = window.__shareLanguageDefaultLocale;
  const selected = new Set(getShareLanguageSelectedCodes().filter((code) => code !== "zh-CN"));
  selected.add(window.__shareLanguageDefaultLocale);
  window.__shareLanguageSelectedLocales = Array.from(selected);
  window.__shareCardI18nSelectedLocales = window.__shareLanguageSelectedLocales;
  window.__shareCardI18nPendingLocales = window.__shareLanguageSelectedLocales;
  renderRoute();
};

window.saveShareLanguages = async function (returnPath = "/ops/share-card-config") {
  const selected = new Set(getShareLanguageSelectedCodes().filter((code) => code !== "zh-CN"));
  selected.add(getShareCardDefaultLanguageCode());
  window.__shareLanguageSelectedLocales = Array.from(selected);
  window.__shareCardI18nSelectedLocales = window.__shareLanguageSelectedLocales;
  window.__shareCardI18nPendingLocales = window.__shareLanguageSelectedLocales;
  try {
    await contentApi.updateLanguages({
      locales: window.__shareLanguageSelectedLocales,
      defaultLocale: getShareCardDefaultLanguageCode(),
    });
    await invalidateAndRefresh();
    const isAdminReturn = String(returnPath || "").startsWith("/admin/");
    UI.toast(isAdminReturn ? "多语言全局配置已保存" : "多语言选择已确认", "success");
    navigate(returnPath);
  } catch (err) {
    UI.toast(err?.message || "保存失败", "error");
  }
};

window.addCustomShareLanguage = function () {
  const codeInput = document.getElementById("custom-share-language-code");
  const nameInput = document.getElementById("custom-share-language-name");
  const code = (codeInput?.value || "").trim();
  const name = (nameInput?.value || "").trim() || code;
  if (!/^[A-Za-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/.test(code)) {
    UI.toast("请输入有效的 BCP 47 标签，例如 ur-PK、en-CA", "warning");
    return;
  }
  const normalized = code.split("-").map((part, idx) => idx === 0 ? part.toLowerCase() : (part.length === 2 ? part.toUpperCase() : part)).join("-");
  if (getShareLanguageCatalog().some((locale) => locale.code === normalized)) {
    UI.toast("该语言标签已存在", "info");
    return;
  }
  window.__shareLanguageCustomLocales = [...(window.__shareLanguageCustomLocales || []), { code: normalized, name, zhName: name, region: "自定义", status: "draft", owner: "待翻译", progress: 0 }];
  const selected = new Set(getShareLanguageSelectedCodes().filter((item) => item !== "zh-CN"));
  selected.add(normalized);
  window.__shareLanguageSelectedLocales = Array.from(selected);
  window.__shareCardI18nSelectedLocales = window.__shareLanguageSelectedLocales;
  window.__shareCardI18nPendingLocales = window.__shareLanguageSelectedLocales;
  UI.toast(`已添加 ${normalized}`, "success");
  renderRoute();
};

function saveShareCardI18nDraft(localeCode) {
  if (!localeCode || localeCode === "zh-CN") return;
  const drafts = getShareCardI18nManualDrafts();
  const current = drafts[localeCode] || {};
  const getValue = (id, fallback = "") => document.getElementById(id)?.value ?? fallback;
  const labels = getShareCardI18nFieldLabels(localeCode);
  const imageUrl = getValue(`i18n-${localeCode}-image-url-input`, current.imageUrl || "");
  drafts[localeCode] = {
    title: getValue(`i18n-${localeCode}-title-input`, current.title || ""),
    desc: getValue(`i18n-${localeCode}-desc-input`, current.desc || ""),
    copy: getValue(`i18n-${localeCode}-copy-input`, current.copy || ""),
    site: getValue(`i18n-${localeCode}-site-input`, current.site || ""),
    imageUrl,
    imageDataUrl: imageUrl ? "" : (current.imageDataUrl || ""),
    imageFileName: imageUrl ? labels.overrideFileName : (current.imageFileName || ""),
  };
}

function saveShareCardActiveI18nDraft() {
  saveShareCardI18nDraft(window.__shareCardI18nLocaleTab || "zh-CN");
}

window.updateShareCardI18nDraft = function (localeCode) {
  saveShareCardI18nDraft(localeCode);
  const draft = getShareCardI18nManualDrafts()[localeCode] || {};
  const ogState = getShareCardOgFormState();
  const preview = document.getElementById(`i18n-${localeCode}-image-preview`);
  const fileName = document.getElementById(`i18n-${localeCode}-image-file-name`);
  if (preview) {
    const labels = getShareCardI18nFieldLabels(localeCode);
    preview.innerHTML = getShareCardPreviewImageHtml({ imageDataUrl: draft.imageDataUrl || ogState.imageDataUrl || "", imageUrl: draft.imageDataUrl ? "" : (draft.imageUrl || ogState.imageUrl || "") }, `<div class="text-sm font-medium text-ink-600">${labels.defaultReuseTitle}</div><div class="text-[11px] mt-1">${labels.defaultReuseHint}</div>`);
  }
  if (fileName) {
    const labels = getShareCardI18nFieldLabels(localeCode);
    fileName.textContent = draft.imageFileName || (draft.imageUrl ? labels.overrideFileName : labels.reuseFileName);
  }
  if ((window.__shareCardI18nLocaleTab || "zh-CN") === localeCode) {
    updateShareCardPreviewDom(getActiveShareCardPreviewState());
  }
};

window.resetShareCardI18nImage = function (localeCode) {
  saveShareCardI18nDraft(localeCode);
  const drafts = getShareCardI18nManualDrafts();
  drafts[localeCode] = {
    ...(drafts[localeCode] || {}),
    imageUrl: "",
    imageDataUrl: "",
    imageFileName: "",
  };
  UI.toast("已恢复复用中文源图片", "success");
  renderRoute();
};

window.switchShareCardI18nTab = function (localeCode) {
  saveShareCardActiveI18nDraft();
  window.__shareCardI18nLocaleTab = localeCode || "zh-CN";
  saveShareCardOgFormState();
  saveShareCardPostFormState();
  renderRoute();
};

window.addShareCardLocale = function () {
  UI.toast("可在这里扩展更多 locale；原型中先提供常用出海语言", "info");
};

window.syncShareCardBaseLocale = function () {
  UI.toast("中文源内容来自下方信息输入区，请先保存分享卡片后再导出 CSV", "info");
};

function escapeCsvCell(value) {
  return `"${String(value ?? "").replace(/"/g, '""')}"`;
}

window.exportShareCardI18nCsv = function () {
  const ogState = saveShareCardOgFormState();
  const postState = saveShareCardPostFormState();
  const source = getShareCardLocaleDraft(SHARE_CARD_I18N_LOCALES[0], ogState, postState);
  const selectedLocales = SHARE_CARD_I18N_LOCALES.filter((locale) => locale.code !== "zh-CN" && getSelectedShareCardI18nLocales().has(locale.code));
  if (!selectedLocales.length) {
    UI.toast("请先选择至少一种目标语言", "warning");
    return;
  }
  const headers = ["field", "zh-CN", ...selectedLocales.map((locale) => locale.code), "comment"];
  const rows = [
    ["og:title", source.title, ...selectedLocales.map(() => ""), "分享标题，建议不超过 60 字符"],
    ["og:description", source.desc, ...selectedLocales.map(() => ""), "分享描述，建议不超过 110 字符"],
    ["share_copy", source.copy, ...selectedLocales.map(() => ""), "Post 分享文案"],
    ["og:site_name", source.site, ...selectedLocales.map(() => ""), "站点名 / 游戏名"],
  ];
  const csv = [headers, ...rows].map((row) => row.map(escapeCsvCell).join(",")).join("\n");
  const blob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `share-card-zh-cn-source-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
  UI.toast(`已下载中文包 CSV，包含 ${selectedLocales.length} 种目标语言`, "success");
};

function parseSimpleCsv(text) {
  const rows = [];
  let row = [], cell = "", quoted = false;
  for (let i = 0; i < text.length; i += 1) {
    const ch = text[i];
    const next = text[i + 1];
    if (quoted && ch === '"' && next === '"') { cell += '"'; i += 1; continue; }
    if (ch === '"') { quoted = !quoted; continue; }
    if (!quoted && ch === ",") { row.push(cell); cell = ""; continue; }
    if (!quoted && (ch === "\n" || ch === "\r")) {
      if (ch === "\r" && next === "\n") i += 1;
      row.push(cell); rows.push(row); row = []; cell = ""; continue;
    }
    cell += ch;
  }
  row.push(cell);
  if (row.some((item) => item !== "")) rows.push(row);
  return rows;
}

window.importShareCardI18nCsv = function (file) {
  if (!file) return;
  if (!file.name.toLowerCase().endsWith(".csv") && file.type !== "text/csv") {
    UI.toast("请上传 CSV 文件", "error");
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    const text = String(reader.result || "").replace(/^\uFEFF/, "");
    const parsed = parseSimpleCsv(text);
    const headers = (parsed[0] || []).map((item) => item.trim());
    const indexOf = (name) => headers.indexOf(name);
    const fieldIdx = indexOf("field");
    const sourceIdx = indexOf("zh-CN");
    const legacyLocaleIdx = indexOf("locale");
    const legacyLanguageIdx = indexOf("language");
    const legacySourceIdx = indexOf("source_text_zh_cn");
    const legacyTargetIdx = indexOf("target_text");
    let rows = [];
    if (legacyLocaleIdx >= 0 && legacyTargetIdx >= 0) {
      rows = parsed.slice(1).map((cols) => ({
        locale: cols[legacyLocaleIdx] || "",
        language: cols[legacyLanguageIdx] || "",
        field: cols[fieldIdx] || "",
        sourceText: cols[legacySourceIdx] || "",
        targetText: cols[legacyTargetIdx] || "",
      })).filter((row) => row.locale && row.field);
    } else {
      const localeColumns = headers
        .map((name, idx) => ({ name, idx }))
        .filter((item) => !["field", "zh-CN", "comment"].includes(item.name));
      rows = parsed.slice(1).flatMap((cols) => localeColumns.map((column) => {
        const locale = SHARE_CARD_I18N_LOCALES.find((item) => item.code === column.name);
        return {
          locale: column.name,
          language: locale?.name || column.name,
          field: cols[fieldIdx] || "",
          sourceText: cols[sourceIdx] || "",
          targetText: cols[column.idx] || "",
        };
      })).filter((row) => row.locale && row.field);
    }
    window.__shareCardI18nImportedRows = rows;
    window.__shareCardI18nSelectedLocales = Array.from(new Set(rows.map((row) => row.locale)));
    window.__shareCardI18nLocale = window.__shareCardI18nSelectedLocales[0] || "en-US";
    UI.toast(`已读取 ${rows.length} 条多语言包内容，并在配置界面呈现`, "success");
    renderRoute();
  };
  reader.readAsText(file, "utf-8");
};

window.switchShareCardPreviewTab = function (tab) {
  document.querySelectorAll(".share-card-preview-tab").forEach((el) => {
    const active = el.dataset.previewTab === tab;
    el.classList.toggle("bg-brand-900", active);
    el.classList.toggle("text-white", active);
    el.classList.toggle("shadow-soft", active);
    el.classList.toggle("text-ink-600", !active);
    el.classList.toggle("hover:bg-white", !active);
  });
  document.querySelectorAll(".share-card-preview-panel").forEach((el) => {
    el.classList.toggle("hidden", el.dataset.previewPanel !== tab);
  });
};

window.updateWhatsAppPreview = function (ogState = getShareCardOgFormState()) {
  const { hints } = getWhatsAppPreviewValues();
  document.querySelectorAll(".whatsapp-rich-preview-shell").forEach((shell) => {
    const useChannelImage = shell.dataset.useChannelImage !== "0";
    const previewState = useChannelImage ? getPreviewStateWithChannelImage(ogState, "whatsapp") : ogState;
    shell.innerHTML = renderWhatsAppRichPreviewShell(previewState);
    const mode = shell.closest(".whatsapp-preview-card")?.querySelector(".whatsapp-preview-mode");
    if (mode) mode.textContent = getWhatsAppImageVariant(previewState).label;
  });
  const hintList = document.getElementById("whatsapp-preview-hints");
  if (hintList) {
    hintList.innerHTML = hints
      .map((item) => `<li class="flex gap-1.5"><span class="text-brand-600">•</span><span>${escapeShareCardValue(item)}</span></li>`)
      .join("");
  }
};

function updateShareCardPreviewDom(previewState) {
  const title = previewState.title || "分享标题预览";
  const desc = previewState.desc || "分享描述会在这里展示。";
  const url = previewState.url || "https://example.com/share";
  const site = previewState.site || "example.com";
  const imageUrl = previewState.imageDataUrl || previewState.imageUrl || "";
  document.querySelectorAll(".og-preview-title").forEach((el) => { el.textContent = title; });
  document.querySelectorAll(".og-preview-desc").forEach((el) => { el.textContent = desc; });
  document.querySelectorAll(".og-preview-url").forEach((el) => { el.textContent = url; });
  document.querySelectorAll(".og-preview-site").forEach((el) => { el.textContent = site; });
  document.querySelectorAll(".og-preview-image").forEach((el) => {
    el.classList.add("w-full", "h-full", "min-h-0", "overflow-hidden");
    if (imageUrl) {
      el.innerHTML = `<img src="${escapeShareCardValue(imageUrl)}" alt="分享卡片图片" class="block w-full h-full max-w-full max-h-full object-cover" />`;
    } else {
      el.textContent = "og:image";
    }
  });
  updateWhatsAppPreview(previewState);
  updateDiscordDevicePreviews(previewState);
  updateShareCardPostPreviews();
}

window.updateOgCardPreviews = function () {
  const state = saveShareCardOgFormState();
  const postState = getShareCardPostFormState();
  const previewState = getActiveShareCardPreviewState(state, postState);
  const setCount = (id, value) => { const el = document.getElementById(id); if (el) el.textContent = String(value.length); };
  setCount("og-title-counter", state.title);
  setCount("og-desc-counter", state.desc);
  setCount("og-site-counter", state.site);
  updateShareCardPreviewDom(previewState);
  syncOgImageDimensions(state);
  syncChannelImageDimensions(state, "whatsapp");
  syncChannelImageDimensions(state, "discordPc");
  syncChannelImageDimensions(state, "discordMobile");
  updateOgImageRatioTip(state);
};

window.updateShareCardPostPreviews = function () {
  const postState = saveShareCardPostFormState();
  const previewState = getActiveShareCardPreviewState(getShareCardOgFormState(), postState);
  const values = getShareCardPostPreviewValues(previewState);
  document.querySelectorAll(".post-preview-copy").forEach((el) => { el.textContent = values.postCopy; });
  document.querySelectorAll(".publisher-preview").forEach((el) => { el.textContent = values.publisherName; });
  document.querySelectorAll(".fb-preview-type").forEach((el) => { el.textContent = values.fbOgType; });
  document.querySelectorAll(".fb-preview-size").forEach((el) => { el.textContent = values.fbImageSize; });
  document.querySelectorAll(".fb-preview-alt").forEach((el) => { el.textContent = values.fbImageAlt; });
  document.querySelectorAll(".twitter-preview-card").forEach((el) => { el.textContent = values.twitterCard; });
  document.querySelectorAll(".twitter-preview-site").forEach((el) => { el.textContent = values.twitterSite; });
  document.querySelectorAll(".twitter-preview-creator").forEach((el) => { el.textContent = values.twitterCreator; });
  document.querySelectorAll(".twitter-preview-alt").forEach((el) => { el.textContent = values.twitterImageAlt; });
};

window.bindShareCardPostRealtime = function () {
  const container = document.getElementById("share-card-post-step");
  if (!container || container.dataset.realtimeBound === "1") return;
  container.dataset.realtimeBound = "1";
  const refresh = () => updateShareCardPostPreviews();
  container.querySelectorAll("input, textarea, select").forEach((el) => {
    el.addEventListener("input", refresh);
    el.addEventListener("change", refresh);
  });
};

window.bindFieldHelpTooltips = function () {
  const triggers = document.querySelectorAll(".field-help-trigger:not([data-help-bound='1'])");
  if (!triggers.length) return;
  let tip = document.getElementById("field-help-tooltip");
  if (!tip) {
    tip = document.createElement("div");
    tip.id = "field-help-tooltip";
    tip.className = "fixed z-[9999] hidden w-72 rounded-lg bg-ink-900 px-3 py-2 text-[11px] leading-relaxed text-white shadow-pop pointer-events-none";
    document.body.appendChild(tip);
  }
  const place = (trigger) => {
    tip.textContent = trigger.dataset.help || "";
    tip.classList.remove("hidden");
    const rect = trigger.getBoundingClientRect();
    const margin = 12;
    const width = tip.offsetWidth || 288;
    const height = tip.offsetHeight || 80;
    let left = rect.left + rect.width / 2 - width / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - width - margin));
    let top = rect.bottom + 8;
    if (top + height > window.innerHeight - margin) top = rect.top - height - 8;
    tip.style.left = `${left}px`;
    tip.style.top = `${Math.max(margin, top)}px`;
  };
  triggers.forEach((trigger) => {
    trigger.dataset.helpBound = "1";
    trigger.addEventListener("mouseenter", () => place(trigger));
    trigger.addEventListener("focus", () => place(trigger));
    trigger.addEventListener("mouseleave", () => tip.classList.add("hidden"));
    trigger.addEventListener("blur", () => tip.classList.add("hidden"));
  });
};

window.updateShareCardSpecialDraftPreview = function () {
  const draft = saveShareCardSpecialDraftState();
  const target = document.getElementById("special-live-preview");
  if (target) target.innerHTML = renderSpecialCardPreview(draft);
};

window.bindShareCardSpecialRealtime = function () {
  const container = document.getElementById("share-card-special-step");
  if (!container || container.dataset.realtimeBound === "1") return;
  container.dataset.realtimeBound = "1";
  const refresh = () => updateShareCardSpecialDraftPreview();
  container.querySelectorAll("input, textarea, select").forEach((el) => {
    el.addEventListener("input", refresh);
    el.addEventListener("change", refresh);
  });
};

window.syncSpecialStyleByChannel = function () {
  const channel = document.getElementById("special-channel-input")?.value;
  const style = getShareCardStyles().find((s) => s.channel === channel);
  const styleInput = document.getElementById("special-style-input");
  if (style && styleInput) styleInput.value = style.style;
};

window.addShareCardSpecialConfig = async function () {
  const draft = stripDiscordRuntimeOnlyFields({ ...saveShareCardSpecialDraftState() });
  try {
    const { data: config } = await contentApi.createSpecialCard(draft);
    getShareCardSpecialConfigs().push(config);
    await invalidateAndRefresh();
    UI.toast(`${config.channel || draft.channel} 增强卡片配置已添加`, "success");
    renderRoute();
  } catch (err) {
    UI.toast(err?.message || "添加失败", "error");
  }
};

window.removeShareCardSpecialConfig = function (id) {
  window.shareCardSpecialConfigs = getShareCardSpecialConfigs().filter((config) => config.id !== id);
  UI.toast("已删除特殊渠道配置", "success");
  renderRoute();
};

window.goShareCardStep = function (step) {
  saveShareCardOgFormState();
  saveShareCardPostFormState();
  saveShareCardSpecialDraftState();
  navigate(`/ops/share-card-config?step=${step}`);
};

window.goShareCardTab = function (tab) {
  saveShareCardOgFormState();
  saveShareCardPostFormState();
  goShareCardStep(tab === "special" ? "special" : "og");
};

window.goShareCardPreview = function (preview) {
  saveShareCardOgFormState();
  saveShareCardPostFormState();
  goShareCardStep(preview === "post" ? "post" : "og");
};

window.handleShareCardImageFile = function (file, target = "og") {
  if (!file) return;
  if (!file.type.startsWith("image/")) {
    UI.toast("请选择图片文件", "error");
    return;
  }
  if (file.size > 2 * 1024 * 1024) {
    UI.toast("图片不能超过 2MB", "error");
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    const dataUrl = reader.result;
    const channelFields = getShareCardChannelImageFields(target);
    const displayFileName = `${file.name} · ${(file.size / 1024).toFixed(0)}KB`;
    const applyUpload = (imageMeta = {}) => {
      const i18nLocaleCode = target.startsWith("i18n:") ? target.split(":")[1] : "";
      const previewId = channelFields?.previewId || (i18nLocaleCode ? `i18n-${i18nLocaleCode}-image-preview` : target === "footerIcon" ? "discord-footer-icon-preview" : target === "authorIcon" ? "discord-author-icon-preview" : target === "botAvatar" ? "discord-bot-avatar-preview" : target === "special" ? "special-card-image-preview" : "og-image-preview");
      const fileNameId = channelFields?.fileNameId || (i18nLocaleCode ? `i18n-${i18nLocaleCode}-image-file-name` : target === "footerIcon" ? "discord-footer-icon-file-name" : target === "authorIcon" ? "discord-author-icon-file-name" : target === "botAvatar" ? "discord-bot-avatar-file-name" : target === "special" ? "special-card-image-file-name" : "og-image-file-name");
      const preview = document.getElementById(previewId);
      const fileName = document.getElementById(fileNameId);
      const width = imageMeta.width || 0;
      const height = imageMeta.height || 0;
      if (preview) {
        preview.innerHTML = `<img src="${dataUrl}" alt="分享卡片图片" class="w-full h-full object-cover" />`;
      }
      if (fileName) fileName.textContent = displayFileName;
      if (i18nLocaleCode) {
        saveShareCardI18nDraft(i18nLocaleCode);
        const drafts = getShareCardI18nManualDrafts();
        drafts[i18nLocaleCode] = {
          ...(drafts[i18nLocaleCode] || {}),
          imageDataUrl: dataUrl,
          imageUrl: "",
          imageFileName: displayFileName,
        };
        const urlInput = document.getElementById(`i18n-${i18nLocaleCode}-image-url-input`);
        if (urlInput) urlInput.value = "";
        if ((window.__shareCardI18nLocaleTab || "zh-CN") === i18nLocaleCode) {
          updateShareCardPreviewDom(getActiveShareCardPreviewState());
        }
      }
      if (target === "og") {
        const state = saveShareCardOgFormState();
        state.imageDataUrl = dataUrl;
        state.imageFileName = displayFileName;
        state.imageWidth = 0;
        state.imageHeight = 0;
        state.imageMetaSource = "";
        state.imageMetaLoading = "";
        window.shareCardOgImageDataUrl = dataUrl;
        window.shareCardOgFormState = state;
        updateOgCardPreviews();
      }
      if (channelFields) {
        const state = saveShareCardOgFormState();
        state[channelFields.dataUrl] = dataUrl;
        state[channelFields.fileName] = displayFileName;
        state[channelFields.width] = width;
        state[channelFields.height] = height;
        state[channelFields.metaSource] = width && height ? dataUrl : "";
        state[channelFields.metaLoading] = "";
        window.shareCardOgFormState = state;
        updateOgCardPreviews();
      }
      if (target === "special") {
        const state = saveShareCardSpecialDraftState();
        state.imageDataUrl = dataUrl;
        state.imageFileName = displayFileName;
        window.shareCardSpecialDraftState = state;
        updateShareCardSpecialDraftPreview();
      }
      if (target === "botAvatar") {
        const state = saveShareCardSpecialDraftState();
        state.botAvatarDataUrl = dataUrl;
        state.botAvatarFileName = displayFileName;
        window.shareCardSpecialDraftState = state;
        updateShareCardSpecialDraftPreview();
      }
      if (target === "authorIcon") {
        const state = saveShareCardSpecialDraftState();
        state.authorIconDataUrl = dataUrl;
        state.authorIconFileName = displayFileName;
        window.shareCardSpecialDraftState = state;
        updateShareCardSpecialDraftPreview();
      }
      if (target === "footerIcon") {
        const state = saveShareCardSpecialDraftState();
        state.footerIconDataUrl = dataUrl;
        state.footerIconFileName = displayFileName;
        window.shareCardSpecialDraftState = state;
        updateShareCardSpecialDraftPreview();
      }
      UI.toast("图片已上传并生成预览", "success");
    };
    if (!channelFields) {
      applyUpload();
      return;
    }
    const img = new Image();
    img.onload = () => {
      const width = img.naturalWidth || img.width || 0;
      const height = img.naturalHeight || img.height || 0;
      if (shouldDoubleCheckBestImage(target, width, height)) {
        const input = document.getElementById(channelFields.fileInputId);
        if (input) input.value = "";
        showBestImageDoubleCheck(target, width, height, file.name, () => applyUpload({ width, height }));
        return;
      }
      applyUpload({ width, height });
    };
    img.onerror = () => applyUpload();
    img.src = dataUrl;
  };
  reader.readAsDataURL(file);
};

Pages.templateLibrary = function () {
  const templates = MOCK.TEMPLATES || [];
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const params = new URLSearchParams(query);
  const selectFor = params.get("selectFor");
  const selectingForLanding = selectFor === "landing";

  return `
    ${UI.pageHeader({
      title: "模版库",
      desc: "集中浏览 SDK 平台提供的全部 模版 模版。运营可从这里选择模版，带回到落地页配置或活动配置中继续个性化生成。",
      actions: `
        ${selectingForLanding ? `<button onclick="navigate('/ops/share-landing-config')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回落地页配置</button>` : ""}
        <button onclick="navigate('/ops/share-card-config')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">分享卡片配置</button>
      `,
    })}
    ${renderOpsModuleTabs("template_library")}

    <div class="grid grid-cols-4 gap-4">
      ${templates.map((t) => {
        const tid = t.temple_id || t.id;
        const selectPath = `/ops/template-library/${encodeURIComponent(tid)}/config${selectingForLanding ? "?selectFor=landing" : ""}`;
        const actionText = selectingForLanding ? "选择此模版" : "配置模版";
        const isBasicWhite = t.layout === "basic_white";
        return `
          <div class="card max-w-[360px] overflow-hidden hover:shadow-pop transition group">
            <div class="aspect-[4/3] ${isBasicWhite ? "bg-white" : "bg-ink-100"} relative flex items-center justify-center border-b border-ink-100">
              ${isBasicWhite ? `
                <div class="w-full h-full p-4 bg-white">
                  <div class="w-full h-full rounded-lg border border-dashed border-ink-200 bg-ink-50 flex items-center justify-center text-xs text-ink-400">可配置主图</div>
                </div>
              ` : `<div class="text-5xl">${t.icon}</div>`}
            </div>
            <div class="p-4 flex items-center justify-between gap-3">
              <div class="text-sm font-semibold text-ink-900 group-hover:text-brand-600 truncate">${t.name}</div>
              <button onclick="navigate('${selectPath}')" class="px-3 py-1.5 rounded-lg bg-brand-900 text-white text-xs hover:bg-brand-800 flex-shrink-0">${actionText}</button>
            </div>
          </div>
        `;
      }).join("")}
    </div>
  `;
};

Pages.landingTemplateConfig = function (templateId) {
  const t = (MOCK.TEMPLATES || []).find((item) => item.temple_id === templateId || item.id === templateId) || (MOCK.TEMPLATES || [])[0];
  const tid = t?.temple_id || t?.id || templateId;
  const generatedUrl = `https://share.easyshare.com/landing/template/${tid}`;
  window.PageHooks = window.PageHooks || {};
  window.PageHooks.mounted = () => bindBasicWhiteTemplateRealtime();
  return `
    ${UI.pageHeader({
      title: `配置模版：${t?.name || "基础白模版"}`,
      desc: "基础白模版只配置三类内容：页面图片、下载游戏按钮、回到游戏按钮。",
      actions: `
        <button onclick="navigate('/ops/template-library?selectFor=landing')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回模版库</button>
      `,
    })}

    <div class="grid grid-cols-12 gap-5 items-start">
      <aside class="col-span-12 lg:col-span-4 lg:order-2 card overflow-hidden lg:sticky lg:top-20">
        <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
          <div>
            <h3 class="text-sm font-semibold text-ink-900">实时预览</h3>
            <p class="text-xs text-ink-500 mt-0.5">9:16 竖版 H5 白模版</p>
          </div>
          <span class="badge bg-ink-100 text-ink-700">白模版</span>
        </div>
        <div class="p-6 flex justify-center bg-ink-50/70">
          <div class="w-[280px] rounded-[28px] border border-ink-200 bg-white p-3 shadow-pop">
            <div id="basic-template-preview-screen" class="aspect-[9/16] rounded-[22px] border border-ink-100 bg-white p-4 flex flex-col overflow-hidden"></div>
          </div>
        </div>
      </aside>

      <section class="col-span-12 lg:col-span-8 lg:order-1 space-y-5">
        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">1. 页面图片</h3>
              <p class="text-xs text-ink-500 mt-0.5">上传白模版顶部主视觉图片。</p>
            </div>
            <span class="badge bg-brand-50 text-brand-700">必填</span>
          </div>
          <div class="p-5 space-y-4">
            <div class="rounded-2xl border border-dashed border-ink-200 bg-ink-50/70 p-6">
              <input id="basic-template-image-input" type="file" accept="image/png,image/jpeg,image/webp" onchange="handleBasicWhiteTemplateImageFile(this.files?.[0])" class="hidden" />
              <div class="flex items-center justify-between gap-4">
                <div>
                  <div class="text-sm font-medium text-ink-900">上传主图</div>
                  <div class="text-xs text-ink-500 mt-1">建议使用竖版或主体居中的活动图，支持 PNG / JPG / WebP。</div>
                  <div id="basic-template-image-name" class="text-[11px] text-ink-400 mt-2">暂未上传图片</div>
                </div>
                <button type="button" onclick="document.getElementById('basic-template-image-input')?.click()" class="px-4 py-2 text-sm rounded-lg bg-white border border-ink-200 text-ink-700 hover:bg-ink-50">选择图片</button>
              </div>
            </div>
            <div class="rounded-2xl border border-ink-100 bg-white p-4">
              <div class="text-sm font-medium text-ink-900 mb-3">主图展示方式</div>
              <div class="grid grid-cols-2 gap-3">
                <label class="rounded-xl border border-brand-200 bg-brand-50/50 p-3 cursor-pointer">
                  <div class="flex items-center gap-2"><input type="radio" name="basic-template-image-layout" value="above" checked onchange="updateBasicWhiteTemplatePreview()" class="text-brand-600" /><span class="text-sm font-semibold text-ink-900">按钮上方</span></div>
                  <div class="mt-1 text-xs text-ink-500">图片展示在按钮区域上方，适合常规活动图。</div>
                </label>
                <label class="rounded-xl border border-ink-100 bg-ink-50/60 p-3 cursor-pointer">
                  <div class="flex items-center gap-2"><input type="radio" name="basic-template-image-layout" value="fullscreen" onchange="updateBasicWhiteTemplatePreview()" class="text-brand-600" /><span class="text-sm font-semibold text-ink-900">铺满全屏</span></div>
                  <div class="mt-1 text-xs text-ink-500">图片作为整页背景，按钮浮在底部。</div>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">2. 按钮配置</h3>
              <p class="text-xs text-ink-500 mt-0.5">默认两个按钮，也可以继续新增按钮；预览会实时同步。</p>
            </div>
            <button type="button" onclick="addBasicWhiteTemplateButton()" class="px-3 py-1.5 text-xs rounded-lg bg-brand-900 text-white hover:bg-brand-800">+ 增加按钮</button>
          </div>
          <div class="p-5">
            <div id="basic-template-button-list" class="space-y-3">
              <div class="rounded-2xl border border-brand-100 bg-brand-50/40 p-4" data-basic-template-button="true">
                <div class="flex items-center justify-between gap-2">
                  <div class="text-sm font-semibold text-brand-900">按钮 1</div>
                  <span class="badge bg-white text-brand-700 border border-brand-100">主按钮</span>
                </div>
                <div class="mt-3 grid grid-cols-2 gap-3">
                  <label class="block">
                    <span class="block text-xs font-medium text-ink-500 mb-1.5">按钮文案</span>
                    <input value="下载游戏" oninput="updateBasicWhiteTemplatePreview()" class="basic-template-button-text w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white" />
                  </label>
                  <label class="block">
                    <span class="block text-xs font-medium text-ink-500 mb-1.5">按钮链接</span>
                    <input placeholder="https://appstore.example.com/game" oninput="updateBasicWhiteTemplatePreview()" class="basic-template-button-url w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono bg-white" />
                  </label>
                </div>
              </div>
              <div class="rounded-2xl border border-ink-100 bg-white p-4" data-basic-template-button="true">
                <div class="flex items-center justify-between gap-2">
                  <div class="text-sm font-semibold text-ink-900">按钮 2</div>
                  <button type="button" onclick="removeBasicWhiteTemplateButton(this)" class="text-xs text-danger-600 hover:underline">删除</button>
                </div>
                <div class="mt-3 grid grid-cols-2 gap-3">
                  <label class="block">
                    <span class="block text-xs font-medium text-ink-500 mb-1.5">按钮文案</span>
                    <input value="回到游戏" oninput="updateBasicWhiteTemplatePreview()" class="basic-template-button-text w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
                  </label>
                  <label class="block">
                    <span class="block text-xs font-medium text-ink-500 mb-1.5">按钮链接</span>
                    <input placeholder="game://open/share" oninput="updateBasicWhiteTemplatePreview()" class="basic-template-button-url w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono" />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">3. 生成页面 URL</h3>
              <p class="text-xs text-ink-500 mt-0.5">生成后会回到创建落地页页面，并自动带入模版 URL。</p>
            </div>
            <span class="badge bg-ok-50 text-ok-700">可生成</span>
          </div>
          <div class="p-5 flex items-center justify-between gap-4">
            <div class="min-w-0">
              <div class="text-xs text-ink-500 mb-1">生成 URL</div>
              <div class="text-sm font-mono text-brand-700 truncate">${generatedUrl}</div>
            </div>
            <button onclick="navigate('/ops/share-landing-config?method=template&temple=${encodeURIComponent(tid)}')" class="px-4 py-2 text-sm rounded-lg bg-brand-900 text-white hover:bg-brand-800 flex-shrink-0">生成并使用 URL</button>
          </div>
        </div>
      </section>
    </div>
  `;
};

function bindBasicWhiteTemplateRealtime() {
  const container = document.getElementById("basic-template-image-input")?.closest("section")?.parentElement;
  if (container && container.dataset.basicTemplateBound === "1") return;
  if (container) container.dataset.basicTemplateBound = "1";
  document.getElementById("basic-template-button-list")?.addEventListener("input", updateBasicWhiteTemplatePreview);
  updateBasicWhiteTemplatePreview();
}

window.updateBasicWhiteTemplatePreview = function () {
  const screen = document.getElementById("basic-template-preview-screen");
  if (!screen) return;
  const rows = Array.from(document.querySelectorAll("[data-basic-template-button='true']"));
  const buttons = rows.map((row, idx) => {
    const text = (row.querySelector(".basic-template-button-text")?.value || `按钮 ${idx + 1}`).trim() || `按钮 ${idx + 1}`;
    const url = (row.querySelector(".basic-template-button-url")?.value || "").trim();
    return { text, url, primary: idx === 0 };
  });
  const layout = document.querySelector("input[name='basic-template-image-layout']:checked")?.value || "above";
  const imageUrl = window.__basicWhiteTemplateImageDataUrl || "";
  const placeholder = `
    <div class="w-12 h-12 rounded-2xl bg-white border border-ink-100 flex items-center justify-center text-ink-300">IMG</div>
    <div class="mt-3 text-xs font-medium text-ink-500">上传后展示页面主图</div>
  `;
  const imageHtml = imageUrl
    ? `<img src="${imageUrl}" alt="页面主图预览" class="w-full h-full object-cover" />`
    : placeholder;
  const buttonsHtml = buttons.map((button) => `
    <div title="${button.url ? `链接：${button.url}` : "未配置链接"}" class="rounded-xl ${button.primary ? "bg-brand-900 text-white shadow-soft" : "border border-ink-200 bg-white/95 text-ink-700"} px-3 py-3 text-center text-sm font-semibold truncate">${button.text}</div>
  `).join("");
  if (layout === "fullscreen") {
    screen.className = "aspect-[9/16] rounded-[22px] border border-ink-100 bg-ink-900 p-4 flex flex-col justify-end overflow-hidden relative";
    screen.innerHTML = `
      <div class="absolute inset-0 ${imageUrl ? "" : "bg-gradient-to-b from-ink-50 to-white flex flex-col items-center justify-center text-center px-4"}">${imageHtml}</div>
      <div class="relative z-10 space-y-2">${buttonsHtml}</div>
    `;
    return;
  }
  screen.className = "aspect-[9/16] rounded-[22px] border border-ink-100 bg-white p-4 flex flex-col overflow-hidden";
  screen.innerHTML = `
    <div class="flex-1 rounded-2xl border ${imageUrl ? "border-ink-100" : "border-dashed border-ink-200"} bg-gradient-to-b from-ink-50 to-white flex flex-col items-center justify-center text-center px-4 overflow-hidden">${imageHtml}</div>
    <div class="mt-4 space-y-2">${buttonsHtml}</div>
  `;
};

window.addBasicWhiteTemplateButton = function () {
  const list = document.getElementById("basic-template-button-list");
  if (!list) return;
  const count = list.querySelectorAll("[data-basic-template-button='true']").length + 1;
  list.insertAdjacentHTML("beforeend", `
    <div class="rounded-2xl border border-ink-100 bg-white p-4" data-basic-template-button="true">
      <div class="flex items-center justify-between gap-2">
        <div class="text-sm font-semibold text-ink-900">按钮 ${count}</div>
        <button type="button" onclick="removeBasicWhiteTemplateButton(this)" class="text-xs text-danger-600 hover:underline">删除</button>
      </div>
      <div class="mt-3 grid grid-cols-2 gap-3">
        <label class="block">
          <span class="block text-xs font-medium text-ink-500 mb-1.5">按钮文案</span>
          <input value="按钮 ${count}" oninput="updateBasicWhiteTemplatePreview()" class="basic-template-button-text w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
        </label>
        <label class="block">
          <span class="block text-xs font-medium text-ink-500 mb-1.5">按钮链接</span>
          <input placeholder="https://example.com/action" oninput="updateBasicWhiteTemplatePreview()" class="basic-template-button-url w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono" />
        </label>
      </div>
    </div>
  `);
  updateBasicWhiteTemplatePreview();
};

window.removeBasicWhiteTemplateButton = function (button) {
  const list = document.getElementById("basic-template-button-list");
  const rows = list ? Array.from(list.querySelectorAll("[data-basic-template-button='true']")) : [];
  if (rows.length <= 1) {
    UI.toast("至少保留一个按钮", "warning");
    return;
  }
  button?.closest("[data-basic-template-button='true']")?.remove();
  updateBasicWhiteTemplatePreview();
};

window.handleBasicWhiteTemplateImageFile = function (file) {
  if (!file) return;
  const name = document.getElementById("basic-template-image-name");
  if (name) name.textContent = file.name;
  const reader = new FileReader();
  reader.onload = () => {
    window.__basicWhiteTemplateImageDataUrl = reader.result;
    updateBasicWhiteTemplatePreview();
  };
  reader.readAsDataURL(file);
};

Pages.templateList = function () {
  const isSdkAdmin = MOCK.SESSION.currentRole === "sdk_admin";
  const templeLandingPages = (MOCK.LANDING_PAGES || []).filter((p) => p.source_type === "temple");
  const officialCount = (MOCK.TEMPLATES || []).filter((t) => t.is_official).length;
  const totalUsed = (MOCK.TEMPLATES || []).reduce((sum, t) => sum + (t.used_count || 0), 0);
  return `
    ${UI.pageHeader({
      title: "落地页模版管理",
      desc: "管理 SDK 平台预置的落地页模版页面；运营可基于模版快速生成定制落地页。",
      actions: isSdkAdmin
        ? `<button onclick="navigate('/ops/templates/create')" class="px-3 py-1.5 text-sm bg-brand-500 text-white rounded-lg hover:bg-brand-600">+ 创建落地页模版</button>`
        : `<span class="badge bg-ink-100 text-ink-700">运营仅可查看 / 调用落地页模版</span>`,
    })}
    ${renderOpsModuleTabs("card")}
    ${renderOpsWorkflowHint("card")}

    <div class="grid grid-cols-4 gap-4 mb-5">
      ${UI.statCard({ label: "落地页模版", value: MOCK.TEMPLATES.length, delta: 0, icon: "image", color: "brand" })}
      ${UI.statCard({ label: "官方模板", value: officialCount, delta: 0, icon: "shield", color: "blue" })}
      ${UI.statCard({ label: "生成落地页", value: templeLandingPages.length, delta: 0, icon: "share", color: "green" })}
      ${UI.statCard({ label: "累计调用", value: totalUsed, delta: 0, icon: "trendingUp", color: "amber" })}
    </div>

    <!-- 筛选 -->
    <div class="card p-4 mb-4 flex items-center gap-3 flex-wrap">
      <div class="flex items-center gap-2">
        <span class="text-xs text-ink-500">分类</span>
        <div class="flex gap-1">
          ${["全部", "RPG", "Casual", "Strategy", "通用", "活动"].map(
            (c, i) => `<button class="px-2.5 py-1 text-xs rounded ${i === 0 ? "bg-brand-50 text-brand-600 font-medium" : "border border-ink-100 hover:bg-ink-50"}">${c}</button>`,
          ).join("")}
        </div>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-xs text-ink-500">来源</span>
        <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
          <option>全部</option>
          <option>官方模板</option>
          <option>自建模板</option>
        </select>
      </div>
      <div class="flex-1"></div>
      <input type="text" placeholder="搜索模版名称" class="w-56 text-xs border border-ink-100 rounded-lg px-3 py-1.5" />
    </div>

    <div class="card p-4 mb-4 bg-brand-50 border-brand-100">
      <div class="flex items-start gap-3">
        <div class="w-8 h-8 rounded-lg bg-white border border-brand-100 flex items-center justify-center">${Icon.image({ size: 15, color: "#1E3A8A" })}</div>
        <div>
          <div class="text-sm font-semibold text-brand-900">落地页模版定位</div>
          <div class="text-xs text-brand-700 leading-relaxed mt-1">这里沉淀可复用的落地页预制页面；运营选择模版后，可在落地页配置中继续个性化生成落地页。</div>
        </div>
      </div>
    </div>

    <!-- 分享卡片模板 -->
    <div class="grid grid-cols-3 gap-4">
      ${MOCK.TEMPLATES.map(
        (t) => `
        <div class="card overflow-hidden hover:shadow-pop transition group">
          <div class="h-24 bg-ink-100 relative flex items-center justify-center">
            <div class="text-5xl">${t.icon}</div>
            <div class="absolute top-2 left-2 flex gap-1">
              ${t.is_official ? '<span class="badge bg-white/20 text-white backdrop-blur">官方</span>' : '<span class="badge bg-white/20 text-white backdrop-blur">自建</span>'}
              ${t.is_default ? '<span class="badge bg-emerald-500 text-white">默认</span>' : ""}
            </div>
            <div class="absolute top-2 right-2">
              <span class="badge bg-white/20 text-white backdrop-blur">${t.category}</span>
            </div>
          </div>
          <div class="p-4">
            <div class="text-sm font-semibold text-ink-900 group-hover:text-brand-500">${t.name}</div>
            <div class="text-xs text-ink-500 mt-1 line-clamp-2 h-8">${t.desc}</div>
            <div class="mt-3 pt-3 border-t border-ink-100 flex items-center justify-between text-xs">
              <span class="text-ink-500">📡 ${t.channels} 渠道 · 🌍 ${t.languages} 语言</span>
              <span class="text-ink-700"><strong>${t.used_count}</strong> 次使用</span>
            </div>
            <div class="mt-2 px-2 py-1.5 bg-ink-50 rounded text-[10px] text-ink-700 font-mono line-clamp-1">"${t.sample_title}"</div>
            <div class="mt-3 flex gap-1">
              ${isSdkAdmin
                ? `<button onclick="navigate('/ops/templates/${t.id}')" class="flex-1 px-2 py-1.5 text-xs bg-brand-50 text-brand-600 rounded hover:bg-brand-100">编辑</button>
                   <button onclick="UI.toast('已复制模板，可基于此创建新预置模板', 'success')" class="px-2 py-1.5 text-xs border border-ink-100 rounded hover:bg-ink-50">复制</button>`
                : `<button onclick="navigate('/ops/templates/${t.id}')" class="flex-1 px-2 py-1.5 text-xs border border-ink-100 rounded hover:bg-ink-50">查看</button>`}
              <button onclick="navigate('/ops/share-config/plans/create?temple=${t.temple_id || t.id}')" class="px-2 py-1.5 text-xs bg-brand-900 text-white rounded hover:bg-brand-800">调用生成 落地页</button>
            </div>
          </div>
        </div>`,
      ).join("")}

      ${isSdkAdmin ? `
      <div onclick="navigate('/ops/templates/create')" class="rounded-xl border-2 border-dashed border-ink-100 hover:border-brand-300 hover:bg-brand-50/30 transition cursor-pointer flex flex-col items-center justify-center min-h-[280px] text-ink-300 hover:text-brand-500">
        <div class="text-4xl">+</div>
        <div class="text-sm mt-2 font-medium">创建分享卡片模板</div>
        <div class="text-xs mt-1 text-ink-500">仅 SDK 管理员可创建 模版 卡片</div>
      </div>
      ` : ""}
    </div>
  `;
};

Pages.templateEdit = function (templateId) {
  const isNew = templateId === "new";
  const isSdkAdmin = MOCK.SESSION.currentRole === "sdk_admin";
  const t = isNew ? null : MOCK.TEMPLATES.find((x) => x.id === templateId) || MOCK.TEMPLATES[0];

  // 读取「来自 落地页 详情」上下文：仅当本次进入是从详情页跳来时显示回链横幅
  const fromCtx = (window.__templeEditorContext && (Date.now() - (window.__templeEditorContext.ts || 0) < 60_000))
    ? window.__templeEditorContext
    : null;
  // 一次性消费：渲染后清掉，避免下次直接进入仍显示
  if (fromCtx) window.__templeEditorContext = null;
  const fromLandingId = fromCtx?.fromLandingId || "";
  const fromLanding = fromLandingId ? (MOCK.LANDING_PAGES || []).find((p) => p.id === fromLandingId) : null;
  const fromLandingPublicId = fromLanding ? (typeof landingPageIdForLandingPage === "function" ? landingPageIdForLandingPage(fromLanding) : (fromLanding.landing_page_id || fromLanding.id)) : "";
  const backToLandingBanner = fromLanding
    ? `
      <div class="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-brand-200 bg-brand-50 px-4 py-3 text-xs">
        <div class="flex items-center gap-2 text-brand-800">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17l-5-5 5-5M4 12h16"/></svg>
          <span>当前从 落地页 <code class="font-mono px-1 rounded bg-white border border-brand-100">${fromLandingPublicId}</code>${fromLanding.name ? `（${fromLanding.name}）` : ""} 进入 模版 编辑器，下方为该落地页的来源 模版 <code class="font-mono px-1 rounded bg-white border border-brand-100">${(t?.temple_id) || templateId}</code> 的详情与参数。</span>
        </div>
        <button type="button" onclick="navigate('/ops/configured-landing-pages/${encodeURIComponent(fromLanding.id)}')" class="px-3 py-1.5 rounded-lg bg-white border border-brand-200 text-brand-700 hover:bg-brand-100 font-medium">返回 落地页 详情</button>
      </div>`
    : "";

  if (!isSdkAdmin && isNew) {
    return UI.emptyState({ icon: "🔒", title: "仅 SDK 管理员可创建预置模板", desc: "游戏运营可以查看并调用 模版，调用后生成 落地页编号 再继续调整。", action: `<button onclick="navigate('/ops/templates')" class="px-4 py-2 bg-brand-500 text-white rounded-lg text-sm">返回模板列表</button>` });
  }
  if (!isSdkAdmin) {
    return `
      ${UI.pageHeader({
        title: `查看模板：${t.name}`,
        desc: "游戏运营只能查看并调用预置 模版；调用后会生成 落地页编号，可继续调整为 活动配置编号。",
        actions: `<button onclick="navigate('/ops/share-config/plans/create?temple=${t.temple_id || t.id}')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">调用生成 落地页</button>`,
      })}
      ${backToLandingBanner}
      <div class="card p-6 max-w-3xl">
        <div class="grid grid-cols-3 gap-3 mb-5">
          <div class="rounded-lg border border-brand-200 bg-brand-50 p-3">
            <div class="text-[11px] font-semibold text-brand-700">模版编号</div>
            <div class="mt-1 font-mono text-xs text-ink-900">${t.temple_id || t.id}</div>
          </div>
          <div class="rounded-lg border border-ink-200 bg-ink-50 p-3">
            <div class="text-[11px] font-semibold text-ink-500">权限</div>
            <div class="mt-1 text-xs text-ink-900">只读 / 可调用</div>
          </div>
          <div class="rounded-lg border border-ink-200 bg-ink-50 p-3">
            <div class="text-[11px] font-semibold text-ink-500">调用结果</div>
            <div class="mt-1 text-xs text-ink-900">生成 落地页编号</div>
          </div>
        </div>
        <div class="text-4xl mb-3">${t.icon}</div>
        <h3 class="text-base font-semibold text-ink-900">${t.name}</h3>
        <p class="text-sm text-ink-500 leading-relaxed mt-2">${t.desc}</p>
        <div class="mt-4 px-3 py-2 bg-ink-50 rounded-lg text-xs text-ink-700 font-mono">${t.sample_title}</div>
      </div>
    `;
  }

  return `
    ${UI.pageHeader({
      title: isNew ? "创建新模板" : `编辑模板：${t.name}`,
      desc: "模板包含分享文案 / 多语言 / 渠道默认值 / UTM 等可复用配置",
      actions: `
        <button onclick="navigate('/ops/templates')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回列表</button>
        <button onclick="confirmAction('保存模板', '确定要保存当前模板配置吗？保存后可被游戏运营用于生成包体运营中的配置历史。', '确认保存', '模板已保存', '/ops/templates')" class="px-3 py-1.5 text-sm bg-brand-500 text-white rounded-lg hover:bg-brand-600">保存模板</button>
      `,
    })}
    ${backToLandingBanner}

    <div class="grid grid-cols-3 gap-4">
      <!-- 基本信息 -->
      <div class="col-span-2 space-y-4">
        <div class="card p-5">
          <h3 class="text-sm font-semibold text-ink-900 mb-4">基本信息</h3>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="text-xs text-ink-500">模版编号</label>
              <input type="text" value="${t?.temple_id || "temple_new"}" class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm font-mono bg-ink-50" readonly />
            </div>
            <div>
              <label class="text-xs text-ink-500">模板名称</label>
              <input type="text" value="${t?.name || ""}" class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm" placeholder="如：RPG 召唤伙伴模板" />
            </div>
            <div>
              <label class="text-xs text-ink-500">分类</label>
              <select class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm bg-white">
                <option>RPG</option>
                <option>Casual</option>
                <option>Strategy</option>
                <option>通用</option>
                <option>活动</option>
              </select>
            </div>
            <div class="col-span-2">
              <label class="text-xs text-ink-500">模板描述</label>
              <textarea rows="2" class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm">${t?.desc || ""}</textarea>
            </div>
            <div>
              <label class="text-xs text-ink-500">图标</label>
              <input type="text" value="${t?.icon || "🎮"}" class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm" />
            </div>
            <div class="flex items-center gap-3 pt-5">
              <label class="flex items-center gap-1.5 text-sm cursor-pointer">
                <input type="checkbox" ${t?.is_default ? "checked" : ""} class="w-4 h-4 rounded text-brand-500" />
                设为默认模板
              </label>
              <label class="flex items-center gap-1.5 text-sm cursor-pointer">
                <input type="checkbox" ${t?.is_official ? "checked" : ""} class="w-4 h-4 rounded text-brand-500" />
                官方推荐
              </label>
            </div>
          </div>
        </div>

        <!-- 多语言文案 -->
        <div class="card p-5">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-sm font-semibold text-ink-900">多语言文案</h3>
            <button class="text-xs text-brand-500 hover:underline">+ 添加语言</button>
          </div>
          <div class="space-y-3">
            ${[
              { code: "en", flag: "🇺🇸", label: "English (默认)", title: t?.sample_title || "Join me!", desc: "Download now and play together!" },
              { code: "zh-CN", flag: "🇨🇳", label: "简体中文", title: "快来和我一起战斗！", desc: "立即下载领取免费宝石！" },
              { code: "ja", flag: "🇯🇵", label: "日本語", title: "一緒にプレイしよう！", desc: "今すぐダウンロード！" },
            ].map((l) => `
              <details class="border border-ink-100 rounded-lg" open>
                <summary class="px-4 py-2.5 cursor-pointer flex items-center gap-2">
                  <svg class="chev w-3 h-3 text-ink-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
                  <span class="text-base">${l.flag}</span>
                  <span class="text-sm font-medium">${l.label}</span>
                  <span class="ml-auto text-[10px] text-ink-500 font-mono">${l.code}</span>
                </summary>
                <div class="px-4 pb-3 space-y-2 border-t border-ink-100 pt-3">
                  <div>
                    <label class="text-xs text-ink-500">标题 (title)</label>
                    <input type="text" value="${l.title}" class="w-full mt-1 px-3 py-1.5 border border-ink-100 rounded text-sm" />
                  </div>
                  <div>
                    <label class="text-xs text-ink-500">描述 (description)</label>
                    <textarea rows="2" class="w-full mt-1 px-3 py-1.5 border border-ink-100 rounded text-sm">${l.desc}</textarea>
                  </div>
                </div>
              </details>
            `).join("")}
          </div>
        </div>

        <!-- 渠道默认值 -->
        <div class="card p-5">
          <h3 class="text-sm font-semibold text-ink-900 mb-3">默认启用渠道与 UTM</h3>
          <p class="text-xs text-ink-500 mb-3">应用此模板时，这些渠道与默认 UTM 参数将自动填入；运营可在生成的 落地页 / 活动配置编号 中继续调整</p>
          <div class="space-y-2">
            ${MOCK.CHANNELS.filter((c) => c.enabled).slice(0, 6).map((c) => `
              <div class="flex items-center gap-3 p-2.5 border border-ink-100 rounded-lg">
                <input type="checkbox" checked class="w-4 h-4 rounded text-brand-500" />
                <span class="text-base">${c.icon}</span>
                <span class="text-sm font-medium w-24">${c.name}</span>
                <div class="flex-1 grid grid-cols-3 gap-2">
                  <input type="text" value="${c.code}" placeholder="utm_source" class="px-2 py-1 border border-ink-100 rounded text-xs font-mono" />
                  <input type="text" value="social" placeholder="utm_medium" class="px-2 py-1 border border-ink-100 rounded text-xs font-mono" />
                  <input type="text" value="\${campaign}" placeholder="utm_campaign" class="px-2 py-1 border border-ink-100 rounded text-xs font-mono" />
                </div>
              </div>
            `).join("")}
          </div>
        </div>
      </div>

      <!-- 实时预览 -->
      <div class="space-y-4">
        <div class="card p-5 sticky top-2">
          <h3 class="text-sm font-semibold text-ink-900 mb-3">📱 实时预览</h3>
          <div class="space-y-3">
            <div class="border border-ink-100 rounded-lg overflow-hidden">
              <div class="bg-ink-50 px-3 py-1.5 text-xs flex items-center gap-1.5"><span>📘</span> Facebook OG</div>
              <div class="p-3">
                <div class="bg-ink-100 h-32 rounded flex items-center justify-center text-4xl">${t?.icon || "🎮"}</div>
                <div class="text-[10px] text-ink-300 mt-2 uppercase">share.kqst.io</div>
                <div class="text-sm font-semibold mt-0.5">${t?.sample_title || "Join me!"}</div>
                <div class="text-xs text-ink-500 mt-0.5">Download now and play together!</div>
              </div>
            </div>
            <div class="border border-ink-100 rounded-lg overflow-hidden">
              <div class="bg-ink-50 px-3 py-1.5 text-xs flex items-center gap-1.5"><span>𝕏</span> Twitter Card</div>
              <div class="p-3">
                <div class="bg-ink-100 h-20 rounded-lg flex items-center justify-center text-3xl">${t?.icon || "🎮"}</div>
                <div class="mt-2 text-xs font-semibold">${t?.sample_title || "Join me!"}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
;(window as any).bindBasicWhiteTemplateRealtime = bindBasicWhiteTemplateRealtime;
;(window as any).escapeCsvCell = escapeCsvCell;
;(window as any).escapeShareCardValue = escapeShareCardValue;
;(window as any).formatWhatsAppImageSize = formatWhatsAppImageSize;
;(window as any).getActiveShareCardI18nLocale = getActiveShareCardI18nLocale;
;(window as any).getActiveShareCardPreviewState = getActiveShareCardPreviewState;
;(window as any).getDiscordRuntimePreviewMeta = getDiscordRuntimePreviewMeta;
;(window as any).getImageSourceByFields = getImageSourceByFields;
;(window as any).getImportedShareCardI18nRows = getImportedShareCardI18nRows;
;(window as any).getOgImageRatioTip = getOgImageRatioTip;
;(window as any).getOgPreviewRiskNotes = getOgPreviewRiskNotes;
;(window as any).getPendingShareCardI18nLocales = getPendingShareCardI18nLocales;
;(window as any).getPreviewStateWithChannelImage = getPreviewStateWithChannelImage;
;(window as any).getSelectedShareCardI18nLocales = getSelectedShareCardI18nLocales;
;(window as any).getShareCardBestImageSpec = getShareCardBestImageSpec;
;(window as any).getShareCardChannelImageFields = getShareCardChannelImageFields;
;(window as any).getShareCardDefaultLanguage = getShareCardDefaultLanguage;
;(window as any).getShareCardDefaultLanguageCode = getShareCardDefaultLanguageCode;
;(window as any).getShareCardI18nFieldLabels = getShareCardI18nFieldLabels;
;(window as any).getShareCardI18nLocalesForInput = getShareCardI18nLocalesForInput;
;(window as any).getShareCardI18nManualDrafts = getShareCardI18nManualDrafts;
;(window as any).getShareCardLocaleDraft = getShareCardLocaleDraft;
;(window as any).getShareCardLocaleStatusMeta = getShareCardLocaleStatusMeta;
;(window as any).getShareCardOgFormState = getShareCardOgFormState;
;(window as any).getShareCardPostChannelNames = getShareCardPostChannelNames;
;(window as any).getShareCardPostFormState = getShareCardPostFormState;
;(window as any).getShareCardPostPreviewValues = getShareCardPostPreviewValues;
;(window as any).getShareCardPostSpecs = getShareCardPostSpecs;
;(window as any).getShareCardPreviewImageHtml = getShareCardPreviewImageHtml;
;(window as any).getShareCardPreviewStateForLocale = getShareCardPreviewStateForLocale;
;(window as any).getShareCardSpecialConfigs = getShareCardSpecialConfigs;
;(window as any).getShareCardSpecialDraftState = getShareCardSpecialDraftState;
;(window as any).getShareCardSpecialStyles = getShareCardSpecialStyles;
;(window as any).getShareCardStyles = getShareCardStyles;
;(window as any).getShareLanguageCatalog = getShareLanguageCatalog;
;(window as any).getShareLanguageChineseName = getShareLanguageChineseName;
;(window as any).getShareLanguageNativeName = getShareLanguageNativeName;
;(window as any).getShareLanguageSelectedCodes = getShareLanguageSelectedCodes;
;(window as any).getSpecialPreviewValues = getSpecialPreviewValues;
;(window as any).getWhatsAppImageVariant = getWhatsAppImageVariant;
;(window as any).getWhatsAppPreviewValues = getWhatsAppPreviewValues;
;(window as any).isNearAspectRatio = isNearAspectRatio;
;(window as any).maybeWarnOgImageRatio = maybeWarnOgImageRatio;
;(window as any).parseDiscordRows = parseDiscordRows;
;(window as any).parseDiscordTags = parseDiscordTags;
;(window as any).parseSimpleCsv = parseSimpleCsv;
;(window as any).renderChannelImageOverrideControls = renderChannelImageOverrideControls;
;(window as any).renderDiscordDevicePreview = renderDiscordDevicePreview;
;(window as any).renderDiscordDevicePreviewShell = renderDiscordDevicePreviewShell;
;(window as any).renderDiscordRichEmbedPreview = renderDiscordRichEmbedPreview;
;(window as any).renderFieldHelp = renderFieldHelp;
;(window as any).renderOgChannelPreview = renderOgChannelPreview;
;(window as any).renderOgImageRatioTip = renderOgImageRatioTip;
;(window as any).renderOgPostPreview = renderOgPostPreview;
;(window as any).renderOgPreviewRiskHint = renderOgPreviewRiskHint;
;(window as any).renderPostFieldBadges = renderPostFieldBadges;
;(window as any).renderPostFieldGuide = renderPostFieldGuide;
;(window as any).renderRuntimeGeneratedField = renderRuntimeGeneratedField;
;(window as any).renderShareCardBestStep = renderShareCardBestStep;
;(window as any).renderShareCardI18nConfig = renderShareCardI18nConfig;
;(window as any).renderShareCardI18nImportedPreview = renderShareCardI18nImportedPreview;
;(window as any).renderShareCardLocaleInputArea = renderShareCardLocaleInputArea;
;(window as any).renderShareCardLocaleTabs = renderShareCardLocaleTabs;
;(window as any).renderShareCardOgStep = renderShareCardOgStep;
;(window as any).renderShareCardPostStep = renderShareCardPostStep;
;(window as any).renderShareCardSpecialStep = renderShareCardSpecialStep;
;(window as any).renderShareCardUnifiedConfig = renderShareCardUnifiedConfig;
;(window as any).renderShareCardWorkflowSteps = renderShareCardWorkflowSteps;
;(window as any).renderSpecialCardPreview = renderSpecialCardPreview;
;(window as any).renderWhatsAppImageTag = renderWhatsAppImageTag;
;(window as any).renderWhatsAppPreview = renderWhatsAppPreview;
;(window as any).renderWhatsAppReferenceHover = renderWhatsAppReferenceHover;
;(window as any).renderWhatsAppReferenceImage = renderWhatsAppReferenceImage;
;(window as any).renderWhatsAppRichPreviewShell = renderWhatsAppRichPreviewShell;
;(window as any).renderWhatsAppTextBlock = renderWhatsAppTextBlock;
;(window as any).saveShareCardActiveI18nDraft = saveShareCardActiveI18nDraft;
;(window as any).saveShareCardI18nDraft = saveShareCardI18nDraft;
;(window as any).saveShareCardOgFormState = saveShareCardOgFormState;
;(window as any).saveShareCardPostFormState = saveShareCardPostFormState;
;(window as any).saveShareCardSpecialDraftState = saveShareCardSpecialDraftState;
;(window as any).shouldDoubleCheckBestImage = shouldDoubleCheckBestImage;
;(window as any).showBestImageDoubleCheck = showBestImageDoubleCheck;
;(window as any).stripDiscordRuntimeOnlyFields = stripDiscordRuntimeOnlyFields;
;(window as any).syncChannelImageDimensions = syncChannelImageDimensions;
;(window as any).syncImageDimensionsForFields = syncImageDimensionsForFields;
;(window as any).syncOgImageDimensions = syncOgImageDimensions;
;(window as any).truncateShareCardText = truncateShareCardText;
;(window as any).updateDiscordDevicePreviews = updateDiscordDevicePreviews;
;(window as any).updateOgImageRatioTip = updateOgImageRatioTip;
;(window as any).updateShareCardPreviewDom = updateShareCardPreviewDom;
